/**
 * Données de mock pour les widgets
 * Basé sur la structure réelle de l'API Apidae
 */

import { FacetId, FacetValue, ObjetTouristique } from "./types/apidae.d";
import {
  WidgetConfiguration,
  WidgetTemplateType,
  WidgetLanguage,
  WidgetFont,
  WidgetSortOption,
  FilterId,
  DisplayedFieldPreviewId,
  DisplayedFieldId,
} from "./types/widgets.d";

export const MOCK_OBJETS_TOURISTIQUES: ObjetTouristique[] = [
  {
    type: "HEBERGEMENT_LOCATIF",
    id: 176389,
    nom: {
      libelleFr: "Les Hauts de Fontmora",
    },
    identifier: "sitraHLO633629",
    presentation: {
      descriptifCourt: {
        libelleFr:
          "En pleine nature, dans le Massif du Pilat, et aussi à 10 min de St-Etienne, ce gîte indépendant a été restauré dans une ancienne grange du 19° siècle en schistes.",
      },
    },
    informationsHebergementLocatif: {
      hebergementLocatifType: {
        elementReferenceType: "HebergementLocatifType",
        id: 2619,
        libelleFr: "Chambre d'hôtes",
        ordre: 4,
        description:
          "Définition Atout France - Selon le code du tourisme, les chambres d'hôtes sont des chambres meublées situées chez l'habitant en vue d'accueillir des touristes, à titre onéreux, pour une ou plusieurs nuitées, assorties de prestations. L'activité de location de chambres d'hôtes correspond à la fourniture groupée de la nuitée et du petit déjeuner.\r\nCette activité est limitée à un plafond de cinq chambres pour une capacité maximale d'accueil de quinze personnes. L'accueil doit être assuré par l'habitant. Chaque chambre d'hôte doit donner accès à une salle d'eau et à un WC. Elle doit être en conformité avec les réglementations en vigueur dans les domaines de l'hygiène, de la sécurité et de la salubrité. La location doit être assortie, au minimum, de la fourniture du linge de maison.\r\nLa location de chambres d'hôtes peut éventuellement être complétée par la prestation de tables d'hôtes. Cette seconde prestation n'est pas définie sur le plan réglementaire.",
      },
    },
    capacites: {
      classees: { personnes: 6, unitesHebergement: 1 },
      hebergementLocatif: {
        nombreChambres: 3,
        nombreCabines: 0,
        nombreLitsDoubles: 2,
        nombreLitsSimples: 2,
        surface: 95,
        nombreSallesDeBain: 2,
      },
    },
    localisation: {
      adresse: {
        adresse1: "493 chemin de Fontmora",
        adresse2: "Fontmora",
        codePostal: "42100",
        commune: {
          id: 16601,
          code: "42218",
          nom: "Rochetaillée",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
            ordre: 78,
          },
          codePostal: "42100",
        },
      },
      geolocalisation: {
        altitude: 1000,
        valide: true,
        geoJson: {
          type: "Point",
          coordinates: [4.45768, 45.396706],
        },
      },
    },
    illustrations: [
      {
        identifiant: 31532976,
        link: false,
        type: "IMAGE",
        nom: {},
        legende: {},
        copyright: {
          libelleFr: "Gîtes de France",
        },
        traductionFichiers: [
          {
            locale: "fr",
            url: "http://static.apidae-tourisme.com/filestore/objets-touristiques/images/125/205/32755069.jpg",
            urlListe:
              "https://plus.unsplash.com/premium_photo-1745946640178-69beac3840cc?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", //"http://static.apidae-tourisme.com/filestore/objets-touristiques/images/125/205/32755069-liste.jpg",
            urlFiche:
              "http://static.apidae-tourisme.com/filestore/objets-touristiques/images/125/205/32755069-fiche.jpg",
            urlDiaporama:
              "https://plus.unsplash.com/premium_photo-1745946640178-69beac3840cc?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // "http://static.apidae-tourisme.com/filestore/objets-touristiques/images/125/205/32755069-diaporama.jpg",
            extension: "jpg",
            fileName: "32755069",
            taille: 446828,
            hauteur: 1080,
            largeur: 1710,
            lastModifiedDate: "2025-07-14T03:12:08.945+0000",
            checksum:
              "74d99f58d1e4789969f8e4a5d71b09f9b74bcd56adceb402ab48c5c6f24198df",
          },
        ],
        locked: true,
        source: "Gîtes de France",
      },
      {
        identifiant: 31532977,
        link: false,
        type: "DOCUMENT",
        nom: {
          libelleFr: "Les Hauts de Fontmora - Brochure",
        },
        legende: {
          libelleFr: "Documentation complète de l'établissement",
        },
        copyright: {},
        traductionFichiers: [
          {
            locale: "fr",
            url: "https://example.com/documents/brochure-fontmora.pdf",
            urlListe: "https://example.com/documents/brochure-fontmora.pdf",
            urlFiche: "https://example.com/documents/brochure-fontmora.pdf",
            urlDiaporama: "https://example.com/documents/brochure-fontmora.pdf",
            extension: "pdf",
            fileName: "brochure-fontmora",
            taille: 1024000,
            hauteur: 0,
            largeur: 0,
            lastModifiedDate: "2025-01-15T10:00:00.000+0000",
            checksum: "abc123",
          },
        ],
        locked: false,
      },
      {
        identifiant: 31532978,
        link: false,
        type: "VIDEO",
        nom: {
          libelleFr: "Vue aérienne de l'établissement",
        },
        legende: {
          libelleFr: "Etablissement vu de drône",
        },
        copyright: {},
        traductionFichiers: [
          {
            locale: "fr",
            url: "https://example.com/videos/drone-fontmora.mp4",
            urlListe: "https://example.com/videos/drone-fontmora.mp4",
            urlFiche: "https://example.com/videos/drone-fontmora.mp4",
            urlDiaporama: "https://example.com/videos/drone-fontmora.mp4",
            extension: "mp4",
            fileName: "drone-fontmora",
            taille: 5120000,
            hauteur: 1080,
            largeur: 1920,
            lastModifiedDate: "2025-01-20T14:30:00.000+0000",
            checksum: "def456",
          },
        ],
        locked: false,
      },
      {
        identifiant: 31532979,
        link: false,
        type: "GPX",
        nom: {
          libelleFr: "Itinéraire de randonnée",
        },
        legende: {
          libelleFr: "Fichier GPX du circuit",
        },
        copyright: {},
        traductionFichiers: [
          {
            locale: "fr",
            url: "https://example.com/gpx/circuit-fontmora.gpx",
            urlListe: "https://example.com/gpx/circuit-fontmora.gpx",
            urlFiche: "https://example.com/gpx/circuit-fontmora.gpx",
            urlDiaporama: "https://example.com/gpx/circuit-fontmora.gpx",
            extension: "gpx",
            fileName: "circuit-fontmora",
            taille: 256000,
            hauteur: 0,
            largeur: 0,
            lastModifiedDate: "2025-01-10T09:00:00.000+0000",
            checksum: "ghi789",
          },
        ],
        locked: false,
      },
    ],
    informations: {
      moyensCommunication: [
        {
          identifiant: 32910490,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 201,
            libelleFr: "Téléphone",
            ordre: 1,
          },
          coordonnees: {
            fr: "04 77 79 18 49",
          },
        },
        {
          identifiant: 26428061,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 205,
            libelleFr: "Site web (URL)",
            ordre: 3,
          },
          coordonnees: {
            fr: "https://www.gites-de-france-loire.com/fiche-hebergement-4026.html",
          },
        },
      ],
    },
    ouverture: {
      periodesOuvertures: [
        {
          identifiant: 1,
          dateDebut: "2025-01-01",
          dateFin: "2025-12-31",
          complementHoraire: {
            libelleFr: "Toute l'année",
          },
          tousLesAns: true,
        },
      ],
      ouvertTouteLAnnee: "OUVERT_TOUTE_L_ANNEE",
    },
    descriptionTarif: {
      indicationTarif: "PAYANT",
      gratuit: false,
      tarifsEnClair: {
        libelleFr:
          "De 89€ à 127€ par nuit selon la saison. Petit déjeuner inclus.",
      },
      tarifsEnClairGenerationMode: "MANUEL",
      modesPaiement: [
        {
          elementReferenceType: "ModePaiement",
          id: 1268,
          libelleFr: "Carte bancaire/crédit",
          ordre: 5,
        },
        {
          elementReferenceType: "ModePaiement",
          id: 1271,
          libelleFr: "Chèque",
          ordre: 11,
        },
        {
          elementReferenceType: "ModePaiement",
          id: 1277,
          libelleFr: "Espèces",
          ordre: 28,
        },
      ],
      devise: "EUR",
      conditions: {},
    },
    prestations: {
      equipements: [
        {
          elementReferenceType: "PrestationEquipement",
          id: 972,
          libelleFr: "Parking",
          ordre: 221,
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 741,
          libelleFr: "Toilettes",
          ordre: 158,
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1106,
          libelleFr: "Restaurant",
          ordre: 151,
        },
      ],
      animauxAcceptes: "ACCEPTES",
      animauxAcceptesSupplement:
        "Seulement les petits chiens et autres animaux de compagnie de petite taille.",
      tourismesAdaptes: [
        {
          elementReferenceType: "TourismeAdapte",
          id: 3653,
          libelleFr: "Accessible en fauteuil roulant en autonomie",
          ordre: 1,
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3667,
          libelleFr: "WC + barre d'appui + espace de circulation",
          ordre: 40,
        },
      ],
      surchargeTourismesAdaptes: true,
    },
    donneesPrivees: [
      {
        nomTechnique: "1157_Vg_testDescriptifPrive-1",
        libelleFr: "VG_Test Descriptif privé-1",
        ordre: 1,
        descriptif: {
          libelleFr: "Test descriptif privé 1",
        },
      },
      {
        nomTechnique: "team_apidae_adresse",
        libelleFr: "Les bonnes adresses by la team Apidae",
        ordre: 2,
        descriptif: {
          libelleFr:
            "Adresse de très bonne qualité, on se régale ici, aussi bien pour les grands et les petits !",
        },
      },
      {
        nomTechnique: "1157_TestDescriptifPrive",
        libelleFr: "test  descriptif privé Gers",
        ordre: 3,
        descriptif: {
          libelleFr: "Les gers c'est le canard avant tout.",
        },
      },
    ],
    metadonnees: [
      {
        noeudId: "open-system",
        contenus: [
          {
            cible: "general",
            metadonnee: {
              widget: {
                v: "1.0",
                uis: [{ ui: "CA-ITEAG-72602-1874", metier: "hebergement" }],
                integration: { id: 1023, idPanier: "kbuTkZE" }, // noyau-1.0.min.js plante sur récupération de k.panier.domaine.fr, car pas de domaine
              },
            },
          },
        ],
      },
    ],
  },
  /** Mock dégustation avec ouvertures et fermetures exceptionnelles (dateFermeture + dateSpeciale). */
  {
    type: "DEGUSTATION",
    id: 4864350,
    nom: {
      libelleFr: "Caveau de dégustation – test fermetures exceptionnelles",
    },
    identifier: "sitraDEG-fermetures-test",
    presentation: { descriptifCourt: { libelleFr: "" } },
    ouverture: {
      periodeEnClair: {
        libelleFr:
          "06/03/2026.\n\n08/03/2026 de 8h à 18h.\n\n09/03/2026 à partir de 8h.\n\n10/03/2026 jusqu'à 19h.\n\n11/03/2026 fermé .\n\nDu 23/03 au 26/03/2026 le lundi et jeudi. Le mardi et mercredi de 8h à 12h.\nFermeture exceptionnelle le 24/03.\n\nDu 02/04 au 16/04/2026 le lundi, mardi et les week-ends de 8h à 18h. Le vendredi. Fermé le jeudi.\nFermetures exceptionnelles les jours fériés.\n\nDu 27/04 au 31/10/2026 du lundi au vendredi de 10h à 18h.\nFermetures exceptionnelles les 29/06, 11/07 et jours fériés.",
      },
      periodeEnClairGenerationMode: "AUTOMATIQUE",
      indicationsPeriode: [
        {
          elementReferenceType: "IndicationPeriode",
          id: 416,
          libelleFr: "Automne",
          ordre: 4,
          description:
            "Permet de trouver des objets en fonction de la saison automnale - 21 septembre au 20 décembre",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 114,
            libelleFr: "Période",
            ordre: 116,
          },
        },
        {
          elementReferenceType: "IndicationPeriode",
          id: 418,
          libelleFr: "Eté",
          ordre: 3,
          description:
            "Permet de trouver des objets en fonction de la saison estivale - 21 juin au 20 septembre",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 114,
            libelleFr: "Période",
            ordre: 116,
          },
        },
        {
          elementReferenceType: "IndicationPeriode",
          id: 435,
          libelleFr: "Hiver",
          ordre: 5,
          description:
            "Permet de trouver des objets en fonction de la saison hivernale - 21 décembre au 20 mars",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 114,
            libelleFr: "Période",
            ordre: 116,
          },
        },
        {
          elementReferenceType: "IndicationPeriode",
          id: 436,
          libelleFr: "Printemps",
          ordre: 2,
          description:
            "Permet de trouver des objets en fonction de la saison printanière - 21 mars au 20 juin",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 114,
            libelleFr: "Période",
            ordre: 116,
          },
        },
      ],
      periodesOuvertures: [
        {
          identifiant: 37959429,
          dateDebut: "2026-03-06",
          dateFin: "2026-03-06",
          type: "OUVERTURE_TOUS_LES_JOURS",
          tousLesAns: false,
          identifiantTechnique: 37959459,
          horaires: [
            {
              id: 2636810,
              type: {
                elementReferenceType: "HoraireType",
                id: 7487,
                libelleFr: "Ouverture",
                ordre: 1,
                description: "Horaires d'ouverture",
                externalType: "opening",
                startTimeVisibility: true,
                endTimeVisibility: true,
                recurrenceVisibility: false,
              },
              timePeriods: [{ id: 2835958, closed: false, weekdays: ["FRI"] }],
            },
          ],
        },
        {
          identifiant: 37959431,
          dateDebut: "2026-03-08",
          dateFin: "2026-03-08",
          type: "OUVERTURE_TOUS_LES_JOURS",
          tousLesAns: false,
          identifiantTechnique: 37959460,
          horaires: [
            {
              id: 2636811,
              type: {
                elementReferenceType: "HoraireType",
                id: 7487,
                libelleFr: "Ouverture",
                ordre: 1,
                description: "Horaires d'ouverture",
                externalType: "opening",
                startTimeVisibility: true,
                endTimeVisibility: true,
                recurrenceVisibility: false,
              },
              timePeriods: [
                {
                  id: 2835959,
                  closed: false,
                  weekdays: ["SUN"],
                  timeFrames: [
                    { id: 2909348, startTime: "08:00", endTime: "18:00" },
                  ],
                },
              ],
            },
          ],
        },
        {
          identifiant: 37959432,
          dateDebut: "2026-03-09",
          dateFin: "2026-03-09",
          type: "OUVERTURE_TOUS_LES_JOURS",
          tousLesAns: false,
          identifiantTechnique: 37959461,
          horaires: [
            {
              id: 2636812,
              type: {
                elementReferenceType: "HoraireType",
                id: 7487,
                libelleFr: "Ouverture",
                ordre: 1,
                description: "Horaires d'ouverture",
                externalType: "opening",
                startTimeVisibility: true,
                endTimeVisibility: true,
                recurrenceVisibility: false,
              },
              timePeriods: [
                {
                  id: 2835960,
                  closed: false,
                  weekdays: ["MON"],
                  timeFrames: [{ id: 2909349, startTime: "08:00" }],
                },
              ],
            },
          ],
        },
        {
          identifiant: 37959433,
          dateDebut: "2026-03-10",
          dateFin: "2026-03-10",
          type: "OUVERTURE_TOUS_LES_JOURS",
          tousLesAns: false,
          identifiantTechnique: 37959462,
          horaires: [
            {
              id: 2636813,
              type: {
                elementReferenceType: "HoraireType",
                id: 7487,
                libelleFr: "Ouverture",
                ordre: 1,
                description: "Horaires d'ouverture",
                externalType: "opening",
                startTimeVisibility: true,
                endTimeVisibility: true,
                recurrenceVisibility: false,
              },
              timePeriods: [
                {
                  id: 2835961,
                  closed: false,
                  weekdays: ["TUE"],
                  timeFrames: [{ id: 2909350, endTime: "19:00" }],
                },
              ],
            },
          ],
        },
        {
          identifiant: 37959434,
          dateDebut: "2026-03-11",
          dateFin: "2026-03-11",
          type: "OUVERTURE_TOUS_LES_JOURS",
          tousLesAns: false,
          identifiantTechnique: 37959463,
          horaires: [
            {
              id: 2636814,
              type: {
                elementReferenceType: "HoraireType",
                id: 7487,
                libelleFr: "Ouverture",
                ordre: 1,
                description: "Horaires d'ouverture",
                externalType: "opening",
                startTimeVisibility: true,
                endTimeVisibility: true,
                recurrenceVisibility: false,
              },
              timePeriods: [{ id: 2835962, closed: true, weekdays: ["WED"] }],
            },
          ],
        },
        {
          identifiant: 37959441,
          dateDebut: "2026-03-23",
          dateFin: "2026-03-26",
          type: "OUVERTURE_TOUS_LES_JOURS",
          tousLesAns: false,
          identifiantTechnique: 37959464,
          horaires: [
            {
              id: 2636815,
              type: {
                elementReferenceType: "HoraireType",
                id: 7487,
                libelleFr: "Ouverture",
                ordre: 1,
                description: "Horaires d'ouverture",
                externalType: "opening",
                startTimeVisibility: true,
                endTimeVisibility: true,
                recurrenceVisibility: false,
              },
              timePeriods: [
                { id: 2835963, closed: false, weekdays: ["MON", "THU"] },
                {
                  id: 2835964,
                  closed: false,
                  weekdays: ["WED", "TUE"],
                  timeFrames: [
                    { id: 2909351, startTime: "08:00", endTime: "12:00" },
                  ],
                },
              ],
            },
          ],
        },
        {
          identifiant: 37959449,
          dateDebut: "2026-04-02",
          dateFin: "2026-04-16",
          type: "OUVERTURE_SAUF",
          tousLesAns: false,
          ouverturesJournalieres: [{ jour: "MERCREDI" }, { jour: "JEUDI" }],
          identifiantTechnique: 37959465,
          horaires: [
            {
              id: 2636816,
              type: {
                elementReferenceType: "HoraireType",
                id: 7487,
                libelleFr: "Ouverture",
                ordre: 1,
                description: "Horaires d'ouverture",
                externalType: "opening",
                startTimeVisibility: true,
                endTimeVisibility: true,
                recurrenceVisibility: false,
              },
              timePeriods: [
                {
                  id: 2835965,
                  closed: false,
                  weekdays: ["TUE", "MON", "SAT", "SUN"],
                  timeFrames: [
                    { id: 2909352, startTime: "08:00", endTime: "18:00" },
                  ],
                },
                { id: 2835966, closed: true, weekdays: ["THU"] },
                { id: 2835967, closed: false, weekdays: ["FRI"] },
              ],
            },
          ],
        },
        {
          identifiant: 37959458,
          dateDebut: "2026-04-27",
          dateFin: "2026-10-31",
          type: "OUVERTURE_SAUF",
          tousLesAns: false,
          ouverturesJournalieres: [{ jour: "SAMEDI" }, { jour: "DIMANCHE" }],
          identifiantTechnique: 37959466,
          horaires: [
            {
              id: 2636817,
              type: {
                elementReferenceType: "HoraireType",
                id: 7487,
                libelleFr: "Ouverture",
                ordre: 1,
                description: "Horaires d'ouverture",
                externalType: "opening",
                startTimeVisibility: true,
                endTimeVisibility: true,
                recurrenceVisibility: false,
              },
              timePeriods: [
                {
                  id: 2835968,
                  closed: false,
                  weekdays: ["WED", "TUE", "MON", "FRI", "THU"],
                  timeFrames: [
                    { id: 2909353, startTime: "10:00", endTime: "18:00" },
                  ],
                },
              ],
            },
          ],
        },
      ],
      fermeturesExceptionnelles: [
        { dateSpeciale: "PREMIER_JANVIER" },
        { dateSpeciale: "FETE_CITOYENNETE", dates: ["2026-09-24"] },
        { dateSpeciale: "VENDREDI_SAINT", dates: ["2026-04-03"] },
        { dateSpeciale: "LUNDI_PAQUES", dates: ["2026-04-06"] },
        { dateSpeciale: "ASCENSION", dates: ["2026-05-14"] },
        { dateSpeciale: "LUNDI_PENTECOTE", dates: ["2026-05-25"] },
        { dateSpeciale: "PREMIER_MAI", dates: ["2026-05-01"] },
        { dateSpeciale: "HUIT_MAI", dates: ["2026-05-08"] },
        { dateSpeciale: "FETE_AUTONOMIE", dates: ["2026-06-29"] },
        { dateSpeciale: "QUATORZE_JUILLET", dates: ["2026-07-14"] },
        { dateSpeciale: "FETE_DIEU", dates: ["2026-06-04"] },
        { dateSpeciale: "FETE_NATIONALE_SUISSE", dates: ["2026-08-01"] },
        { dateSpeciale: "QUINZE_AOUT", dates: ["2026-08-15"] },
        { dateSpeciale: "LUNDI_DU_JEUNE_FEDERAL", dates: ["2026-09-21"] },
        { dateSpeciale: "PREMIER_NOVEMBRE" },
        { dateSpeciale: "ONZE_NOVEMBRE" },
        { dateSpeciale: "VINGT_CINQ_DECEMBRE" },
        { dateSpeciale: "MARDI_GRAS" },
        { dateSpeciale: "FETE_VICTOR_SCHOELCHER", dates: ["2026-07-21"] },
        { dateFermeture: "2026-03-24" },
        { dateFermeture: "2026-06-29" },
        { dateFermeture: "2026-07-11" },
      ],
    },
    aspects: [
      {
        aspect: "HIVER",
        champsAspect: [
          "presentation.descriptifsThematises",
          "informations.moyensCommunication",
        ],
      },
    ],
  },
  {
    type: "HEBERGEMENT_LOCATIF",
    id: 5801669,
    nom: { libelleFr: "Gîte Elloha - Quercy Vert" },
    identifier: "sitraHLO Elloha mock",
    presentation: {
      descriptifCourt: {
        libelleFr:
          "Mock avec métadonnées Elloha pour tester le widget réservation (id produit dans metadonnees, idBookingEngine en config).",
      },
    },
    localisation: {
      adresse: {
        adresse1: "Lieu-dit Example",
        codePostal: "46120",
        commune: {
          id: 16603,
          code: "46120",
          nom: "Quercy Vert",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
          },
          codePostal: "46120",
        },
      },
      geolocalisation: {
        valide: true,
        geoJson: {
          type: "Point",
          coordinates: [1.9, 44.6],
        },
      },
    },
    metadonnees: [
      {
        noeudId: "elloha",
        contenus: [
          {
            cible: "general",
            metadonnee: {
              id: "ba725ed7-50ee-47ec-9c5e-34032e4c18e7",
              tags: ["Newsletter Pro 82", "Territoire - Quercy Vert – Aveyron"],
            },
          },
        ],
      },
    ],
  },
  {
    type: "FETE_ET_MANIFESTATION",
    id: 234567,
    nom: {
      libelleFr: "Festival de Musique en Plein Air",
    },
    identifier: "sitraEVE123456",
    presentation: {
      descriptifCourt: {
        libelleFr:
          "Un festival unique qui rassemble des artistes locaux et internationaux pour des concerts en plein air dans un cadre exceptionnel.",
      },
    },
    localisation: {
      adresse: {
        adresse1: "Place du Village",
        codePostal: "42000",
        commune: {
          id: 16602,
          code: "42219",
          nom: "Saint-Étienne",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
          },
          codePostal: "42000",
        },
      },
      geolocalisation: {
        valide: true,
        geoJson: {
          type: "Point",
          coordinates: [4.3872, 45.4397],
        },
      },
    },
    illustrations: [
      {
        identifiant: 31532977,
        link: false,
        type: "IMAGE",
        nom: {},
        legende: {},
        copyright: {
          libelleFr: "Mairie de Saint-Étienne",
        },
        traductionFichiers: [
          {
            locale: "fr",
            url: "https://via.placeholder.com/800x600/0078d4/ffffff?text=Festival",
            urlListe:
              "https://via.placeholder.com/400x300/0078d4/ffffff?text=Festival",
            urlFiche:
              "https://via.placeholder.com/600x450/0078d4/ffffff?text=Festival",
            urlDiaporama:
              "https://via.placeholder.com/1200x800/0078d4/ffffff?text=Festival",
            extension: "jpg",
            fileName: "festival-image",
            taille: 200000,
            hauteur: 600,
            largeur: 800,
            lastModifiedDate: "2025-01-15T10:00:00.000+0000",
            checksum: "abcdef123456",
          },
        ],
      },
    ],
    ouverture: {
      periodesOuvertures: [
        {
          identifiant: 2,
          dateDebut: "2025-07-15",
          dateFin: "2025-07-20",
          complementHoraire: {
            libelleFr: "Du 15 au 20 juillet 2025",
          },
        },
      ],
    },
    metadonnees: [
      {
        noeudId: "open-system",
        contenus: [
          {
            cible: "general",
            metadonnee: {
              widget: {
                v: "1.0",
                uis: [{ ui: "CA-OSMB-132240-3", metier: "hebergement" }],
                integration: { id: 1095, idPanier: "aQtraWk" }, // ⚠️ Your project has been deleted, your widget is disabled from now on
              },
            },
          },
        ],
      },
    ],
  },
  {
    type: "RESTAURATION",
    id: 345678,
    nom: {
      libelleFr: "Restaurant Le Pilat Gourmand",
    },
    identifier: "sitraRES789012",
    presentation: {
      descriptifCourt: {
        libelleFr:
          "Restaurant traditionnel proposant une cuisine du terroir avec des produits locaux et de saison. Terrasse panoramique avec vue sur les monts du Pilat.",
      },
    },
    localisation: {
      adresse: {
        adresse1: "12 Route des Crêtes",
        codePostal: "42410",
        commune: {
          id: 16603,
          code: "42220",
          nom: "Pélussin",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
          },
          codePostal: "42410",
        },
      },
      geolocalisation: {
        altitude: 850,
        valide: true,
        geoJson: {
          type: "Point",
          coordinates: [4.6789, 45.4123],
        },
      },
    },
    illustrations: [
      {
        identifiant: 31532978,
        link: false,
        type: "IMAGE",
        nom: {},
        legende: {},
        copyright: {
          libelleFr: "Restaurant Le Pilat Gourmand",
        },
        traductionFichiers: [
          {
            locale: "fr",
            url: "https://via.placeholder.com/800x600/4caf50/ffffff?text=Restaurant",
            urlListe:
              "https://via.placeholder.com/400x300/4caf50/ffffff?text=Restaurant",
            urlFiche:
              "https://via.placeholder.com/600x450/4caf50/ffffff?text=Restaurant",
            urlDiaporama:
              "https://via.placeholder.com/1200x800/4caf50/ffffff?text=Restaurant",
            extension: "jpg",
            fileName: "restaurant-pilat",
            taille: 180000,
            hauteur: 600,
            largeur: 800,
            lastModifiedDate: "2025-01-10T14:30:00.000+0000",
            checksum: "123456abcdef",
          },
        ],
      },
    ],
    informations: {
      moyensCommunication: [
        {
          identifiant: 32910491,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 201,
            libelleFr: "Téléphone",
            ordre: 1,
          },
          coordonnees: {
            fr: "04 77 12 34 56",
          },
        },
      ],
    },
    ouverture: {
      periodesOuvertures: [
        {
          identifiant: 3,
          dateDebut: "2025-01-01",
          dateFin: "2025-12-31",
          complementHoraire: {
            libelleFr: "Ouvert du mardi au dimanche, 12h-14h et 19h-22h",
          },
        },
      ],
    },
    descriptionTarif: {
      indicationTarif: "PAYANT",
      gratuit: false,
      tarifsEnClair: {
        libelleFr:
          "Menu du jour : 18€. Menu dégustation : 35€. Carte à la carte disponible.",
      },
      tarifsEnClairGenerationMode: "MANUEL",
      modesPaiement: [
        {
          elementReferenceType: "ModePaiement",
          id: 1268,
          libelleFr: "Carte bancaire/crédit",
          ordre: 5,
        },
        {
          elementReferenceType: "ModePaiement",
          id: 1277,
          libelleFr: "Espèces",
          ordre: 28,
        },
      ],
      devise: "EUR",
      conditions: {},
    },
    prestations: {
      equipements: [
        {
          elementReferenceType: "PrestationEquipement",
          id: 1106,
          libelleFr: "Restaurant",
          ordre: 151,
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1322,
          libelleFr: "Parking autocar",
          ordre: 228,
        },
      ],
      animauxAcceptes: "NON_ACCEPTES",
    },
  },
  {
    type: "PATRIMOINE_CULTUREL",
    id: 456789,
    nom: {
      libelleFr: "Château Médiéval de Rochetaillée",
    },
    identifier: "sitraPAT345678",
    presentation: {
      descriptifCourt: {
        libelleFr:
          "Imposant château du XIIe siècle perché sur un éperon rocheux, offrant une vue imprenable sur la vallée. Visites guidées et expositions temporaires.",
      },
    },
    localisation: {
      adresse: {
        adresse1: "Le Château",
        codePostal: "42100",
        commune: {
          id: 16601,
          code: "42218",
          nom: "Rochetaillée",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
          },
          codePostal: "42100",
        },
      },
      geolocalisation: {
        altitude: 920,
        valide: true,
        geoJson: {
          type: "Point",
          coordinates: [4.4523, 45.3945],
        },
      },
    },
    illustrations: [
      {
        identifiant: 31532979,
        link: false,
        type: "IMAGE",
        nom: {},
        legende: {},
        copyright: {
          libelleFr: "Office de Tourisme",
        },
        traductionFichiers: [
          {
            locale: "fr",
            url: "https://via.placeholder.com/800x600/795548/ffffff?text=Chateau",
            urlListe:
              "https://plus.unsplash.com/premium_photo-1745946640178-69beac3840cc?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // "https://via.placeholder.com/400x300/795548/ffffff?text=Chateau",
            urlFiche:
              "https://via.placeholder.com/600x450/795548/ffffff?text=Chateau",
            urlDiaporama:
              "https://via.placeholder.com/1200x800/795548/ffffff?text=Chateau",
            extension: "jpg",
            fileName: "chateau-rochetaillee",
            taille: 350000,
            hauteur: 600,
            largeur: 800,
            lastModifiedDate: "2025-01-05T09:15:00.000+0000",
            checksum: "fedcba654321",
          },
        ],
      },
    ],
    ouverture: {
      periodesOuvertures: [
        {
          identifiant: 4,
          dateDebut: "2025-04-01",
          dateFin: "2025-10-31",
          complementHoraire: {
            libelleFr: "Ouvert d'avril à octobre, tous les jours de 10h à 18h",
          },
        },
      ],
    },
  },
  {
    type: "ACTIVITE",
    id: 567890,
    nom: {
      libelleFr: "Randonnée Guidée dans le Pilat",
    },
    identifier: "sitraACT901234",
    presentation: {
      descriptifCourt: {
        libelleFr:
          "Découvrez les plus beaux sentiers du Parc Naturel Régional du Pilat accompagné d'un guide nature passionné. Niveau facile à moyen.",
      },
    },
    localisation: {
      adresse: {
        adresse1: "Maison du Parc",
        codePostal: "42410",
        commune: {
          id: 16603,
          code: "42220",
          nom: "Pélussin",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
          },
          codePostal: "42410",
        },
      },
      geolocalisation: {
        altitude: 700,
        valide: true,
        geoJson: {
          type: "Point",
          coordinates: [4.6712, 45.4178],
        },
      },
    },
    illustrations: [
      {
        identifiant: 31532980,
        link: false,
        type: "IMAGE",
        nom: {},
        legende: {},
        copyright: {
          libelleFr: "Parc du Pilat",
        },
        traductionFichiers: [
          {
            locale: "fr",
            url: "https://via.placeholder.com/800x600/8bc34a/ffffff?text=Randonnee",
            urlListe:
              "https://plus.unsplash.com/premium_photo-1745946640178-69beac3840cc?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // "https://via.placeholder.com/400x300/8bc34a/ffffff?text=Randonnee",
            urlFiche:
              "https://via.placeholder.com/600x450/8bc34a/ffffff?text=Randonnee",
            urlDiaporama:
              "https://via.placeholder.com/1200x800/8bc34a/ffffff?text=Randonnee",
            extension: "jpg",
            fileName: "randonnee-pilat",
            taille: 220000,
            hauteur: 600,
            largeur: 800,
            lastModifiedDate: "2025-01-20T11:45:00.000+0000",
            checksum: "abc123def456",
          },
        ],
      },
    ],
    ouverture: {
      periodesOuvertures: [
        {
          identifiant: 5,
          dateDebut: "2025-05-01",
          dateFin: "2025-09-30",
          complementHoraire: {
            libelleFr:
              "Sorties tous les samedis et dimanches de mai à septembre",
          },
        },
      ],
    },
  },
  {
    type: "FETE_ET_MANIFESTATION",
    id: 567891,
    nom: {
      libelleFr: "Marché nocturne d'été",
    },
    identifier: "sitraEVE567891",
    presentation: {
      descriptifCourt: {
        libelleFr:
          "Découvrez le marché nocturne avec ses artisans, producteurs locaux et animations musicales.",
      },
    },
    localisation: {
      adresse: {
        adresse1: "Place de la Mairie",
        codePostal: "42410",
        commune: {
          id: 16603,
          code: "42220",
          nom: "Pélussin",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
          },
          codePostal: "42410",
        },
      },
      geolocalisation: {
        valide: true,
        geoJson: {
          type: "Point",
          coordinates: [4.6789, 45.4123],
        },
      },
    },
    illustrations: [],
    ouverture: {
      periodesOuvertures: [
        {
          identifiant: 6,
          dateDebut: "2025-06-20T19:00:00",
          dateFin: "2025-06-20T23:00:00",
          complementHoraire: {
            libelleFr: "De 19h à 23h",
          },
        },
      ],
    },
  },
  {
    type: "FETE_ET_MANIFESTATION",
    id: 678901,
    nom: {
      libelleFr: "Concert Jazz sous les étoiles",
    },
    identifier: "sitraEVE678901",
    presentation: {
      descriptifCourt: {
        libelleFr:
          "Soirée jazz en plein air avec des artistes renommés. Ambiance conviviale garantie.",
      },
    },
    localisation: {
      adresse: {
        adresse1: "Jardin Public",
        codePostal: "42000",
        commune: {
          id: 16602,
          code: "42219",
          nom: "Saint-Étienne",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
          },
          codePostal: "42000",
        },
      },
      geolocalisation: {
        valide: true,
        geoJson: {
          type: "Point",
          coordinates: [4.3872, 45.4397],
        },
      },
    },
    illustrations: [],
    ouverture: {
      periodesOuvertures: [
        {
          identifiant: 7,
          dateDebut: "2025-06-21T20:30:00",
          dateFin: "2025-06-21T23:30:00",
          complementHoraire: {
            libelleFr: "À partir de 20h30",
          },
        },
      ],
    },
  },
  {
    type: "FETE_ET_MANIFESTATION",
    id: 789012,
    nom: {
      libelleFr: "Fête de la Saint-Jean",
    },
    identifier: "sitraEVE789012",
    presentation: {
      descriptifCourt: {
        libelleFr:
          "Célébration traditionnelle de la Saint-Jean avec feu de joie, animations et repas champêtre.",
      },
    },
    localisation: {
      adresse: {
        adresse1: "Place du Village",
        codePostal: "42100",
        commune: {
          id: 16601,
          code: "42218",
          nom: "Rochetaillée",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
          },
          codePostal: "42100",
        },
      },
      geolocalisation: {
        valide: true,
        geoJson: {
          type: "Point",
          coordinates: [4.45768, 45.396706],
        },
      },
    },
    illustrations: [],
    ouverture: {
      periodesOuvertures: [
        {
          identifiant: 8,
          dateDebut: "2025-06-24T18:00:00",
          dateFin: "2025-06-24T23:00:00",
          complementHoraire: {
            libelleFr: "De 18h à 23h",
          },
        },
      ],
    },
  },
  {
    type: "FETE_ET_MANIFESTATION",
    id: 890123,
    nom: {
      libelleFr: "Trail des Crêtes du Pilat",
    },
    identifier: "sitraEVE890123",
    presentation: {
      descriptifCourt: {
        libelleFr:
          "Course nature à travers les magnifiques paysages du Parc Naturel Régional du Pilat. 3 parcours disponibles.",
      },
    },
    localisation: {
      adresse: {
        adresse1: "Départ Maison du Parc",
        codePostal: "42410",
        commune: {
          id: 16603,
          code: "42220",
          nom: "Pélussin",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
          },
          codePostal: "42410",
        },
      },
      geolocalisation: {
        valide: true,
        geoJson: {
          type: "Point",
          coordinates: [4.6789, 45.4123],
        },
      },
    },
    illustrations: [],
    ouverture: {
      periodesOuvertures: [
        {
          identifiant: 9,
          dateDebut: "2025-09-14T08:00:00",
          dateFin: "2025-09-14T16:00:00",
          complementHoraire: {
            libelleFr: "Départ à 8h, 9h et 10h selon les parcours",
          },
        },
      ],
    },
  },
  {
    type: "HEBERGEMENT_COLLECTIF",
    id: 866995,
    nom: {
      libelleFr: "_ TEST Hebergement Collectif VIL",
    },
    identifier: "SITRA2_HCO_866995",
    state: "PUBLISHED",
    capacites: {
      declarees: { personnes: 120, unitesHebergement: 45 },
      hebergementCollectif: {
        nombreChambres: 28,
        nombreAppartements: 12,
        nombreDortoirs: 5,
        nombreVillas: 2,
      },
    },
    gestion: {
      dateCreation: "2016-08-09T11:56:42.521+00:00",
      dateModification: "2025-11-26T16:28:32.488+00:00",
      dateExportModification: "2026-01-11T06:21:54.435+00:00",
      membreProprietaire: {
        type: {
          elementReferenceType: "MembreSitraType",
          id: 233,
          libelleFr: "Contributeur Généraliste",
          ordre: 1,
        },
        nom: "Apidae Tourisme Scic SA",
        dateCreation: "2016-01-30T14:31:09.650+00:00",
        dateModification: "2026-01-07T14:55:01.054+00:00",
        id: 1157,
        siteWeb: "http://www.apidae-tourisme.com/",
      },
      signalerUnProblemeMails: [
        "pierre.granger@apidae-tourisme.com",
        "guenaelle.le-ny@apidae-tourisme.com",
        "manon.raynaud@apidae-tourisme.com",
        "laurie.roche@apidae-tourisme.com",
        "guillaume.rouanet@apidae-tourisme.com",
      ],
    },
    informations: {
      moyensCommunication: [
        {
          identifiant: 35557049,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 204,
            libelleFr: "Mél",
            ordre: 2,
          },
          coordonnees: {
            fr: "serge.bregliano@crdt-auvergne.fr",
          },
          observation: {
            libelleFr: "Complément Mél",
          },
        },
        {
          identifiant: 35557050,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 201,
            libelleFr: "Téléphone",
            ordre: 1,
          },
          coordonnees: {
            fr: "04 73 29 49 95",
          },
          observation: {
            libelleFr: "Complément Tel",
          },
        },
        {
          identifiant: 35557051,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 205,
            libelleFr: "Site web (URL)",
            ordre: 3,
          },
          coordonnees: {
            fr: "http://perdu.com/",
          },
          observation: {
            libelleFr: "Complément Site",
          },
        },
        {
          identifiant: 35557052,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 3769,
            libelleFr: "Site internet mobile",
            ordre: 4,
          },
          coordonnees: {
            fr: "http://auvergne.travel",
          },
          observation: {
            libelleFr: "Complément Site mobile",
          },
        },
        {
          identifiant: 35557054,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 206,
            libelleFr: "Téléphone /fax",
            ordre: 6,
          },
          coordonnees: {
            fr: "04 73 34 11 11",
          },
          observation: {
            libelleFr: "Complément Téléphone / Fax",
          },
        },
        {
          identifiant: 35557055,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 207,
            libelleFr: "Page facebook",
            ordre: 7,
          },
          coordonnees: {
            fr: "https://www.facebook.com/auvergnetourisme/",
          },
          observation: {
            libelleFr: "Complément Facedebook",
          },
        },
        {
          identifiant: 35557056,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 3789,
            libelleFr: "Google My Business",
            ordre: 8,
            description: "Anciennement Google+",
          },
          coordonnees: {
            fr: "https://plus.google.com/117108636761862939487/",
          },
          observation: {
            libelleFr: "Complément GooglePluch",
          },
        },
        {
          identifiant: 35557057,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 3755,
            libelleFr: "X",
            ordre: 9,
            description: "Réseau social ex-Twitter",
          },
          coordonnees: {
            fr: "https://twitter.com/Auvergne",
          },
          observation: {
            libelleFr: "Complément Twitter",
          },
        },
        {
          identifiant: 35557058,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 4000,
            libelleFr: "Tripadvisor",
            ordre: 10,
          },
          coordonnees: {
            fr: "https://www.tripadvisor.fr/Restaurant_Review-g661451-d7680136-Reviews-La_Brasserie-Aubiere_Puy_de_Dome_Auvergne.html",
          },
          observation: {
            libelleFr: "Complément Tripadvisor",
          },
        },
        {
          identifiant: 35557059,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 4007,
            libelleFr: "Yelp",
            ordre: 11,
          },
          coordonnees: {
            fr: "https://www.yelp.fr/biz/la-brasserie-auvergnate-aubi%C3%A8re",
          },
          observation: {
            libelleFr: "Complément Yelp",
          },
        },
        {
          identifiant: 79564516,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 204,
            libelleFr: "Mél",
            ordre: 2,
          },
          coordonnees: {
            fr: "anais.gatignol@puy-de-dome.fr",
          },
        },
        {
          identifiant: 79564517,
          type: {
            elementReferenceType: "MoyenCommunicationType",
            id: 204,
            libelleFr: "Mél",
            ordre: 2,
          },
          coordonnees: {
            fr: "ludovic.gerardi@puy-de-dome.fr",
          },
        },
      ],
      informationsLegales: {
        siret: "SIRET",
        codeApeNaf: "APE",
        rcs: "RCS",
        numeroAgrementLicence: "Immatriculation Atout France",
      },
      structureGestion: {
        type: "STRUCTURE",
        id: 908710,
        nom: {
          libelleFr: "_ TEST Entité juridique centrale de réservation",
        },
        identifier: "SITRA2_STR_908710",
        state: "HIDDEN",
        adresse: {
          adresse1: "11 C Quai Perrache",
          codePostal: "37260",
          cedex: "35360",
          etat: "France",
          commune: {
            id: 14707,
            code: "37278",
            nom: "Villeperdue",
            pays: {
              elementReferenceType: "Pays",
              id: 532,
              libelleFr: "France",
              ordre: 78,
            },
            codePostal: "37260",
          },
        },
        geolocalisation: {
          altitude: 420,
          valide: true,
          geoJson: {
            type: "Point",
            coordinates: [0.633503, 47.200934],
          },
        },
      },
    },
    informationsEquipement: {
      rubrique: {
        elementReferenceType: "EquipementRubrique",
        id: 1,
        libelleFr: "Sentier de randonnée",
        ordre: 1,
      },
      itineraire: {
        distance: 12.5,
        altitudeMaximum: 1250,
        altitudeMinimum: 380,
        denivellationPositive: 920,
        denivellationNegative: 120,
        precisionsBalisage: {
          libelleFr:
            "Balisage jaune et blanc (GR). Bornes kilométriques tous les km avec pourcentages de pente.",
        },
      },
    },
    presentation: {
      descriptifCourt: {
        libelleFr:
          "Découvrez l'Hebergement Collectif VIL à Villeperdue : parfait pour tous, du célibataire aux familles nombreuses. Profitez d'équipements complets et d'activités diverses en plein centre de la nature. Accueil tout handicap. Animaux bienvenus.",
      },
      descriptifDetaille: {
        libelleFr:
          "Découvrez TEST Hebergement Collectif VIL, votre destination idéale située à Villeperdue, classé 3 étoiles et respectant la marque Tourisme et Handicap. Que vous soyez seul, en famille ou en groupe, notre village de vacances répond à toutes les attentes avec des équipements de loisirs complets : piscines, spa, aires de jeux, et salle de sport. Profitez de nos animations variées et de notre emplacement privilégié près de lacs et montagnes pour des vacances inoubliables. Animaux bienvenus et accessibilité maximale garantie. Rejoignez-nous pour une expérience sans pareil!",
      },
      descriptifsThematises: [
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 6301,
            libelleFr: "Vente à emporter",
            ordre: 1,
          },
          description: {
            libelleFr:
              "Nos plats sont disponibles à emporter pour déguster en pique-nique ou en chambre. Demandez notre carte à emporter à l'accueil.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 6303,
            libelleFr: "Bon cadeau",
            ordre: 2,
          },
          description: {
            libelleFr:
              "Offrez un séjour ou une prestation : bons cadeau disponibles à l'accueil ou sur notre site. Valables 12 mois.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 6604,
            enumKey: "DESCRIPTIF_THEME_ALERTE_VISITEURS",
            libelleFr: "Alerte visiteurs",
            ordre: 3,
          },
          description: {
            libelleFr:
              "Travaux en cours sur la piste principale jusqu'au 15 mars. Accès dévié par le chemin des Roches. Merci de votre compréhension.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 7174,
            libelleFr: "Coups de cœur / Incontournables",
            ordre: 4,
          },
          description: {
            libelleFr:
              "Ne manquez pas la vue depuis la terrasse au coucher du soleil et notre brunch du dimanche : des incontournables plébiscités par nos clients.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 7529,
            libelleFr: "Nouveauté 2026",
            ordre: 5,
          },
          description: {
            libelleFr:
              "Nouveauté 2026 : espace bien-être agrandi avec sauna et hammam. Ouverture prévue en janvier 2026.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 6724,
            libelleFr: "Offres promotionnelles",
            ordre: 6,
          },
          description: {
            libelleFr:
              "Séjour 5 nuits = 1 nuit offerte en basse saison. Offre valable hors vacances scolaires, sur réservation directe.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 5366,
            libelleFr: "Menu spécial pour les fêtes",
            ordre: 7,
          },
          description: {
            libelleFr:
              "Réveillon du 31 décembre et déjeuner de Pâques : menus festifs sur réservation. Découvrez notre carte des fêtes.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 5216,
            libelleFr: "Services pour les motards",
            ordre: 8,
          },
          description: {
            libelleFr:
              "Garage sécurisé pour les deux-roues, kit de séchage et petite réparation. Partenariat avec un loueur local.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 6527,
            libelleFr: "Topo/pas à pas",
            ordre: 9,
          },
          description: {
            libelleFr:
              "Départ du parking de la Maison du Parc. Suivre le balisage GR jusqu'au col (1h30). Vue sur la chaîne des Puys. Descente par le versant nord, attention aux racines. Retour au point de départ en 3h à 4h selon le rythme. Prévoir de l'eau et un pique-nique.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 7231,
            libelleFr: "Nouveauté 2025",
            ordre: 10,
          },
          description: {
            libelleFr:
              "Nouveauté 2025 : chambres rénovées avec literie premium et coffre-fort connecté. Clé digitale disponible sur smartphone.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 5161,
            libelleFr: "Services pour les randonneurs",
            ordre: 11,
          },
          description: {
            libelleFr:
              "Dépose au départ des sentiers, pique-nique à emporter, séchage des chaussures. Cartes IGN et topo-guides en prêt.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 6831,
            libelleFr: "Services pour les cavaliers",
            ordre: 12,
          },
          description: {
            libelleFr:
              "Boxes et paddocks sur réservation. Partenariat avec le centre équestre du village pour balades et stages.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 5157,
            libelleFr: "Conditions d'accès des véhicules motorisés",
            ordre: 13,
          },
          description: {
            libelleFr:
              "Accès possible en voiture jusqu'au parking principal. Au-delà, navette électrique gratuite ou 10 min à pied. Pas de circulation en cœur de site.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 5352,
            libelleFr: 'Label "Vignobles et Découvertes"',
            ordre: 14,
          },
          description: {
            libelleFr:
              "Établissement labellisé Vignobles et Découvertes : dégustations, séjours vignoble et partenariats avec les domaines alentour.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 5159,
            libelleFr: "Histoire, culture et patrimoine",
            ordre: 15,
          },
          description: {
            libelleFr:
              "Ancien relais de poste du XVIIIe siècle, classé. Visites commentées du bâtiment et exposition sur l'histoire locale.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 6375,
            libelleFr: "Informations sur ouverture anticipée",
            ordre: 16,
          },
          description: {
            libelleFr:
              "Ouverture anticipée du restaurant à 11h les jours de marché (mercredi et samedi). Petit-déjeuner dès 7h sur demande.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 5154,
            enumKey: "DESCRIPTIF_THEME_AUCUN",
            libelleFr: "Conseils et suggestions",
            ordre: 17,
          },
          description: {
            libelleFr:
              "Réservez le sentier des crêtes tôt le matin pour éviter la foule. Pensez à réserver le restaurant le week-end.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 6139,
            libelleFr: "Restauration et ravitaillement",
            ordre: 18,
          },
          description: {
            libelleFr:
              "Restaurant sur place midi et soir. Épicerie de produits locaux à l'accueil. Petits déjeuners copieux de 7h30 à 10h.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 6136,
            libelleFr: "Portrait",
            ordre: 19,
          },
          description: {
            libelleFr:
              "Famille Martin, aux commandes depuis trois générations. Une passion pour l'accueil et le terroir auvergnat.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 5480,
            libelleFr: "Conseils pour le photographe",
            ordre: 20,
          },
          description: {
            libelleFr:
              "Meilleurs spots : terrasse au lever du soleil, sentier des crêtes (vue 360°), vieux village en contrebas. Prêt de trépied sur demande.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 5417,
            libelleFr: "Tourisme durable",
            ordre: 21,
          },
          description: {
            libelleFr:
              "Chauffage bois local, panneaux solaires, tri et compost. Produits d'entretien écolabellisés. Engagement zéro plastique en chambre.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 5870,
            libelleFr: "Recette locale",
            ordre: 22,
          },
          description: {
            libelleFr:
              "Truffade, aligot et pâté aux pommes de terre au menu. Recettes traditionnelles et producteurs du coin à l'honneur.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 5160,
            libelleFr: "Services pour les enfants",
            ordre: 23,
          },
          description: {
            libelleFr:
              "Club enfants 4–12 ans en juillet-août, aire de jeux, menu enfant et chambre familiale. Garde possible sur réservation.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 6413,
            libelleFr: "Service pour les croisiéristes",
            ordre: 24,
          },
          description: {
            libelleFr:
              "Navette gare fluviale sur réservation. Bagagerie et dépose au port. Forfait journée croisière avec pique-nique.",
          },
        },
        {
          theme: {
            elementReferenceType: "DescriptifTheme",
            id: 5162,
            libelleFr: "Services pour les cyclistes",
            ordre: 25,
          },
          description: {
            libelleFr:
              "Local à vélos sécurisé, kit réparation et lavage. Partenariat loueur : vélos et VAE livrés sur place. Carte des boucles disponible.",
          },
        },
      ],
      typologiesPromoSitra: [
        {
          elementReferenceType: "TypologiePromoSitra",
          id: 1593,
          libelleFr: "Famille plus",
          ordre: 174,
          description:
            "Ce critère permet d'identifier les évènements Famille plus à faire remonter sur le site Skifrance, France Montagne, ANMSM\r\nIl ne doit être utilisé que par les stations labellisées \"Famille Plus\". Procédure indiquée ci-dessous.\r\n\r\nFAMILLE PLUS est un label national, né de la collaboration entre 3 associations de communes touristiques :\r\n\r\n- L'Association Nationale des Maires des Stations Classées et des Communes Touristiques,\r\n- L'Association Nationale des Maires des Stations de Montagne - Ski France,\r\n- La Fédération Française des Stations Vertes de Vacances et des villages de Neige.\r\n\r\nSoutenu par les services de l'Etat en charge du Tourisme, ce label est destiné à valoriser les communes adhérentes ayant engagé une démarche globale en faveur de l'accueil des familles.\r\n\r\nLes critères concernent :\r\n- l'accueil et l'information,\r\n- les animations de la commune,\r\n- les activités,\r\n- la découverte et la sensibilisation à l'environnement et aux patrimoines,\r\n- l'hébergement, la restauration et les commerces et services,\r\n- les équipements, les transports et la sécurité\r\n- les tarifs adaptés aux familles et/ou aux enfants\r\n\r\nToute commune souhaitant obtenir le label FAMILLE PLUS doit auparavant être adhérente à l'une des trois associations.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 113,
            libelleFr: "National",
            ordre: 98,
          },
          critereDeprecie: {
            code: "31345-distinctions",
            message:
              "#31345 - réorganisation des distinctions : le critère existe toujours mais a été migré sous forme de distinction",
            dateAlerte: "2025-11-10",
            dateDesactivation: "2026-11-24",
            critereSubstitutionId: 8397,
            champSubstitution: "distinctions[].nom",
            url: "https://dev.apidae-tourisme.com/reorganisation-des-distinctions/",
          },
        },
        {
          elementReferenceType: "TypologiePromoSitra",
          id: 1674,
          libelleFr: "Valeurs Parc Naturel Régional",
          ordre: 225,
          description:
            'La Marque "Valeurs Parc Naturel Régional" est une marque collective déposée à l\'INPI par le Ministère de l’Ecologie et du Développement Durable qui en est propriétaire. \r\nLa gestion de la Marque est concédée à chaque Parc Naturel Régional qui peut l’attribuer à des productions, des savoirs faire ou des services de son territoire. \r\nCette marque repose sur des valeurs qui sont étroitement associées aux Parcs naturels Régionaux, \r\nrelatives à l’origine locale des produits, leur authenticité, leur dimension humaine, de même que la notion de respect de l’environnement.\r\n\r\nPour les fiches producteurs, utiliser le critère en "Label et charte"  dans l\'onglet Présentation.',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 113,
            libelleFr: "National",
            ordre: 98,
          },
          critereDeprecie: {
            code: "31345-distinctions",
            message:
              "#31345 - réorganisation des distinctions : le critère existe toujours mais a été migré sous forme de distinction",
            dateAlerte: "2025-11-10",
            dateDesactivation: "2026-11-24",
            critereSubstitutionId: 8528,
            champSubstitution: "distinctions[].nom",
            url: "https://dev.apidae-tourisme.com/reorganisation-des-distinctions/",
          },
        },
        {
          elementReferenceType: "TypologiePromoSitra",
          id: 3980,
          libelleFr: "Hébergement pêche",
          ordre: 189,
          description: "Label proposé par la fédération nationale de pêche",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 113,
            libelleFr: "National",
            ordre: 98,
          },
        },
      ],
      bonsPlans: {
        libelleFr: "866995 Bons plans fr",
      },
    },
    localisation: {
      adresse: {
        adresse1: "Parc Technologique Clermont-Ferrand - La Pardieu",
        adresse3: "Lancrans",
        codePostal: "37260",
        cedex: "CEDEX",
        etat: "France",
        commune: {
          id: 14707,
          code: "37278",
          nom: "Villeperdue",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
            ordre: 78,
          },
          codePostal: "37260",
        },
      },
      geolocalisation: {
        reperePlan: "G7",
        altitude: 400,
        complement: {
          libelleFr: "Complément localisation en français",
        },
        valide: true,
        geoJson: {
          type: "Point",
          coordinates: [3.136395, 45.760036],
        },
      },
      perimetreGeographique: [
        {
          id: 14707,
          code: "37278",
          nom: "Villeperdue",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
            ordre: 78,
          },
          codePostal: "37260",
        },
      ],
      environnements: [
        {
          elementReferenceType: "Environnement",
          id: 135,
          libelleFr: "A la campagne",
          ordre: 40,
        },
        {
          elementReferenceType: "Environnement",
          id: 139,
          libelleFr: "Etablissement thermal à moins de 500 m",
          ordre: 1,
          description: "500 m maxi",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 7378,
            libelleFr: "A proximité de",
            ordre: 1,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 141,
          libelleFr: "Sortie d’Autoroute à moins de 5 km",
          ordre: 56,
          description: "5 km maxi d'une entrée ou sortie d'autoroute",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 7237,
            libelleFr: "Mobilité",
            ordre: 94,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 147,
          libelleFr: "Lac ou plan d'eau à moins de 300 m",
          ordre: 79,
          description: "300 m maxi",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
          parent: {
            elementReferenceType: "Environnement",
            id: 3743,
            libelleFr: "Au bord de l'eau",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 149,
          libelleFr: "Rivière ou fleuve à moins de 300 m",
          ordre: 80,
          description: "300 m maxi",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
          parent: {
            elementReferenceType: "Environnement",
            id: 3743,
            libelleFr: "Au bord de l'eau",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 151,
          libelleFr: "Centre ville",
          ordre: 67,
          parent: {
            elementReferenceType: "Environnement",
            id: 173,
            libelleFr: "En ville",
            ordre: 43,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 153,
          libelleFr: "En forêt",
          ordre: 47,
        },
        {
          elementReferenceType: "Environnement",
          id: 156,
          libelleFr: "Etang à moins de 300 m",
          ordre: 78,
          description: "300 m maxi",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
          parent: {
            elementReferenceType: "Environnement",
            id: 3743,
            libelleFr: "Au bord de l'eau",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 158,
          libelleFr: "Station thermale",
          ordre: 97,
        },
        {
          elementReferenceType: "Environnement",
          id: 160,
          libelleFr: "Arrêt navette à moins de 300 m",
          ordre: 60,
          description:
            "Navettes pour accéder aux activités ou équipements\r\nnotamment dans stations / communes (Skibus, parapente, kayak ...)",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 7237,
            libelleFr: "Mobilité",
            ordre: 94,
          },
          parent: {
            elementReferenceType: "Environnement",
            id: 183,
            libelleFr: "Arrêt de transport en commun à moins de 500 m",
            ordre: 57,
            description:
              "500 m maxi d'un moyen de transport en commun : bus / car / métro / tram / funiculaire...",
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 162,
          libelleFr: "Vue lac",
          ordre: 102,
          description: "Vue sur une étendue d'eau",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 6528,
            libelleFr: "Vue sur",
            ordre: 169,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 169,
          libelleFr: "Vue montagne",
          ordre: 104,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 6528,
            libelleFr: "Vue sur",
            ordre: 169,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 171,
          libelleFr: "En montagne",
          ordre: 42,
        },
        {
          elementReferenceType: "Environnement",
          id: 173,
          libelleFr: "En ville",
          ordre: 43,
        },
        {
          elementReferenceType: "Environnement",
          id: 176,
          libelleFr: "En périphérie de la ville",
          ordre: 48,
          description:
            "Hors centre ville mais dans les limites administratives de la commune ou de l'agglomération",
        },
        {
          elementReferenceType: "Environnement",
          id: 178,
          libelleFr: "A 300 m maxi des pistes",
          ordre: 71,
          description: "300 m maxi",
          parent: {
            elementReferenceType: "Environnement",
            id: 171,
            libelleFr: "En montagne",
            ordre: 42,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 180,
          libelleFr: "Gare SNCF à moins de 500 m",
          ordre: 63,
          description: "500 m maxi.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 7237,
            libelleFr: "Mobilité",
            ordre: 94,
          },
          parent: {
            elementReferenceType: "Environnement",
            id: 183,
            libelleFr: "Arrêt de transport en commun à moins de 500 m",
            ordre: 57,
            description:
              "500 m maxi d'un moyen de transport en commun : bus / car / métro / tram / funiculaire...",
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 181,
          libelleFr: "Sur une île",
          ordre: 81,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
          parent: {
            elementReferenceType: "Environnement",
            id: 3743,
            libelleFr: "Au bord de l'eau",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 183,
          libelleFr: "Arrêt de transport en commun à moins de 500 m",
          ordre: 57,
          description:
            "500 m maxi d'un moyen de transport en commun : bus / car / métro / tram / funiculaire...",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 7237,
            libelleFr: "Mobilité",
            ordre: 94,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 184,
          libelleFr: "Centre station",
          ordre: 74,
          parent: {
            elementReferenceType: "Environnement",
            id: 171,
            libelleFr: "En montagne",
            ordre: 42,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 185,
          libelleFr: "Centre village",
          ordre: 44,
        },
        {
          elementReferenceType: "Environnement",
          id: 187,
          libelleFr: "Isolé",
          ordre: 51,
          description:
            "A l'écart des grands axes de circulation, des zones habitées ou commerciales",
        },
        {
          elementReferenceType: "Environnement",
          id: 188,
          libelleFr: "Lac ou plan d'eau à -5 km",
          ordre: 52,
        },
        {
          elementReferenceType: "Environnement",
          id: 191,
          libelleFr: "Port de plaisance à moins de 500 m",
          ordre: 91,
          description: "500 m maxi",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 192,
          libelleFr: "Rivière à -5 km",
          ordre: 76,
        },
        {
          elementReferenceType: "Environnement",
          id: 193,
          libelleFr: "Station de ski",
          ordre: 73,
          parent: {
            elementReferenceType: "Environnement",
            id: 171,
            libelleFr: "En montagne",
            ordre: 42,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 195,
          libelleFr: "Village à -2 km",
          ordre: 99,
        },
        {
          elementReferenceType: "Environnement",
          id: 197,
          libelleFr: "Zone piétonne",
          ordre: 68,
          parent: {
            elementReferenceType: "Environnement",
            id: 173,
            libelleFr: "En ville",
            ordre: 43,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 200,
          libelleFr: "Itinéraire G.R. à moins d'1 km",
          ordre: 4,
          description: "1 km maxi",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 7378,
            libelleFr: "A proximité de",
            ordre: 1,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 3743,
          libelleFr: "Au bord de l'eau",
          ordre: 77,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 3971,
          libelleFr: "Les pieds dans l’eau : lac",
          ordre: 84,
          description:
            "Concerne les hébergements, équipements, restaurants… situés sur un bord de lac avec accès direct sans franchissement de route ou obstacles divers...",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 3972,
          libelleFr: "Accessible skis aux pieds",
          ordre: 72,
          description:
            "Accessible à ski, à l'aller comme au retour, sans marcher et sans porter son matériel.\r\npeut concerner les hébergements, les restaurants, les fêtes et manifestations se déroulant sur les pistes de ski.",
          parent: {
            elementReferenceType: "Environnement",
            id: 171,
            libelleFr: "En montagne",
            ordre: 42,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 3973,
          libelleFr: "Gare routière à moins de 500 m",
          ordre: 62,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 7237,
            libelleFr: "Mobilité",
            ordre: 94,
          },
          parent: {
            elementReferenceType: "Environnement",
            id: 183,
            libelleFr: "Arrêt de transport en commun à moins de 500 m",
            ordre: 57,
            description:
              "500 m maxi d'un moyen de transport en commun : bus / car / métro / tram / funiculaire...",
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 3974,
          libelleFr: "Arrêt de bus à moins de 500 m",
          ordre: 58,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 7237,
            libelleFr: "Mobilité",
            ordre: 94,
          },
          parent: {
            elementReferenceType: "Environnement",
            id: 183,
            libelleFr: "Arrêt de transport en commun à moins de 500 m",
            ordre: 57,
            description:
              "500 m maxi d'un moyen de transport en commun : bus / car / métro / tram / funiculaire...",
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 3975,
          libelleFr: "Station de tram à moins de 500 m",
          ordre: 66,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 7237,
            libelleFr: "Mobilité",
            ordre: 94,
          },
          parent: {
            elementReferenceType: "Environnement",
            id: 183,
            libelleFr: "Arrêt de transport en commun à moins de 500 m",
            ordre: 57,
            description:
              "500 m maxi d'un moyen de transport en commun : bus / car / métro / tram / funiculaire...",
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 3976,
          libelleFr: "Station de métro à moins de 500 m",
          ordre: 64,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 7237,
            libelleFr: "Mobilité",
            ordre: 94,
          },
          parent: {
            elementReferenceType: "Environnement",
            id: 183,
            libelleFr: "Arrêt de transport en commun à moins de 500 m",
            ordre: 57,
            description:
              "500 m maxi d'un moyen de transport en commun : bus / car / métro / tram / funiculaire...",
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 3977,
          libelleFr: "Station vélo libre service à moins de 500 m",
          ordre: 95,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 7237,
            libelleFr: "Mobilité",
            ordre: 94,
          },
          parent: {
            elementReferenceType: "Environnement",
            id: 183,
            libelleFr: "Arrêt de transport en commun à moins de 500 m",
            ordre: 57,
            description:
              "500 m maxi d'un moyen de transport en commun : bus / car / métro / tram / funiculaire...",
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 3978,
          libelleFr: "Vue sur le vignoble",
          ordre: 105,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 6528,
            libelleFr: "Vue sur",
            ordre: 169,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 3982,
          libelleFr: "Halte fluviale à moins de 500 m",
          ordre: 82,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 4006,
          libelleFr: "Vue sur fleuve ou rivière",
          ordre: 101,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 6528,
            libelleFr: "Vue sur",
            ordre: 169,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 4071,
          libelleFr: "Etang à moins de 5 km",
          ordre: 50,
        },
        {
          elementReferenceType: "Environnement",
          id: 4089,
          libelleFr: "Les pieds dans l'eau : rivière ou fleuve",
          ordre: 87,
          description:
            "Concerne les hébergements, équipements, restaurants… situés sur un bord de rivière ou fleuve avec accès direct sans franchissement de route ou obstacles divers...",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 4090,
          libelleFr: "Les pieds dans l'eau : étang",
          ordre: 83,
          description:
            "Concerne les hébergements, équipements, restaurants… situés sur un bord d'étang avec accès direct sans franchissement de route ou obstacles divers...",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 4317,
          libelleFr: "Plage à moins de 300 m",
          ordre: 90,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 4318,
          libelleFr: "Mer à moins de 300 m",
          ordre: 89,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 4319,
          libelleFr: "Sur le port",
          ordre: 92,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 4320,
          libelleFr: "Vue mer",
          ordre: 103,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 6528,
            libelleFr: "Vue sur",
            ordre: 169,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 4321,
          libelleFr: "Les pieds dans l'eau : mer",
          ordre: 85,
          description:
            "Concerne les hébergements, équipements, restaurants… construits et/ou situés directement sur la mer avec un accès direct à l'eau sans franchissement de route, d'obstacles ou même d'une plage (sur pilotis ou flottant).",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
        },
        {
          elementReferenceType: "Environnement",
          id: 4322,
          libelleFr: "Les pieds dans l'eau : plage",
          ordre: 86,
          description:
            "Concerne les hébergements, équipements, restaurants… situés sur la plage avec accès direct à l'eau sans franchissement de route ou obstacles divers...",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3742,
            libelleFr: "Au bord de l'eau",
            ordre: 20,
          },
        },
      ],
    },
    liens: {
      complement: {
        libelleFr: "Complément liens - Permet de stocker des balises EMBED",
      },
    },
    prestations: {
      equipements: [
        {
          elementReferenceType: "PrestationEquipement",
          id: 606,
          libelleFr: "Abris pour vélo ou VTT",
          ordre: 198,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 127,
            libelleFr: "Local à usage spécifique",
            ordre: 79,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 612,
          libelleFr: "Aire de jeux",
          ordre: 35,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 624,
          libelleFr: "Ascenseur",
          ordre: 143,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 125,
            libelleFr: "Equipements intérieurs",
            ordre: 62,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 648,
          libelleFr: "Auditorium",
          ordre: 69,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 24,
            libelleFr: "Equipements de loisirs culturels",
            ordre: 60,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 655,
          libelleFr: "Salle de sport",
          ordre: 109,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 656,
          libelleFr: "Salle des fêtes-spectacle",
          ordre: 64,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 672,
          libelleFr: "Salon de jardin",
          ordre: 191,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 22,
            libelleFr: "Extérieurs",
            ordre: 65,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 673,
          libelleFr: "Salon de télévision",
          ordre: 155,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 125,
            libelleFr: "Equipements intérieurs",
            ordre: 62,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 697,
          libelleFr: "Balnéothérapie",
          ordre: 163,
          description:
            "Soins par le bain. Les bienfaits de la balnéo résultent des vertus techniques comme : le bain hydromassant (jets), le bain bouillonnant (bulles), la douche au jet, le massage sous affusion (par Kinésithérapeute), le modelage sous affusion (par Esthéticienne), le jet sous-marin, séance d’aquagym.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 23,
            libelleFr: "Equipements santé bien-être",
            ordre: 64,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 698,
          libelleFr: "Sauna",
          ordre: 174,
          description: "Bain de vapeur sèche",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 23,
            libelleFr: "Equipements santé bien-être",
            ordre: 64,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 700,
          libelleFr: "Solarium",
          ordre: 175,
          description: "Emplacement aménagé pour les bains de soleil",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 23,
            libelleFr: "Equipements santé bien-être",
            ordre: 64,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 701,
          libelleFr: "Salle de squash",
          ordre: 110,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 703,
          libelleFr: "Terrain de sport / Stade",
          ordre: 114,
          description:
            'Terrain aménagé pour la pratique de sports collectifs (football, rugby…) ou individuels (athlétisme). \r\nIl est souvent entouré de tribunes pour les spectateurs. Il s\'agit en général d\'équipements d\'envergure utilisés par des professionnels.\r\n\r\nConcerne essentiellement les terrains découverts (Ex : terrain de basket, terrain de handball, terrain multisports...).\r\nPour les terrains couverts (dans des salles), utiliser "Gymnase" ou "Salle des sports".',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 707,
          libelleFr: "Terrain de tennis",
          ordre: 115,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 710,
          libelleFr: "Terrain clos",
          ordre: 183,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 22,
            libelleFr: "Extérieurs",
            ordre: 65,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 715,
          libelleFr: "Bar",
          ordre: 40,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 723,
          libelleFr: "Terrasse",
          ordre: 187,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 22,
            libelleFr: "Extérieurs",
            ordre: 65,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 776,
          libelleFr: "Abris voiture",
          ordre: 216,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 126,
            libelleFr: "Stationnement",
            ordre: 155,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 801,
          libelleFr: "Barrière automatique",
          ordre: 219,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 126,
            libelleFr: "Stationnement",
            ordre: 155,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 803,
          libelleFr: "Barbecue",
          ordre: 41,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 804,
          libelleFr: "Climatisation",
          ordre: 147,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 125,
            libelleFr: "Equipements intérieurs",
            ordre: 62,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 812,
          libelleFr: "Local pêche",
          ordre: 207,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 127,
            libelleFr: "Local à usage spécifique",
            ordre: 79,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 822,
          libelleFr: "Salle d'exposition",
          ordre: 72,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 24,
            libelleFr: "Equipements de loisirs culturels",
            ordre: 60,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 826,
          libelleFr: "Bibliothèque",
          ordre: 70,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 24,
            libelleFr: "Equipements de loisirs culturels",
            ordre: 60,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 827,
          libelleFr: "Terrain clos commun",
          ordre: 184,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 22,
            libelleFr: "Extérieurs",
            ordre: 65,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 829,
          libelleFr: "Equipement de Tir à l'arc",
          ordre: 82,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 830,
          libelleFr: "Trampoline",
          ordre: 116,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 836,
          libelleFr: "Billard",
          ordre: 42,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 852,
          libelleFr: "Restaurant climatisé",
          ordre: 152,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 125,
            libelleFr: "Equipements intérieurs",
            ordre: 62,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 860,
          libelleFr:
            "Boulodrome / Terrain de pétanque / Terrain de boule de fort",
          ordre: 79,
          description:
            "Un boulodrome est un terrain ou une salle de sports aménagé pour l'entraînement et les compétitions de la pratique des jeux de boules et de quilles (pétanque, boule lyonnaise, boule bretonne, jeu provençal, boule de fort...).",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 912,
          libelleFr: "Infirmerie",
          ordre: 201,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 127,
            libelleFr: "Local à usage spécifique",
            ordre: 79,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 914,
          libelleFr: "Laverie",
          ordre: 202,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 127,
            libelleFr: "Local à usage spécifique",
            ordre: 79,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 929,
          libelleFr: "Nursery",
          ordre: 208,
          description:
            "Local où l'on peut changer les bébés, chauffer les biberons...",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 127,
            libelleFr: "Local à usage spécifique",
            ordre: 79,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 931,
          libelleFr: "Pataugeoire",
          ordre: 48,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 948,
          libelleFr: "Etang de pêche",
          ordre: 83,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 957,
          libelleFr: "Bains à remous",
          ordre: 160,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 23,
            libelleFr: "Equipements santé bien-être",
            ordre: 64,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 972,
          libelleFr: "Parking",
          ordre: 221,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 126,
            libelleFr: "Stationnement",
            ordre: 155,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 975,
          libelleFr: "Cabine téléphonique / Point Phone",
          ordre: 144,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 125,
            libelleFr: "Equipements intérieurs",
            ordre: 62,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 976,
          libelleFr: "Sèche chaussures",
          ordre: 210,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 127,
            libelleFr: "Local à usage spécifique",
            ordre: 79,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 978,
          libelleFr: "Table d'orientation",
          ordre: 65,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 984,
          libelleFr: "Défibrillateur",
          ordre: 236,
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1030,
          libelleFr: "Equipements développement durable",
          ordre: 22,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 37,
            libelleFr: "Démarche écoresponsable",
            ordre: 46,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1038,
          libelleFr: "Espace fitness",
          ordre: 166,
          description:
            "Espace situé soit dans un centre de remise en forme, un hôtel,  un centre thermal, une piscine pour pratiquer des activités physiques visant à améliorer sa condition physique et son hygiène de vie.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 23,
            libelleFr: "Equipements santé bien-être",
            ordre: 64,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1050,
          libelleFr: "Garage",
          ordre: 232,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 126,
            libelleFr: "Stationnement",
            ordre: 155,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1054,
          libelleFr: "Hammam",
          ordre: 170,
          description: "Bain de vapeur (chaleur humide)",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 23,
            libelleFr: "Equipements santé bien-être",
            ordre: 64,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1057,
          libelleFr: "Espace Spa",
          ordre: 168,
          description:
            'Espace bien-être comportant de nombreux équipements et prestations : sauna, hammam, bains à remous, soins, …\r\n\r\nSi vous avez uniquement un "jacuzzi" ou "spa", utilisez le critère "Bain à remous"',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 23,
            libelleFr: "Equipements santé bien-être",
            ordre: 64,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1058,
          libelleFr: "Jardin",
          ordre: 193,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 22,
            libelleFr: "Extérieurs",
            ordre: 65,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1064,
          libelleFr: "Local matériel fermé",
          ordre: 206,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 127,
            libelleFr: "Local à usage spécifique",
            ordre: 79,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1081,
          libelleFr: "Minigolf",
          ordre: 47,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1089,
          libelleFr: "Parc",
          ordre: 181,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 22,
            libelleFr: "Extérieurs",
            ordre: 65,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1092,
          libelleFr: "Piano bar",
          ordre: 50,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1093,
          libelleFr: "Piscine",
          ordre: 97,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1100,
          libelleFr: "Plage",
          ordre: 51,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1102,
          libelleFr: "Plan d'eau",
          ordre: 54,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1106,
          libelleFr: "Restaurant",
          ordre: 151,
          description:
            "Permet d'identifier les restaurants à l'intérieur d'un objet (de type hébergement ou patrimoine culturel)",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 125,
            libelleFr: "Equipements intérieurs",
            ordre: 62,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1290,
          libelleFr: "Salle d'animation",
          ordre: 59,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1297,
          libelleFr: "Salle de jeux",
          ordre: 61,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1298,
          libelleFr: "Salle de projection",
          ordre: 62,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1300,
          libelleFr: "Salle de réunion",
          ordre: 142,
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1318,
          libelleFr: "Parking couvert",
          ordre: 222,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 126,
            libelleFr: "Stationnement",
            ordre: 155,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 972,
            libelleFr: "Parking",
            ordre: 221,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1321,
          libelleFr: "Parking à proximité",
          ordre: 230,
          description:
            'A 500 m maxi\r\nNe concerne que les parkings publics, sinon utiliser "parking privé"',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 126,
            libelleFr: "Stationnement",
            ordre: 155,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1322,
          libelleFr: "Parking autocar",
          ordre: 228,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 126,
            libelleFr: "Stationnement",
            ordre: 155,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 972,
            libelleFr: "Parking",
            ordre: 221,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1323,
          libelleFr: "Parking privé",
          ordre: 226,
          description:
            'Parking d\'un hotel, musée, commerces... gratuit.\r\nSi le parking est payant, cocher également "parking payant".\r\nSi le site ne possède pas de parking privé, cocher "parking à proximité" s\'il est à - de 500 m.',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 126,
            libelleFr: "Stationnement",
            ordre: 155,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 972,
            libelleFr: "Parking",
            ordre: 221,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1373,
          libelleFr: "Toilettes sèches",
          ordre: 31,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 37,
            libelleFr: "Démarche écoresponsable",
            ordre: 46,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1030,
            libelleFr: "Equipements développement durable",
            ordre: 22,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1375,
          libelleFr: "Eau chaude solaire",
          ordre: 24,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 37,
            libelleFr: "Démarche écoresponsable",
            ordre: 46,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1030,
            libelleFr: "Equipements développement durable",
            ordre: 22,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1376,
          libelleFr: "Eolienne",
          ordre: 25,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 37,
            libelleFr: "Démarche écoresponsable",
            ordre: 46,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1030,
            libelleFr: "Equipements développement durable",
            ordre: 22,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1378,
          libelleFr: "Gestion des déchets",
          ordre: 28,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 37,
            libelleFr: "Démarche écoresponsable",
            ordre: 46,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1030,
            libelleFr: "Equipements développement durable",
            ordre: 22,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1381,
          libelleFr: "Panneau photovoltaïque",
          ordre: 29,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 37,
            libelleFr: "Démarche écoresponsable",
            ordre: 46,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1030,
            libelleFr: "Equipements développement durable",
            ordre: 22,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1384,
          libelleFr: "Géothermie",
          ordre: 27,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 37,
            libelleFr: "Démarche écoresponsable",
            ordre: 46,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1030,
            libelleFr: "Equipements développement durable",
            ordre: 22,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1388,
          libelleFr: "Epuration phytosanitaire",
          ordre: 26,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 37,
            libelleFr: "Démarche écoresponsable",
            ordre: 46,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1030,
            libelleFr: "Equipements développement durable",
            ordre: 22,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1421,
          libelleFr: "Garage privé",
          ordre: 234,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 126,
            libelleFr: "Stationnement",
            ordre: 155,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1050,
            libelleFr: "Garage",
            ordre: 232,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1504,
          libelleFr: "Piscine chauffée",
          ordre: 103,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1093,
            libelleFr: "Piscine",
            ordre: 97,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1505,
          libelleFr: "Piscine collective",
          ordre: 102,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1093,
            libelleFr: "Piscine",
            ordre: 97,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1506,
          libelleFr: "Piscine couverte",
          ordre: 100,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1093,
            libelleFr: "Piscine",
            ordre: 97,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1507,
          libelleFr: "Piscine enfants",
          ordre: 99,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1093,
            libelleFr: "Piscine",
            ordre: 97,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 1508,
          libelleFr: "Piscine plein air",
          ordre: 98,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1093,
            libelleFr: "Piscine",
            ordre: 97,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 3833,
          libelleFr: "Récupérateurs d'eau de pluie",
          ordre: 30,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 37,
            libelleFr: "Démarche écoresponsable",
            ordre: 46,
          },
          parent: {
            elementReferenceType: "PrestationEquipement",
            id: 1030,
            libelleFr: "Equipements développement durable",
            ordre: 22,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 4054,
          libelleFr: "Appareil à raclette",
          ordre: 37,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 4055,
          libelleFr: "Appareil à fondue",
          ordre: 38,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 4062,
          libelleFr: "Baby-foot",
          ordre: 39,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 4063,
          libelleFr: "Jeux de société",
          ordre: 46,
          description:
            "Ce critère permet d'identifier les prestataires (hébergeurs, restaurants...) qui mettent des jeux à disposition sur place.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 122,
            libelleFr: "Equipements de loisirs",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 4554,
          libelleFr: "Table de ping pong",
          ordre: 112,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 123,
            libelleFr: "Equipements de loisirs sportifs",
            ordre: 61,
          },
        },
        {
          elementReferenceType: "PrestationEquipement",
          id: 4562,
          libelleFr: "Rétroprojecteur",
          ordre: 153,
          description: "Concerne les équipements des salles de classes",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 125,
            libelleFr: "Equipements intérieurs",
            ordre: 62,
          },
        },
      ],
      services: [
        {
          elementReferenceType: "PrestationService",
          id: 683,
          libelleFr: "Accueil nuit",
          ordre: 21,
          description:
            "Accueil organisé avec une présence physique pendant les horaires de nuit",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 687,
          libelleFr: "Animaux acceptés",
          ordre: 376,
          description:
            'Indique que les animaux sont acceptés sur l’offre.\r\n\r\nCe critère n\'est pas visible en saisie, il est automatiquement appliqué lorsque l’on coche "Animaux acceptés" → "Oui" dans le bloc Accueil des animaux.',
        },
        {
          elementReferenceType: "PrestationService",
          id: 693,
          libelleFr: "Alimentation/Point alimentation",
          ordre: 107,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 82,
            libelleFr: "Commerces",
            ordre: 28,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 734,
          libelleFr: "Baby Club",
          ordre: 8,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 77,
            libelleFr: "Accueil enfants",
            ordre: 5,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 738,
          libelleFr: "Baby-sitter",
          ordre: 9,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 77,
            libelleFr: "Accueil enfants",
            ordre: 5,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 781,
          libelleFr: "Accès autocar",
          ordre: 87,
          description:
            "Concerne tous les objets accessibles aux bus (route praticable...)",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 80,
            libelleFr: "Aide au client / transport",
            ordre: 9,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 791,
          libelleFr: "Coin repassage",
          ordre: 34,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 837,
          libelleFr: "Gestion libre",
          ordre: 161,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 117,
            libelleFr: "Formule d'hébergement",
            ordre: 68,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 916,
          libelleFr: "Location de salles",
          ordre: 296,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 118,
            libelleFr: "Location / Prêt",
            ordre: 80,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 921,
          libelleFr: "Pension complète",
          ordre: 163,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 117,
            libelleFr: "Formule d'hébergement",
            ordre: 68,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 926,
          libelleFr: "Petit déjeuner",
          ordre: 165,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 117,
            libelleFr: "Formule d'hébergement",
            ordre: 68,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 934,
          libelleFr: "Prêt de vélos",
          ordre: 329,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4168,
            libelleFr: "Location de cycles",
            ordre: 82,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 993,
          libelleFr: "Réservation",
          ordre: 82,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 79,
            libelleFr: "Aide au client / réservation",
            ordre: 8,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1017,
          libelleFr: "Salon de coiffure",
          ordre: 101,
          description:
            "Concerne les hébergements qui proposent la prestation au sein de l'établissement",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 81,
            libelleFr: "Bien-être",
            ordre: 23,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1018,
          libelleFr: "Blanchisserie",
          ordre: 109,
          description:
            'Utiliser le critère "Blanchisserie" pour la prestation assurée par le commerçant.  \r\nLa laverie est un équipement à disposition des clients.',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 82,
            libelleFr: "Commerces",
            ordre: 28,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1020,
          libelleFr: "Soins esthétiques",
          ordre: 104,
          description:
            "Concerne les hébergements qui proposent la prestation au sein de l'établissement",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 81,
            libelleFr: "Bien-être",
            ordre: 23,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1025,
          libelleFr: "Animaux avec supplément",
          ordre: 377,
          description:
            'Indique que les animaux sont acceptés sur l’offre, avec un supplément.\r\n\r\nCe critère n\'est pas visible en saisie, il est automatiquement appliqué lorsque l’on coche "Animaux acceptés" → "Oui", puis "Animaux acceptés avec supplément" --> "Oui" dans le bloc Accueil des animaux.',
        },
        {
          elementReferenceType: "PrestationService",
          id: 1026,
          libelleFr: "Boutique",
          ordre: 112,
          description:
            "Concerne les espaces de vente propre à l'objet\r\nBoutique de musée, d'une grotte, d'un hébergement qui vend notamment des objets à son effigie...",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 82,
            libelleFr: "Commerces",
            ordre: 28,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1028,
          libelleFr: "Location de draps",
          ordre: 282,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 118,
            libelleFr: "Location / Prêt",
            ordre: 80,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1029,
          libelleFr: "Ménage avec supplément",
          ordre: 57,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1072,
          libelleFr: "Navette",
          ordre: 93,
          description:
            "Concerne tous les types de navettes, partagées et/ou privées, par exemple : dans les stations de ski, vers d'autres activités...\r\nsauf vers les aéroports et les gares",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 80,
            libelleFr: "Aide au client / transport",
            ordre: 9,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1086,
          libelleFr: "Dépose sur site pour les groupes",
          ordre: 91,
          description:
            'Permet d\'identifier les sites touristiques, hébergements, restaurants... disposant d\'une de zone de stationnement temporaire pour les bus.\r\nLe stationnement est limité dans le temps.\r\n\r\nQuand il n\'y a pas de restriction de durée de stationnement, utilisez le critère "Parking autocar" dans l\'onglet "Prestations" et "Equipements"',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 80,
            libelleFr: "Aide au client / transport",
            ordre: 9,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1088,
          libelleFr: "Animateur permanent",
          ordre: 23,
          description:
            "L'établissement ou le site (naturel, culturel) dispose d'une ressource humaine salariée de la structure à disposition du grand public. Cet animateur propose des animations, sorties... aux clients de l'établissement ou du site.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1110,
          libelleFr: "Prêt de matériel",
          ordre: 294,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 118,
            libelleFr: "Location / Prêt",
            ordre: 80,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1111,
          libelleFr: "Bagagerie",
          ordre: 25,
          description:
            "Service de bagagerie = pièce où les clients peuvent laisser leurs bagages en attendant d'avoir leur chambre",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1112,
          libelleFr: "Location de canoës / kayaks",
          ordre: 243,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4170,
            libelleFr: "Location de petites embarcations nautiques",
            ordre: 85,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1113,
          libelleFr: "Vente de cartes de pêche",
          ordre: 189,
          description: "Concerne les dépositaires de cartes de pêche",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4357,
            libelleFr: "Pêche",
            ordre: 102,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1115,
          libelleFr: "Accès Internet Wifi",
          ordre: 16,
          description: "Pour les hébergements, concerne les espaces communs",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1118,
          libelleFr: "Circuits touristiques",
          ordre: 31,
          description:
            "Prestation organisée par l'hébergeur ou responsable de site",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1119,
          libelleFr: "Club Adolescents",
          ordre: 10,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 77,
            libelleFr: "Accueil enfants",
            ordre: 5,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1121,
          libelleFr: "Club enfants",
          ordre: 12,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 77,
            libelleFr: "Accueil enfants",
            ordre: 5,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1122,
          libelleFr: "Coffres réception",
          ordre: 33,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1126,
          libelleFr: "Cyber espace / bornes accès Internet",
          ordre: 37,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1127,
          libelleFr: "Demi-pension",
          ordre: 159,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 117,
            libelleFr: "Formule d'hébergement",
            ordre: 68,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1130,
          libelleFr: "Documentation Touristique",
          ordre: 39,
          description:
            "Documentations diverses et gratuites à disposition des clients",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1134,
          libelleFr: "Garderie",
          ordre: 14,
          description: "Accueil et surveillance collective de jeunes enfants",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 77,
            libelleFr: "Accueil enfants",
            ordre: 5,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1135,
          libelleFr: "Halte Garderie",
          ordre: 15,
          description:
            "Accueil d'enfants de 3 mois à 6 ans pour une durée limitée et occasionnellement",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 77,
            libelleFr: "Accueil enfants",
            ordre: 5,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1145,
          libelleFr: "Location de linge",
          ordre: 283,
          description: "Concerne le linge autre que les draps",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 118,
            libelleFr: "Location / Prêt",
            ordre: 80,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1146,
          libelleFr: "Location de matériel",
          ordre: 284,
          description:
            "Concerne la location de matériel autre que celui de la liste (exemples : micro-onde, matériel sportif...)",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 118,
            libelleFr: "Location / Prêt",
            ordre: 80,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1150,
          libelleFr: "Location de TV",
          ordre: 297,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 118,
            libelleFr: "Location / Prêt",
            ordre: 80,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1151,
          libelleFr: "Location de vélos",
          ordre: 310,
          description:
            "concerne les locations de vélo de tourisme\r\npour les vélos de course, un critère spécifique est disponible",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4168,
            libelleFr: "Location de cycles",
            ordre: 82,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1157,
          libelleFr: "Massages / Modelages",
          ordre: 100,
          description:
            "Concerne les hébergements, équipements et certains commerces et services qui proposent la prestation au sein de l'établissement",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 81,
            libelleFr: "Bien-être",
            ordre: 23,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1163,
          libelleFr: "Navette aéroport ou gare",
          ordre: 94,
          description:
            "L'hébergeur a sa propre navette et assure les dessertes vers la gare ou l'aéroport.\r\nSi l'hébergeur n'a pas de navette mais qu'un arrêt de transport en commun se trouve à proximité et permet de se rendre à la gare ou l'aéroport, aller dans l'onglet localisation, environnement, cocher le critère \"à proximité d'un arrêt de transport en commun\" ou \"à proximité d'un arrêt navette\"",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 80,
            libelleFr: "Aide au client / transport",
            ordre: 9,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1166,
          libelleFr: "Ménage en fin de séjour",
          ordre: 58,
          description: "Prestation de l'hébergeur comprise",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1169,
          libelleFr: "Point argent",
          ordre: 61,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1172,
          libelleFr: "Réservation de prestations",
          ordre: 85,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 79,
            libelleFr: "Aide au client / réservation",
            ordre: 8,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1177,
          libelleFr: "Restauration",
          ordre: 200,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 119,
            libelleFr: "Restauration",
            ordre: 122,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1212,
          libelleFr: "Restauration rapide",
          ordre: 214,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 119,
            libelleFr: "Restauration",
            ordre: 122,
          },
          parent: {
            elementReferenceType: "PrestationService",
            id: 1177,
            libelleFr: "Restauration",
            ordre: 200,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1216,
          libelleFr: "Paniers Pique-nique",
          ordre: 206,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 119,
            libelleFr: "Restauration",
            ordre: 122,
          },
          parent: {
            elementReferenceType: "PrestationService",
            id: 1177,
            libelleFr: "Restauration",
            ordre: 200,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1217,
          libelleFr: "Plats à emporter/Plats cuisinés",
          ordre: 207,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 119,
            libelleFr: "Restauration",
            ordre: 122,
          },
          parent: {
            elementReferenceType: "PrestationService",
            id: 1177,
            libelleFr: "Restauration",
            ordre: 200,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 1223,
          libelleFr: "Traiteur",
          ordre: 225,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 119,
            libelleFr: "Restauration",
            ordre: 122,
          },
          parent: {
            elementReferenceType: "PrestationService",
            id: 1177,
            libelleFr: "Restauration",
            ordre: 200,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 3695,
          libelleFr: "Location ski de fond",
          ordre: 231,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4169,
            libelleFr: "Location de matériel de sports d'hiver",
            ordre: 84,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 3699,
          libelleFr: "Location ski alpin",
          ordre: 230,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4169,
            libelleFr: "Location de matériel de sports d'hiver",
            ordre: 84,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 3889,
          libelleFr: "Location de VTT",
          ordre: 324,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4168,
            libelleFr: "Location de cycles",
            ordre: 82,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 4064,
          libelleFr: "Kit de réparation cycles",
          ordre: 51,
          description:
            'Outils en libre-service / borne, permet de réparer son vélo soi-même.\r\n\r\nSi c\'est un service par un mécanicien, utiliser "Réparation de cycle".',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 4143,
          libelleFr: "Location de vélos à assistance électrique",
          ordre: 322,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4168,
            libelleFr: "Location de cycles",
            ordre: 82,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 4580,
          libelleFr: "Equipe d’animation sur demande",
          ordre: 43,
          description:
            "Permet d'identifier les hébergements collectifs qui n’ont pas d’équipe d’animation permanente mais qui sont en mesure d’en proposer une si l'organisateur de séjour colo ou l’enseignant en fait la demande",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 4581,
          libelleFr: "Equipe d’animation sur place",
          ordre: 44,
          description:
            "Permet d'identifier les hébergements collectifs qui accueillent des enfants dans le cadre d’une colonie ou d’une classe de découvertes et qui ont une équipe d'animation permanente au sein de leur structure.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 4582,
          libelleFr: "Bus à disposition",
          ordre: 90,
          description:
            "Permet d'identifier les hébergements qui disposent d'un bus de 16 personnes ou plus et le mette à disposition des clients pour leurs excursions. Le chauffeur est fourni par l'hébergeur.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 80,
            libelleFr: "Aide au client / transport",
            ordre: 9,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 4583,
          libelleFr: "Minibus à disposition",
          ordre: 92,
          description:
            "Permet d’identifier les hébergements qui disposent d’un bus de 15 personnes maximum, et le mette à disposition des clients pour leurs excursions. Le chauffeur est fourni par l’hébergeur.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 80,
            libelleFr: "Aide au client / transport",
            ordre: 9,
          },
        },
        {
          elementReferenceType: "PrestationService",
          id: 4871,
          libelleFr: "Pension équestre",
          ordre: 60,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 78,
            libelleFr: "Aide au client / pratique",
            ordre: 7,
          },
        },
      ],
      animauxAcceptes: "ACCEPTES",
      animauxAcceptesSupplement: "AVEC_SUPPLEMENT",
      descriptifAnimauxAcceptes: {
        libelleFr: "Conditions d'accueil des animaux",
      },
      activites: [
        {
          elementReferenceType: "PrestationActivite",
          id: 582,
          libelleFr: "Animation",
          ordre: 2,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 106,
            libelleFr: "Animation",
            ordre: 11,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 599,
          libelleFr: "Baignade surveillée",
          ordre: 67,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3922,
            libelleFr: "Sports d'eau",
            ordre: 65,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 602,
          libelleFr: "Canotage",
          ordre: 69,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3922,
            libelleFr: "Sports d'eau",
            ordre: 65,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 609,
          libelleFr: "Rafting",
          ordre: 117,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 708,
            libelleFr: "Sports en eaux vives",
            ordre: 114,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 611,
          libelleFr: "Animation enfants",
          ordre: 3,
          description:
            "Animation proposée au sein d'un hébergement professionnel (sauf meublés), de sites naturels, sites culturels par un personnel compétent pour encadrer les enfants.\r\nL'information concernant les animations enfants peut être saisie dans \"le bon plan\", onglet présentation. Penser à saisir la tranche d'âge des enfants concernés par l'animation.\r\nPenser à cocher le public \"enfants\", onglet prestations.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 106,
            libelleFr: "Animation",
            ordre: 11,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 615,
          libelleFr: "Luge",
          ordre: 80,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3923,
            libelleFr: "Sports d'hiver",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 616,
          libelleFr: "Cascade de glace",
          ordre: 104,
          description:
            "La cascade de glace est une discipline dérivée de l'escalade.\r\nElle consiste à grimper le long de formations glaciaires, comme les cascades gelées\r\nen hiver ou les parois de glaciers comme des goulottes ou des couloirs, qui peuvent\r\nse pratiquer en été si les conditions sont bonnes (les séracs sont généralement\r\ndéconseillés car ils sont très fragiles).",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3925,
            libelleFr: "Sports de glace",
            ordre: 103,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 617,
          libelleFr: "Héliski",
          ordre: 36,
          description:
            "Pratique de ski hors piste où les skieurs sont déposés en\r\nhélicoptère.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3917,
            libelleFr: "Ski",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 618,
          libelleFr: "Free ride",
          ordre: 35,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3917,
            libelleFr: "Ski",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 619,
          libelleFr: "Chasse",
          ordre: 64,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3921,
            libelleFr: "Sports d'adresse",
            ordre: 62,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 620,
          libelleFr: "Kilomètre lancé",
          ordre: 38,
          description:
            "Le ski de vitesse ou kilomètre lancé (KL) est un sport qui\r\nconsiste à descendre une piste enneigée le plus vite possible.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3917,
            libelleFr: "Ski",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 621,
          libelleFr: "Plongée sous glace",
          ordre: 83,
          description:
            "La plongée sous glace est une forme particulière de plongée qui nécessite un\r\néquipement spécifique ainsi qu'une sérieuse préparation afin d'éviter les accidents\r\ndus à une immersion en eau froide non prévue ou une perte de plongeurs sous l'eau.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3923,
            libelleFr: "Sports d'hiver",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 622,
          libelleFr: "Scooter des neiges",
          ordre: 85,
          description:
            "Une motoneige (également appelée scooter des neiges en France) est un petit véhicule motorisé, mu à l'aide d'une ou deux chenilles, et équipé de skis pour la direction. Inventée au Québec par Joseph-Armand Bombardier, elle s'est répandue dans le monde entier.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3923,
            libelleFr: "Sports d'hiver",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 623,
          libelleFr: "Ski joëring",
          ordre: 44,
          description:
            "Le ski joëring est une discipline sportive alliant le ski et l'attelage équestre, bien qu'il\r\nexiste une forme canine de l'activité. Il se pratique avec un cheval ou un poney attelé\r\nqui tire le skieur grâce à un cadre rigide.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3917,
            libelleFr: "Ski",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 625,
          libelleFr: "Ski nocturne",
          ordre: 45,
          description:
            "Pratique du ski à la nuit tombée (ouverture de certaines pistes du domaine skiable).",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3917,
            libelleFr: "Ski",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 626,
          libelleFr: "Snowbike / Snowscoot",
          ordre: 87,
          description:
            "Le snowscoot est un sport d'hiver né dans les années 1990, se pratiquant en glissant\r\nsur la neige à l'aide d'un engin. Il se pratique dans le même environnement que le ski\r\nalpin ou le snowboard, dans des stations de ski ou en hors piste, et ce dans toutes les\r\nconditions de neige. Le snowscoot est un engin composé d'un cadre, de deux planches\r\ndifférentes similaires à des snowboards, d'une fourche et d'un guidon pour orienter la\r\nplanche avant. La planche arrière est fixée au cadre et celle avant est solidaire de la\r\nfourche.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3923,
            libelleFr: "Sports d'hiver",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 627,
          libelleFr: "Speed riding",
          ordre: 57,
          description:
            "Le speed riding est un sport associant le ski, le parapente et le parachutisme dont le\r\nprincipe est de descendre les pentes enneigés équipé d'une paire de skis, d'une sellette\r\net d'une voile de faible surface, en alternant la glisse et le vol.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3919,
            libelleFr: "Sports aériens",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 628,
          libelleFr: "Snowkite",
          ordre: 56,
          description:
            "Le snowkite est le pendant du kitesurf en sport d'hiver, la planche de surf étant\r\nremplacée dans cette discipline par un snowboard, ou des skis. Il est ainsi possible\r\nd'atteindre des vitesses de plus de 70km/h.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3919,
            libelleFr: "Sports aériens",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 629,
          libelleFr: "VTT sur neige",
          ordre: 89,
          description:
            "Un nouveau sport fait son apparition à la montagne, le VTT sur neige. Il permet aux\r\namateurs de sensations fortes de dévaler les pistes à toute vitesse.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3923,
            libelleFr: "Sports d'hiver",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 630,
          libelleFr: "Snowskate",
          ordre: 88,
          description:
            "Le snowskate est un compromis entre le skateboard et le snowboard, d'où son nom.\r\nComme son cousin des stations hivernales, il se pratique sur des pistes enneigées.\r\nToutefois, les planches sont plus petites - de la taille d'une planche de skate - et le\r\nsnowskateur n'y est pas fixé (une corde doit toutefois relier le pied du snowskateur à sa\r\nplanche afin de ne pas perdre cette dernière lors des chutes). Ces caractéristiques en\r\nfont un sport extrême très technique.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3923,
            libelleFr: "Sports d'hiver",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 632,
          libelleFr: "Télémark",
          ordre: 49,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3917,
            libelleFr: "Ski",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 633,
          libelleFr: "Air board",
          ordre: 78,
          description:
            "L'airboard des neiges est une luge moderne gonflable munie de poignées qui permet \r\nde dévaler les pistes à toute vitesse.\r\nPour une bonne glisse, le pratiquant s'allonge sur l'engin et le dirige en déplaçant \r\nle poids de son corps. L'airboard se pratique sur les pistes de luge ou en hors-piste.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3923,
            libelleFr: "Sports d'hiver",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 634,
          libelleFr: "Biathlon",
          ordre: 34,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3917,
            libelleFr: "Ski",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 635,
          libelleFr: "Luge nocturne",
          ordre: 81,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3923,
            libelleFr: "Sports d'hiver",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 636,
          libelleFr: "Paret",
          ordre: 82,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3923,
            libelleFr: "Sports d'hiver",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 637,
          libelleFr: "Snake gliss",
          ordre: 86,
          description:
            "Le snake-gliss est un concept de luge collective ludique. Les luges, toutes identiques, s'assemblent les\r\nunes aux autres par un axe amovible pour former un unique train capable d'effectuer de vrais virages\r\net de procurer des sensations inédites.\r\nCette activité est praticable dans le cadre d'une prestation encadrée par un accompagnateur habilité \r\nqui pilote l'engin.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3923,
            libelleFr: "Sports d'hiver",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 638,
          libelleFr: "Taxi ski",
          ordre: 52,
          description:
            "Le taxi ski est une nouvelle façon de glisser à tout âge et en toute sécurité pour se promener et découvrir nos domaines skiables. Le pratiquant est installé confortablement dans un fauteuil\r\nhomologué, équipé de skis, jambes étendues, tête reposée. Le passager se laisse piloter par un\r\nmoniteur diplômé, qui se tient à l'arrière du taxi ski.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3918,
            libelleFr: "Sports adaptés pour personnes handicapées",
            ordre: 50,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 639,
          libelleFr: "Yooner",
          ordre: 90,
          description:
            "Le yooner est un engin de glisse inspiré du paret. Il est composé d'un siège, d'un patin central\r\net d'un manche qui sert à guider l'engin et à freiner. Assis sur l'engin, le pilote du yooner trouve\r\nson équilibre grâce à l'appui des pieds.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3923,
            libelleFr: "Sports d'hiver",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 643,
          libelleFr: "Dégustation de produits",
          ordre: 13,
          description:
            "concerne également les mâchons, planches, casse-croûte... etc",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 106,
            libelleFr: "Animation",
            ordre: 11,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 644,
          libelleFr: "Equitation",
          ordre: 119,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3928,
            libelleFr: "Sports équestres",
            ordre: 118,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 646,
          libelleFr: "Escalade",
          ordre: 107,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 709,
            libelleFr: "Sports de grimpe / Sports de corde",
            ordre: 105,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 653,
          libelleFr: "Golf",
          ordre: 95,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3924,
            libelleFr: "Sports de balle",
            ordre: 91,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 659,
          libelleFr: "Montgolfière",
          ordre: 54,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3919,
            libelleFr: "Sports aériens",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 664,
          libelleFr: "Parapente",
          ordre: 55,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3919,
            libelleFr: "Sports aériens",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 668,
          libelleFr: "Pêche",
          ordre: 71,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3922,
            libelleFr: "Sports d'eau",
            ordre: 65,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 669,
          libelleFr: "Pétanque",
          ordre: 112,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3926,
            libelleFr: "Sports divers",
            ordre: 110,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 671,
          libelleFr: "Ping-pong",
          ordre: 98,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3924,
            libelleFr: "Sports de balle",
            ordre: 91,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 678,
          libelleFr: "Planche à voile",
          ordre: 72,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3922,
            libelleFr: "Sports d'eau",
            ordre: 65,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 680,
          libelleFr: "Randonnée pédestre / balade à pied",
          ordre: 121,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3927,
            libelleFr: "Sports pédestres",
            ordre: 120,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 688,
          libelleFr: "Ski alpin",
          ordre: 39,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3917,
            libelleFr: "Ski",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 689,
          libelleFr: "Ski nordique",
          ordre: 46,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3917,
            libelleFr: "Ski",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 690,
          libelleFr: "Snowboard",
          ordre: 48,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3917,
            libelleFr: "Ski",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 691,
          libelleFr: "Animations de soirées",
          ordre: 5,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 106,
            libelleFr: "Animation",
            ordre: 11,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 702,
          libelleFr: "Spéléologie",
          ordre: 109,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 709,
            libelleFr: "Sports de grimpe / Sports de corde",
            ordre: 105,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 708,
          libelleFr: "Sports en eaux vives",
          ordre: 114,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 709,
          libelleFr: "Sports de grimpe / Sports de corde",
          ordre: 105,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 724,
          libelleFr: "Tennis",
          ordre: 101,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3924,
            libelleFr: "Sports de balle",
            ordre: 91,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 733,
          libelleFr: "Voile",
          ordre: 75,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3922,
            libelleFr: "Sports d'eau",
            ordre: 65,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 737,
          libelleFr: "VTT",
          ordre: 61,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3920,
            libelleFr: "Sports cyclistes",
            ordre: 59,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 749,
          libelleFr: "Alpinisme",
          ordre: 106,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 709,
            libelleFr: "Sports de grimpe / Sports de corde",
            ordre: 105,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 751,
          libelleFr: "Aviron",
          ordre: 66,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3922,
            libelleFr: "Sports d'eau",
            ordre: 65,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 755,
          libelleFr: "Chiens de traîneau",
          ordre: 79,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3923,
            libelleFr: "Sports d'hiver",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 773,
          libelleFr: "Raquettes",
          ordre: 84,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3923,
            libelleFr: "Sports d'hiver",
            ordre: 77,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 777,
          libelleFr: "Relaxation",
          ordre: 28,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 32,
            libelleFr: "Forme et bien-être",
            ordre: 67,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 778,
          libelleFr: "Ski d'été",
          ordre: 41,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3917,
            libelleFr: "Ski",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 779,
          libelleFr: "Ski nautique",
          ordre: 74,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3922,
            libelleFr: "Sports d'eau",
            ordre: 65,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 786,
          libelleFr: "U.L.M.",
          ordre: 58,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 3919,
            libelleFr: "Sports aériens",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 3917,
          libelleFr: "Ski",
          ordre: 33,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 3918,
          libelleFr: "Sports adaptés pour personnes handicapées",
          ordre: 50,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 3919,
          libelleFr: "Sports aériens",
          ordre: 53,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 3920,
          libelleFr: "Sports cyclistes",
          ordre: 59,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 3921,
          libelleFr: "Sports d'adresse",
          ordre: 62,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 3922,
          libelleFr: "Sports d'eau",
          ordre: 65,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 3923,
          libelleFr: "Sports d'hiver",
          ordre: 77,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 3924,
          libelleFr: "Sports de balle",
          ordre: 91,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 3925,
          libelleFr: "Sports de glace",
          ordre: 103,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 3926,
          libelleFr: "Sports divers",
          ordre: 110,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 3927,
          libelleFr: "Sports pédestres",
          ordre: 120,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 3928,
          libelleFr: "Sports équestres",
          ordre: 118,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
        },
        {
          elementReferenceType: "PrestationActivite",
          id: 4566,
          libelleFr: "Canoë Kayak",
          ordre: 115,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 110,
            libelleFr: "Sport",
            ordre: 137,
          },
          parent: {
            elementReferenceType: "PrestationActivite",
            id: 708,
            libelleFr: "Sports en eaux vives",
            ordre: 114,
          },
        },
      ],
      conforts: [
        {
          elementReferenceType: "PrestationConfort",
          id: 756,
          libelleFr: "Accès Internet privatif réseau",
          ordre: 63,
          description:
            "Accès internet dans les chambres ou les appartements par câble réseau",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 72,
            libelleFr: "Multimédia",
            ordre: 96,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 774,
          libelleFr: "Aspirateur",
          ordre: 32,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 796,
          libelleFr: "Baignoire",
          ordre: 82,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 73,
            libelleFr: "Sanitaires",
            ordre: 123,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 799,
          libelleFr: "Non fumeur",
          ordre: 99,
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 838,
          libelleFr: "Matériel Bébé",
          ordre: 25,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 842,
          libelleFr: "Accès Internet privatif Wifi",
          ordre: 64,
          description:
            "Accès internet wifi dans les chambres ou les appartements",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 72,
            libelleFr: "Multimédia",
            ordre: 96,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 847,
          libelleFr: "Lit 140 cm",
          ordre: 18,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 876,
          libelleFr: "Cuisine",
          ordre: 5,
          description:
            "Correspond à une cuisine (pièce indépendante).\r\nPour préciser un espace cuisine dans la pièce de vie principale, utiliser le critère Coin cuisine.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 68,
            libelleFr: "Configuration",
            ordre: 30,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 877,
          libelleFr: "Cheminée / Poêle",
          ordre: 57,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 71,
            libelleFr: "Energie",
            ordre: 54,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 880,
          libelleFr: "Lits superposés",
          ordre: 23,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 882,
          libelleFr: "Accès Internet privatif Wifi gratuit",
          ordre: 65,
          description:
            "Accès internet gratuit dans les chambres ou les appartements, wifi ou câble réseau",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 72,
            libelleFr: "Multimédia",
            ordre: 96,
          },
          parent: {
            elementReferenceType: "PrestationConfort",
            id: 842,
            libelleFr: "Accès Internet privatif Wifi",
            ordre: 64,
            description:
              "Accès internet wifi dans les chambres ou les appartements",
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 893,
          libelleFr: "Climatisation",
          ordre: 58,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 71,
            libelleFr: "Energie",
            ordre: 54,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 895,
          libelleFr: "Congélateur",
          ordre: 35,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 898,
          libelleFr: "Coin cuisine",
          ordre: 4,
          description:
            "Le présent critère correspond au Coin cuisine = cuisine dans la pièce de vie principale.\r\nPour préciser une cuisine (pièce indépendante), utiliser le critère Cuisine.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 68,
            libelleFr: "Configuration",
            ordre: 30,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 902,
          libelleFr: "Douche",
          ordre: 84,
          description:
            "Lorsque douche est coché sur les refuges, cela signifie que c'est une douche à l'eau froide. Si le refuge propose des douches à l'eau chaude, cocher l'autre critère uniquement.\r\n\r\nPour les autres types d'hébergements, il s'agit de douche à l'eau chaude, bien entendu, puisqu'ils n'ont pas les contraintes de l'isolement.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 73,
            libelleFr: "Sanitaires",
            ordre: 123,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 904,
          libelleFr: "Draps compris",
          ordre: 14,
          description: "Gratuit / avec ou sans supplément.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 907,
          libelleFr: "Four",
          ordre: 36,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 917,
          libelleFr: "Lave linge collectif",
          ordre: 39,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 919,
          libelleFr: "Lave linge privatif",
          ordre: 40,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 922,
          libelleFr: "Lave vaisselle",
          ordre: 41,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 935,
          libelleFr: "Mini-bar",
          ordre: 45,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 939,
          libelleFr: "Prise de télévision",
          ordre: 73,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 72,
            libelleFr: "Multimédia",
            ordre: 96,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 943,
          libelleFr: "Réfrigérateur",
          ordre: 48,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 946,
          libelleFr: "Sèche cheveux",
          ordre: 49,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 949,
          libelleFr: "Sèche linge collectif",
          ordre: 50,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 951,
          libelleFr: "Sèche serviettes",
          ordre: 52,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 960,
          libelleFr: "Téléphone",
          ordre: 77,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 72,
            libelleFr: "Multimédia",
            ordre: 96,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 963,
          libelleFr: "Télévision",
          ordre: 76,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 72,
            libelleFr: "Multimédia",
            ordre: 96,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 971,
          libelleFr: "Balcon",
          ordre: 1,
          description:
            "Concerne les balcons et terrasses privées notamment pour les meublés",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 68,
            libelleFr: "Configuration",
            ordre: 30,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 973,
          libelleFr: "Toilettes séparées",
          ordre: 94,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 73,
            libelleFr: "Sanitaires",
            ordre: 123,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 981,
          libelleFr: "Canapé",
          ordre: 10,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 983,
          libelleFr: "Canapé convertible",
          ordre: 11,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 997,
          libelleFr: "Hotte aspirante",
          ordre: 38,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 998,
          libelleFr: "Lecteur DVD",
          ordre: 70,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 72,
            libelleFr: "Multimédia",
            ordre: 96,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 999,
          libelleFr: "Micro-ondes",
          ordre: 44,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 1004,
          libelleFr: "Séjour / Salle à manger",
          ordre: 7,
          description:
            "Uniquement lorsque l'hébergeur/établissement met cet espace à disposition de sa clientèle.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 68,
            libelleFr: "Configuration",
            ordre: 30,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 1011,
          libelleFr: "Lit 90 cm",
          ordre: 17,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 1012,
          libelleFr: "Matériel de repassage",
          ordre: 42,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 70,
            libelleFr: "Electroménager",
            ordre: 53,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 1013,
          libelleFr: "Lit 160 cm",
          ordre: 19,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 1014,
          libelleFr: "Lit bébé",
          ordre: 27,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
          parent: {
            elementReferenceType: "PrestationConfort",
            id: 838,
            libelleFr: "Matériel Bébé",
            ordre: 25,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 1015,
          libelleFr: "Chaise bébé",
          ordre: 26,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
          parent: {
            elementReferenceType: "PrestationConfort",
            id: 838,
            libelleFr: "Matériel Bébé",
            ordre: 25,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 1016,
          libelleFr: "Table à langer",
          ordre: 31,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
          parent: {
            elementReferenceType: "PrestationConfort",
            id: 838,
            libelleFr: "Matériel Bébé",
            ordre: 25,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 3694,
          libelleFr: "Chambre familiale",
          ordre: 9,
          description:
            "Chambre avec plusieurs lits (parents et enfants sont dans la même chambre)",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 4060,
          libelleFr: "Baignoire bébé",
          ordre: 29,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
          parent: {
            elementReferenceType: "PrestationConfort",
            id: 838,
            libelleFr: "Matériel Bébé",
            ordre: 25,
          },
        },
        {
          elementReferenceType: "PrestationConfort",
          id: 4061,
          libelleFr: "Chauffe-biberon",
          ordre: 28,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 69,
            libelleFr: "Couchage et mobilier",
            ordre: 31,
          },
          parent: {
            elementReferenceType: "PrestationConfort",
            id: 838,
            libelleFr: "Matériel Bébé",
            ordre: 25,
          },
        },
      ],
      languesParlees: [
        {
          elementReferenceType: "Langue",
          id: 1200,
          libelleFr: "Italien",
          ordre: 18,
        },
        {
          elementReferenceType: "Langue",
          id: 1202,
          libelleFr: "Néerlandais",
          ordre: 20,
        },
        {
          elementReferenceType: "Langue",
          id: 4602,
          libelleFr: "Japonais",
          ordre: 22,
        },
        {
          elementReferenceType: "Langue",
          id: 4873,
          libelleFr: "Occitan",
          ordre: 23,
        },
        {
          elementReferenceType: "Langue",
          id: 4604,
          libelleFr: "Polonais",
          ordre: 24,
        },
        {
          elementReferenceType: "Langue",
          id: 4306,
          libelleFr: "Portugais",
          ordre: 25,
        },
        {
          elementReferenceType: "Langue",
          id: 1189,
          libelleFr: "Allemand",
          ordre: 1,
        },
        {
          elementReferenceType: "Langue",
          id: 1192,
          libelleFr: "Anglais",
          ordre: 2,
        },
        {
          elementReferenceType: "Langue",
          id: 4605,
          libelleFr: "Arabe",
          ordre: 3,
        },
        {
          elementReferenceType: "Langue",
          id: 1206,
          libelleFr: "Chinois",
          ordre: 7,
        },
        {
          elementReferenceType: "Langue",
          id: 4603,
          libelleFr: "Coréen",
          ordre: 8,
        },
        {
          elementReferenceType: "Langue",
          id: 1194,
          libelleFr: "Espagnol",
          ordre: 13,
        },
        {
          elementReferenceType: "Langue",
          id: 1197,
          libelleFr: "Français",
          ordre: 14,
        },
        {
          elementReferenceType: "Langue",
          id: 1205,
          libelleFr: "Russe",
          ordre: 28,
        },
      ],
      languesDocumentation: [
        {
          elementReferenceType: "Langue",
          id: 1189,
          libelleFr: "Allemand",
          ordre: 1,
        },
        {
          elementReferenceType: "Langue",
          id: 1192,
          libelleFr: "Anglais",
          ordre: 2,
        },
        {
          elementReferenceType: "Langue",
          id: 1194,
          libelleFr: "Espagnol",
          ordre: 13,
        },
        {
          elementReferenceType: "Langue",
          id: 1197,
          libelleFr: "Français",
          ordre: 14,
        },
        {
          elementReferenceType: "Langue",
          id: 1200,
          libelleFr: "Italien",
          ordre: 18,
        },
        {
          elementReferenceType: "Langue",
          id: 1202,
          libelleFr: "Néerlandais",
          ordre: 20,
        },
        {
          elementReferenceType: "Langue",
          id: 1205,
          libelleFr: "Russe",
          ordre: 28,
        },
        {
          elementReferenceType: "Langue",
          id: 1206,
          libelleFr: "Chinois",
          ordre: 7,
        },
        {
          elementReferenceType: "Langue",
          id: 4306,
          libelleFr: "Portugais",
          ordre: 25,
        },
        {
          elementReferenceType: "Langue",
          id: 4602,
          libelleFr: "Japonais",
          ordre: 22,
        },
        {
          elementReferenceType: "Langue",
          id: 4603,
          libelleFr: "Coréen",
          ordre: 8,
        },
        {
          elementReferenceType: "Langue",
          id: 4604,
          libelleFr: "Polonais",
          ordre: 24,
        },
        {
          elementReferenceType: "Langue",
          id: 4605,
          libelleFr: "Arabe",
          ordre: 3,
        },
        {
          elementReferenceType: "Langue",
          id: 4873,
          libelleFr: "Occitan",
          ordre: 23,
        },
      ],
      complementAccueil: {
        libelleFr: "Complément accueil",
      },
      tourismesAdaptes: [
        {
          elementReferenceType: "TourismeAdapte",
          id: 4215,
          libelleFr:
            "Présence de pictogrammes et/ou de visuels simplifiés de signalétique adaptée (textes/images)",
          ordre: 5,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4210,
            libelleFr: "Critères d'accessibilité pour déficience mentale",
            ordre: 34,
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3665,
          libelleFr: "Table accessible",
          ordre: 33,
          description:
            "Hauteur ss table >= 70 cm largeur>= 77 cm\r\nLa profondeur sous table, lavabo... est de 60 cm minimum.\r\nAttention à certains pieds de tables qui les rendent inaccessibles.\r\n\r\nPour les restaurants, il faudra bien vérifier la largeur entre les pieds pour déterminer si la capacité du restaurant est la même pour des valides et des personnes en fauteuil roulant.\r\nidem pour la hauteur, s'assurer que toutes les tables soient à la bonne hauteur.\r\nLaisser un passage dégagé de 80 cm lorsque les tables sont occupées.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 1199,
          libelleFr: "Prestations adaptées pour déficience visuelle",
          ordre: 11,
          description:
            'Concerne les équipements, le matériel, l’encadrement, les visites, la sensibilisation et la formation du personnel d’accueil…\r\nCritère déclaratif, différent du label "Tourisme & Handicap".\r\n\r\nRenseigner le "descriptif handicap visuel" pour lister les prestations et services adaptés proposés.',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4209,
            libelleFr: "Critères d'accessibilité pour déficience visuelle",
            ordre: 35,
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3684,
          libelleFr: "Rampe d'accès",
          ordre: 26,
          description:
            "Concerne les pentes supérieures à 5%, de préférence sur une courte distance sans obstacle dangereux. Garder à l'esprit qu'un adulte peut peser un certain poids et que l'accompagnant se fatiguera, \r\nvoire ne sera pas en mesure de pousser le fauteuil roulant.\r\n\r\nDonner un maximum de précision dans le \"Descriptif handicap moteur\" sur le nb de plans inclinés, la distance...\r\n\r\nLa présence d'un accompagnant est très certainement nécessaire.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3661,
          libelleFr: "Entrée accessible",
          ordre: 32,
          description:
            "Largeur minimum >=77 cm pour le passage d'un fauteuil roulant.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 4212,
          libelleFr: "Alarme visuelle avec flash lumineux",
          ordre: 7,
          description:
            "Se trouve dans les endroits clos (chambre, SDB, sanitaires). Doit être identifié avec un picto qui ressemble à une oreille.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4211,
            libelleFr: "Critères d'accessibilité pour déficience auditive",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 4217,
          libelleFr:
            "Documentation disponible en braille et/ou en gros caractères",
          ordre: 14,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4209,
            libelleFr: "Critères d'accessibilité pour déficience visuelle",
            ordre: 35,
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 4213,
          libelleFr: "Boucle magnétique disponible à l’accueil",
          ordre: 8,
          description:
            "Critère à cocher si le fonctionnement est permanent, que la boucle est signalée par un pictogramme adéquat, et que le personnel est informé du fonctionnement.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4211,
            libelleFr: "Critères d'accessibilité pour déficience auditive",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 4214,
          libelleFr:
            "Possibilité de communiquer en Langue des Signes Française",
          ordre: 9,
          description:
            'Dans le "Descriptif handicap auditif", préciser si le personnel d\'accueil est formé à la LSF ou utilise un logiciel spécifique',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4211,
            libelleFr: "Critères d'accessibilité pour déficience auditive",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 4218,
          libelleFr:
            "Présentation du lieu accessible aux personnes déficientes visuelles à l'accueil",
          ordre: 15,
          description:
            "Plan en relief, maquette tactile du site ou dispositif d’audio description disponible à l’accueil",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4209,
            libelleFr: "Critères d'accessibilité pour déficience visuelle",
            ordre: 35,
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3651,
          libelleFr: "Non accessible en fauteuil roulant",
          ordre: 47,
          description:
            "Concerne tous les sites avec des chemins chaotiques, à forte déclivité, sans stationnement adapté dans un rayon raisonnable\r\net batiments avec plusieurs marches à l'entrée, aménagés en 1/2 niveaux sans rampe, avec des couloirs trop étroits...",
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 4219,
          libelleFr:
            "Personnel d’accueil sensibilisé à l’accueil des personnes en situation de handicap",
          ordre: 48,
          description:
            "Au moins une personne du personnel a reçu une formation sur l'accueil des publics handicapés et est en mesure d'adopter un comportement adapté.",
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3653,
          libelleFr: "Accessible en fauteuil roulant en autonomie",
          ordre: 1,
          description:
            "Pour qu'un site soit accessible en fauteuil roulant en autonomie, il doit répondre à un maximum de critères listés dans \"Critères d'accessibilité pour personnes à mobilité réduite\". Certains critères peuvent être optionnels : \r\n- si l'établissement est de plain-pied, pas besoin d'ascenseur, \r\n- on peut avoir une salle de douches ou une salle de bains,\r\n- Si absence de place de stationnement, il faut pouvoir déposer quelqu'un devant le site mais peut poser des contraintes de surveillance pour une personne dépendante mentalement.\r\n \r\nUne personne en fauteuil roulant est en mesure de prendre son véhicule ou un transport en commun et de se déplacer seule dans les parties communes ou privatives du site.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3652,
          libelleFr: "Accessible en fauteuil roulant avec aide",
          ordre: 2,
          description:
            "Certaines contraintes matérielles, rendent impossible le déplacement d'une personne en fauteuil roulant sans l'aide de quelqu'un.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 1196,
          libelleFr: "Prestations adaptées pour déficience mentale",
          ordre: 3,
          description:
            'Concerne les équipements, le matériel, l’encadrement, les visites, la sensibilisation et la formation du personnel d’accueil…\r\nCritère déclaratif, différent du label "Tourisme & Handicap".\r\n\r\nRenseigner le "Descriptif handicap mental" pour préciser les services disponibles.',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4210,
            libelleFr: "Critères d'accessibilité pour déficience mentale",
            ordre: 34,
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 1191,
          libelleFr: "Prestations adaptées pour déficience auditive",
          ordre: 6,
          description:
            'Concerne les équipements, le matériel, l’encadrement, les visites, la sensibilisation et la formation du personnel d’accueil…\r\nCritère déclaratif, différent du label "Tourisme & Handicap".\r\n\r\nRenseigner le "Descriptif handicap auditif" pour décrire précisément les services et équipements proposés.',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 4211,
            libelleFr: "Critères d'accessibilité pour déficience auditive",
            ordre: 33,
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3655,
          libelleFr: "Place réservée PMR",
          ordre: 18,
          description:
            "Il s'agit de places matérialisées et aux normes avec une largeur d'au moins 3,3 m.\r\nDans le \"Descriptif handicap moteur\", précisez le nb de places réservées et la distance du lieu, bâtiment.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3657,
          libelleFr: "Revêtement dur",
          ordre: 27,
          description:
            "De préférence un revêtement dur comme du goudron, du ciment... \r\net sans obstacle c'est à dire des trottoirs aménagés avec des bateaux, pas de racines, pas de dévers...",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3659,
          libelleFr: "Cheminement de plain-pied",
          ordre: 28,
          description:
            "Un seuil de porte, une marche de trottoir de + de 2 cm peuvent devenir des obstacles dangereux \r\nqui peuvent entrainer un renversement du fauteuil ou être infranchissables en fonction de la force de la personne en fauteuil roulant.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3663,
          libelleFr: "Ascenseur aux normes",
          ordre: 29,
          description:
            "Dimensions intérieure de l'ascenseur : 80 x 130 cm et porte >= 77 cm",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3660,
          libelleFr: "Zone de circulation dégagée",
          ordre: 30,
          description:
            "90 cm, c'est la largeur nécessaire pour une circulation d'un fauteuil roulant (pour les structures construites après 2007).\r\nPrivilégier les cheminements plus larges pour que les accompagnants puissent marcher à côté et non derrière.\r\nla règlementation tolère les passages de 70 cm pour les structures construites avant 2007.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3664,
          libelleFr:
            "Mobilier/Comptoir d'accueil adapté aux personnes en fauteuil roulant",
          ordre: 31,
          description:
            "Concerne tout le mobilier sur lequel une personne en fauteuil roulant pourra échanger, régler ses courses...\r\n\r\nVeiller à ce que la banque soit dégagée pour être utilisable.\r\n\r\nHauteur recommandée entre 70 et 80 cm.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3674,
          libelleFr: "Site, bâtiment totalement accessible",
          ordre: 56,
          description:
            "Toutes les pièces d'un hébergement, restaurant, commerces...ou tous les lieux d'un site naturel, d'une manifestation... \r\nsont accessibles en fauteuil roulant.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3668,
          libelleFr: "Douche avec assise + espace de circulation",
          ordre: 34,
          description: "aire rotation 150 cm ou espace latéral 80*130",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3669,
          libelleFr: "Baignoire + tablette transfert + espace de circulation",
          ordre: 35,
          description:
            "Prévoir barre d'appui.\r\nAire rotation 150 cm ou espace latéral 80*130",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3670,
          libelleFr: "Lit, wc... entre 46-50 cm de haut",
          ordre: 36,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3672,
          libelleFr: "Espace de circulation sur le côté du lit",
          ordre: 37,
          description:
            "Sur au moins un côté du lit, le passage doit faire 90 cm pour permettre le passage du fauteuil roulant.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3673,
          libelleFr: "Une chambre PMR",
          ordre: 38,
          description:
            "Dans les hébergements, prévoir une chambre séparée pour pouvoir isoler la personne car elle n'a pas forcément le même rythme de vie que les accompagnants.\r\n\r\nLa chambre doit avoir une aire de rotation de 1,50 m",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3676,
          libelleFr: "Possibilité de déposer quelqu’un devant le site",
          ordre: 25,
          description:
            "Attention la possibilité de dépose n'est pas forcément idéale car exige la présence de 2 accompagnants, un pour garer le véhicule et un second pour rester avec la personne en fauteuil roulant. \r\nVous ne pouvez pas laisser un enfant seul, voire certains adultes en fonction des déficiences.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
        {
          elementReferenceType: "TourismeAdapte",
          id: 3667,
          libelleFr: "WC + barre d'appui + espace de circulation",
          ordre: 40,
          description:
            "Aire rotation 150 cm ou espace latéral 80*130 + barres d’appui",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3650,
            libelleFr: "Critères d'accessibilité pour déficience motrice",
            ordre: 32,
            description:
              "Conditions à remplir pour qu'un site soit considéré comme accessible en fauteuil roulant.",
          },
        },
      ],
      surchargeTourismesAdaptes: true,
      labelsTourismeHandicap: [
        {
          elementReferenceType: "LabelTourismeHandicap",
          id: 1224,
          libelleFr: "Marque Tourisme et Handicap - déficience auditive",
          ordre: 1,
          description: "Critère spécifique de la marque, non-déclaratif.",
          critereDeprecie: {
            code: "31345-distinctions",
            message:
              "#31345 - réorganisation des distinctions : le critère existe toujours mais a été migré sous forme de distinction",
            dateAlerte: "2025-11-10",
            dateDesactivation: "2026-11-24",
            critereSubstitutionId: 7715,
            champSubstitution: "distinctions[].nom",
            url: "https://dev.apidae-tourisme.com/reorganisation-des-distinctions/",
          },
        },
        {
          elementReferenceType: "LabelTourismeHandicap",
          id: 1225,
          libelleFr: "Marque Tourisme et Handicap - déficience mentale",
          ordre: 2,
          description: "Critère spécifique de la marque, non-déclaratif.",
          critereDeprecie: {
            code: "31345-distinctions",
            message:
              "#31345 - réorganisation des distinctions : le critère existe toujours mais a été migré sous forme de distinction",
            dateAlerte: "2025-11-10",
            dateDesactivation: "2026-11-24",
            critereSubstitutionId: 7716,
            champSubstitution: "distinctions[].nom",
            url: "https://dev.apidae-tourisme.com/reorganisation-des-distinctions/",
          },
        },
        {
          elementReferenceType: "LabelTourismeHandicap",
          id: 1226,
          libelleFr: "Marque Tourisme et Handicap - déficience motrice",
          ordre: 3,
          description: "Critère spécifique de la marque, non-déclaratif.",
          critereDeprecie: {
            code: "31345-distinctions",
            message:
              "#31345 - réorganisation des distinctions : le critère existe toujours mais a été migré sous forme de distinction",
            dateAlerte: "2025-11-10",
            dateDesactivation: "2026-11-24",
            critereSubstitutionId: 7717,
            champSubstitution: "distinctions[].nom",
            url: "https://dev.apidae-tourisme.com/reorganisation-des-distinctions/",
          },
        },
        {
          elementReferenceType: "LabelTourismeHandicap",
          id: 1227,
          libelleFr: "Marque Tourisme et Handicap - déficience visuelle",
          ordre: 4,
          description: "Critère spécifique de marque, non-déclaratif.",
          critereDeprecie: {
            code: "31345-distinctions",
            message:
              "#31345 - réorganisation des distinctions : le critère existe toujours mais a été migré sous forme de distinction",
            dateAlerte: "2025-11-10",
            dateDesactivation: "2026-11-24",
            critereSubstitutionId: 7718,
            champSubstitution: "distinctions[].nom",
            url: "https://dev.apidae-tourisme.com/reorganisation-des-distinctions/",
          },
        },
      ],
      descriptifHandicapMoteur: {
        libelleFr: "Descriptif handicap moteur",
      },
      surchargeDescriptifHandicapMoteur: true,
      descriptifHandicapAuditif: {
        libelleFr: "Descriptif handicap auditif",
      },
      surchargeDescriptifHandicapAuditif: true,
      descriptifHandicapVisuel: {
        libelleFr: "Descriptif handicap visuel",
      },
      surchargeDescriptifHandicapVisuel: true,
      descriptifHandicapMental: {
        libelleFr: "Descriptif handicap mental",
      },
      surchargeDescriptifHandicapMental: true,
      nombrePersonnesEnFauteuilRoulantAccueilliesSimultanement: 127,
      surchargeNombreFauteuilsRoulants: true,
      typesClientele: [
        {
          elementReferenceType: "TypeClientele",
          id: 496,
          libelleFr: "Spécial adolescents",
          ordre: 50,
          description:
            "Concerne activités, séjours, événements qui conviennent particulièrement aux adolescents (12 ou 14 ans à 18 ans) et qui leur permettent de se retrouver ensemble.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 2,
            libelleFr: "Offres adaptées à des clientèles spécifiques",
            ordre: 185,
            description:
              "Les critères suivants doivent être utilisés uniquement pour identifier une offre ou un service adapté ou réservé à une clientèle particulière. Sans sélection de l’un ou l’autre de ces critères, l’objet est considéré concernant tous les publics au sens large.\r\n \r\nLes grands principes :\r\n\r\n- Par défaut, la majeure partie de l’offre concerne une clientèle touristique, grand public et adulte.\r\n- Il faut réserver l’utilisation des critères à la qualification d’une offre qui présente des spécificités pour un public particulier :\r\n -> Soit pour répondre à une organisation marketing de l’offre relative à la nature du client.\r\n-> Soit parce que pour répondre aux exigences des différentes pratiques.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 504,
          libelleFr: "Cavaliers",
          ordre: 4,
          description:
            "Ce critère ne doit être appliqué seulement si l’offre concernée présente au moins deux spécificités sur les trois proposées :\r\n\r\n- un pré clos, électrifié\r\n- des aliments adaptés pour le cheval (même avec un supplément)\r\n- un point d'attache",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3,
            libelleFr: "Clientèles pratiquant une activité spécifique",
            ordre: 189,
            description:
              "Cette famille de critères a pour objectif d'identifier les objets ou structures non référencés dans le cadre d’une démarche qualifiante comme un label national ou une démarche départementale (rando, cyclo, VTT …).\r\n \r\nS’il n’existe pas de démarche structurée sur la pratique, il reste important de pouvoir identifier une offre particulièrement adaptée, en prenant en compte les services proposés, mais aussi l’expertise et le conseil.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 509,
          libelleFr: "Spécial amoureux",
          ordre: 51,
          description:
            "Permet de caractériser une offre dédiée à des amoureux : service particulier, ambiance et décoration adaptées (chambre « nuptiale », espace réservé type ponton, spa, restaurant…)\r\nHébergement, restauration, bien-être, et peut-être certaines activités saisies dans les Equipements (baptêmes de l’air, croisières…) à condition qu’elles soient formatées réellement dans l’esprit love-love.\r\nA exclure : le produit de base pour 2 personnes sans charme ni caractère particulier.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 2,
            libelleFr: "Offres adaptées à des clientèles spécifiques",
            ordre: 185,
            description:
              "Les critères suivants doivent être utilisés uniquement pour identifier une offre ou un service adapté ou réservé à une clientèle particulière. Sans sélection de l’un ou l’autre de ces critères, l’objet est considéré concernant tous les publics au sens large.\r\n \r\nLes grands principes :\r\n\r\n- Par défaut, la majeure partie de l’offre concerne une clientèle touristique, grand public et adulte.\r\n- Il faut réserver l’utilisation des critères à la qualification d’une offre qui présente des spécificités pour un public particulier :\r\n -> Soit pour répondre à une organisation marketing de l’offre relative à la nature du client.\r\n-> Soit parce que pour répondre aux exigences des différentes pratiques.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 511,
          libelleFr: "Curistes",
          ordre: 5,
          description: "A moins de 500 m d'un établissement thermal.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3,
            libelleFr: "Clientèles pratiquant une activité spécifique",
            ordre: 189,
            description:
              "Cette famille de critères a pour objectif d'identifier les objets ou structures non référencés dans le cadre d’une démarche qualifiante comme un label national ou une démarche départementale (rando, cyclo, VTT …).\r\n \r\nS’il n’existe pas de démarche structurée sur la pratique, il reste important de pouvoir identifier une offre particulièrement adaptée, en prenant en compte les services proposés, mais aussi l’expertise et le conseil.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 512,
          libelleFr: "Cyclistes",
          ordre: 6,
          description:
            "Ce critère doit être appliqué seulement si l’offre concernée présente au moins deux spécificités sur les trois proposées :\r\n\r\n- local sécurisé, \r\n- carte circuit à dispo, \r\n- lave-linge et séchoir.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3,
            libelleFr: "Clientèles pratiquant une activité spécifique",
            ordre: 189,
            description:
              "Cette famille de critères a pour objectif d'identifier les objets ou structures non référencés dans le cadre d’une démarche qualifiante comme un label national ou une démarche départementale (rando, cyclo, VTT …).\r\n \r\nS’il n’existe pas de démarche structurée sur la pratique, il reste important de pouvoir identifier une offre particulièrement adaptée, en prenant en compte les services proposés, mais aussi l’expertise et le conseil.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 513,
          libelleFr: "Spécial famille avec enfants",
          ordre: 52,
          description:
            "Permet de caractériser une offre accessible et attractive pour des familles avec enfants de moins de 12 ou 14 ans, et remplissant au moins une des deux conditions suivantes :\r\n\r\n- permettre une pratique que l’on recommanderait pour une famille (enfants, parents…,) \r\n- proposer un contenu et/ou des services particulièrement adaptés (ex : hébergements et restaurants avec jeux, services – Animations, spectacles, événements pour les enfants – Musées, sites de visites avec prestations adaptées.\r\n\r\nRenseigner le bon plan dans les types objets suivants HOT, HCO, CAM, PCU, RES., pour bien valoriser les services et équipements offerts.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 2,
            libelleFr: "Offres adaptées à des clientèles spécifiques",
            ordre: 185,
            description:
              "Les critères suivants doivent être utilisés uniquement pour identifier une offre ou un service adapté ou réservé à une clientèle particulière. Sans sélection de l’un ou l’autre de ces critères, l’objet est considéré concernant tous les publics au sens large.\r\n \r\nLes grands principes :\r\n\r\n- Par défaut, la majeure partie de l’offre concerne une clientèle touristique, grand public et adulte.\r\n- Il faut réserver l’utilisation des critères à la qualification d’une offre qui présente des spécificités pour un public particulier :\r\n -> Soit pour répondre à une organisation marketing de l’offre relative à la nature du client.\r\n-> Soit parce que pour répondre aux exigences des différentes pratiques.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 522,
          libelleFr: "Pèlerins",
          ordre: 11,
          description:
            "Ce critère doit être appliqué seulement si l’offre concernée présente au moins deux spécificités sur les trois proposées :\r\n\r\n- renseignement client (étape suivante, météo, possibilité de réserver…),  \r\n- infos à jour sur l’établissement (tarifs, accès, type de couchage, mode de réservation…), \r\n- proximité d’un  itinéraire de pèlerinage.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3,
            libelleFr: "Clientèles pratiquant une activité spécifique",
            ordre: 189,
            description:
              "Cette famille de critères a pour objectif d'identifier les objets ou structures non référencés dans le cadre d’une démarche qualifiante comme un label national ou une démarche départementale (rando, cyclo, VTT …).\r\n \r\nS’il n’existe pas de démarche structurée sur la pratique, il reste important de pouvoir identifier une offre particulièrement adaptée, en prenant en compte les services proposés, mais aussi l’expertise et le conseil.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 558,
          libelleFr: "Randonneurs",
          ordre: 24,
          description:
            "Ce critère doit être appliqué seulement si l’offre concernée présente au moins deux spécificités sur les trois proposées :\r\n\r\n- Renseignement client (étape suivante, météo, possibilité de réserver…),  \r\n- infos à jour sur l’établissement (tarifs, accès, type de couchage, mode de réservation…), \r\n- lave-linge et séchoir.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3,
            libelleFr: "Clientèles pratiquant une activité spécifique",
            ordre: 189,
            description:
              "Cette famille de critères a pour objectif d'identifier les objets ou structures non référencés dans le cadre d’une démarche qualifiante comme un label national ou une démarche départementale (rando, cyclo, VTT …).\r\n \r\nS’il n’existe pas de démarche structurée sur la pratique, il reste important de pouvoir identifier une offre particulièrement adaptée, en prenant en compte les services proposés, mais aussi l’expertise et le conseil.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 563,
          libelleFr: "VTTistes",
          ordre: 26,
          description:
            "Ce critère doit être appliqué seulement si l’offre concernée présente au moins deux spécificités sur les trois proposées :\r\n\r\n- local sécurisé, \r\n- lave-linge et séchoir, \r\n- proximité d’un lieu de pratique.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3,
            libelleFr: "Clientèles pratiquant une activité spécifique",
            ordre: 189,
            description:
              "Cette famille de critères a pour objectif d'identifier les objets ou structures non référencés dans le cadre d’une démarche qualifiante comme un label national ou une démarche départementale (rando, cyclo, VTT …).\r\n \r\nS’il n’existe pas de démarche structurée sur la pratique, il reste important de pouvoir identifier une offre particulièrement adaptée, en prenant en compte les services proposés, mais aussi l’expertise et le conseil.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 564,
          libelleFr: "Pratiquants de sports d'eaux vives",
          ordre: 23,
          description:
            "Ce critère doit être appliqué seulement si l’offre concernée présente au moins deux spécificités sur les trois proposées :\r\n- renseignement client  (conseil sur les lieux et les conditions de pratique),  \r\n- local sécurisé, \r\n- proximité  site de pratique.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3,
            libelleFr: "Clientèles pratiquant une activité spécifique",
            ordre: 189,
            description:
              "Cette famille de critères a pour objectif d'identifier les objets ou structures non référencés dans le cadre d’une démarche qualifiante comme un label national ou une démarche départementale (rando, cyclo, VTT …).\r\n \r\nS’il n’existe pas de démarche structurée sur la pratique, il reste important de pouvoir identifier une offre particulièrement adaptée, en prenant en compte les services proposés, mais aussi l’expertise et le conseil.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 565,
          libelleFr: "Motards",
          ordre: 8,
          description:
            "Ce critère ne doit être appliqué que si l’offre concernée présente au moins deux spécificités sur les trois proposées :\r\n\r\n- garage/parking sécurisé, \r\n- lave-linge, \r\n- séchoir.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3,
            libelleFr: "Clientèles pratiquant une activité spécifique",
            ordre: 189,
            description:
              "Cette famille de critères a pour objectif d'identifier les objets ou structures non référencés dans le cadre d’une démarche qualifiante comme un label national ou une démarche départementale (rando, cyclo, VTT …).\r\n \r\nS’il n’existe pas de démarche structurée sur la pratique, il reste important de pouvoir identifier une offre particulièrement adaptée, en prenant en compte les services proposés, mais aussi l’expertise et le conseil.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 566,
          libelleFr: "Pêcheurs",
          ordre: 10,
          description:
            "Ce critère ne doit être appliqué seulement si l’offre concernée présente au moins deux spécificités sur les trois proposées :\r\n\r\n- renseignement client  (conseil sur les lieux et les conditions de pratique), \r\n- local sécurisé, \r\n- proximité d’un lieu de pratique.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3,
            libelleFr: "Clientèles pratiquant une activité spécifique",
            ordre: 189,
            description:
              "Cette famille de critères a pour objectif d'identifier les objets ou structures non référencés dans le cadre d’une démarche qualifiante comme un label national ou une démarche départementale (rando, cyclo, VTT …).\r\n \r\nS’il n’existe pas de démarche structurée sur la pratique, il reste important de pouvoir identifier une offre particulièrement adaptée, en prenant en compte les services proposés, mais aussi l’expertise et le conseil.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 570,
          libelleFr: "Fermé à la clientèle extérieure",
          ordre: 1,
          description:
            "Réservé à sa clientèle\r\n\r\nExemples :\r\n- Hébergement réservé aux membres d'un comité d'entreprise (EDF)\r\n- L'hôtel n'ouvre pas son restaurant à la clientèle extérieure\r\n- Table d'hôtes réservée à la clientèle de la chambre d'hôtes\r\n- Activité à l’année pour laquelle il faut être adhérent à une association\r\n- Association qui ne proposent que des activités à l'année pour leurs adhérents",
        },
        {
          elementReferenceType: "TypeClientele",
          id: 579,
          libelleFr: "Spécial célibataires",
          ordre: 45,
          description:
            "Produits, activités, événements, animations spécialement conçus pour cette clientèle et faisant l’objet d’une communication spécifique.\r\nLa notion de tarif étant très importante pour les célibataires, il faudra ajouter une ligne dans Tarifs pour identifier toutes les offres single",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 2,
            libelleFr: "Offres adaptées à des clientèles spécifiques",
            ordre: 185,
            description:
              "Les critères suivants doivent être utilisés uniquement pour identifier une offre ou un service adapté ou réservé à une clientèle particulière. Sans sélection de l’un ou l’autre de ces critères, l’objet est considéré concernant tous les publics au sens large.\r\n \r\nLes grands principes :\r\n\r\n- Par défaut, la majeure partie de l’offre concerne une clientèle touristique, grand public et adulte.\r\n- Il faut réserver l’utilisation des critères à la qualification d’une offre qui présente des spécificités pour un public particulier :\r\n -> Soit pour répondre à une organisation marketing de l’offre relative à la nature du client.\r\n-> Soit parce que pour répondre aux exigences des différentes pratiques.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 593,
          libelleFr: "Accueil groupes",
          ordre: 27,
          description:
            "Permet d’identifier les prestataires susceptibles d’accueillir en plus une clientèle groupe.\r\n\r\nSont retenus par ailleurs les critères « Accueil groupes affaire/incentive » et « Accueil groupes scolaires/enfants » qui doivent être réservés aux offres proposant des prestations, tarifs et services adaptés.\r\n\r\nIl y a nécessité d’avoir une politique tarifaire pour les groupes, quelle que soit leur taille. Les tarifs groupes devront être renseignés en précisant la taille des groupes pour bénéficier des tarifs indiqués.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5,
            libelleFr: "Public ciblé : groupes",
            ordre: 187,
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 596,
          libelleFr: "Accueil de groupes scolaires",
          ordre: 31,
          description:
            'Permet d’identifier \r\n- les hébergements collectifs qui accueillent les groupes scolaires. L’accueil de ce type de public nécessite pour la structure d’être répertoriée auprès de la DDCS (Direction Départementale de la Cohésion Sociale) pour l’accueil collectif de mineurs. \r\nPour accueillir des maternels, l’hébergement doit avoir reçu en plus l’avis favorable de la Protection Maternelle Infantile.\r\nPour accueillir des enfants d’écoles élémentaires, l’hébergement doit en plus être inscrit au répertoire de l’Education Nationale. \r\n\r\n- les prestataires qui accueillent des groupes scolaires et qui proposent des offres, tarifs et services adaptés. \r\n\r\nSi vous utilisez ce critère, merci de renseigner les autres critères dessous pour permettre une meilleure segmentation du public visé.\r\n\r\nPensez à renseigner la taille des groupes, les tarifs spécifiques consentis.\r\nÉventuellement renseigner l\'aspect "Groupes" si nécessaire.',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5,
            libelleFr: "Public ciblé : groupes",
            ordre: 187,
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 597,
          libelleFr: "Accueil groupes affaire/incentive",
          ordre: 28,
          description:
            'Pensez à renseigner la taille des groupes, les tarifs spécifiques consentis.\r\nÉventuellement renseigner l\'aspect "Groupes" si nécessaire.',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5,
            libelleFr: "Public ciblé : groupes",
            ordre: 187,
          },
          parent: {
            elementReferenceType: "TypeClientele",
            id: 593,
            libelleFr: "Accueil groupes",
            ordre: 27,
            description:
              "Permet d’identifier les prestataires susceptibles d’accueillir en plus une clientèle groupe.\r\n\r\nSont retenus par ailleurs les critères « Accueil groupes affaire/incentive » et « Accueil groupes scolaires/enfants » qui doivent être réservés aux offres proposant des prestations, tarifs et services adaptés.\r\n\r\nIl y a nécessité d’avoir une politique tarifaire pour les groupes, quelle que soit leur taille. Les tarifs groupes devront être renseignés en précisant la taille des groupes pour bénéficier des tarifs indiqués.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 3731,
          libelleFr: "Tarif spécial pour familles nombreuses",
          ordre: 83,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 3728,
            libelleFr: "Tarifs spéciaux proposés pour",
            ordre: 188,
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 3734,
          libelleFr: "Spécial LGBT",
          ordre: 43,
          description:
            "Concerne produits,  établissements, hébergements, activités, événements faisant l’objet d’une communication spécifique pour cette cible.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 2,
            libelleFr: "Offres adaptées à des clientèles spécifiques",
            ordre: 185,
            description:
              "Les critères suivants doivent être utilisés uniquement pour identifier une offre ou un service adapté ou réservé à une clientèle particulière. Sans sélection de l’un ou l’autre de ces critères, l’objet est considéré concernant tous les publics au sens large.\r\n \r\nLes grands principes :\r\n\r\n- Par défaut, la majeure partie de l’offre concerne une clientèle touristique, grand public et adulte.\r\n- Il faut réserver l’utilisation des critères à la qualification d’une offre qui présente des spécificités pour un public particulier :\r\n -> Soit pour répondre à une organisation marketing de l’offre relative à la nature du client.\r\n-> Soit parce que pour répondre aux exigences des différentes pratiques.",
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 3738,
          libelleFr: "Distributeurs",
          ordre: 40,
          description:
            "Il s’agit d’identifier une offre susceptible d’être proposée par des réseaux de distribution (T.O, agences de voyage), ou d’intéresser des comités d’entreprise, ce qui implique qu’elle est impérativement commissionnable.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 6483,
            libelleFr: "Public ciblé",
            ordre: 186,
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 3896,
          libelleFr: "Cycle 1 : école maternelle (PS, MS, GS)",
          ordre: 85,
          description:
            "Permet d'identifier les prestataires, OT, hébergements, activités, animations et sites touristiques proposant une offre spécifique pour cette clientèle",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5,
            libelleFr: "Public ciblé : groupes",
            ordre: 187,
          },
          parent: {
            elementReferenceType: "TypeClientele",
            id: 596,
            libelleFr: "Accueil de groupes scolaires",
            ordre: 31,
            description:
              'Permet d’identifier \r\n- les hébergements collectifs qui accueillent les groupes scolaires. L’accueil de ce type de public nécessite pour la structure d’être répertoriée auprès de la DDCS (Direction Départementale de la Cohésion Sociale) pour l’accueil collectif de mineurs. \r\nPour accueillir des maternels, l’hébergement doit avoir reçu en plus l’avis favorable de la Protection Maternelle Infantile.\r\nPour accueillir des enfants d’écoles élémentaires, l’hébergement doit en plus être inscrit au répertoire de l’Education Nationale. \r\n\r\n- les prestataires qui accueillent des groupes scolaires et qui proposent des offres, tarifs et services adaptés. \r\n\r\nSi vous utilisez ce critère, merci de renseigner les autres critères dessous pour permettre une meilleure segmentation du public visé.\r\n\r\nPensez à renseigner la taille des groupes, les tarifs spécifiques consentis.\r\nÉventuellement renseigner l\'aspect "Groupes" si nécessaire.',
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 3897,
          libelleFr: "Cycle 2 : école élémentaire (CP, CE1, CE2)",
          ordre: 86,
          description:
            "Permet d'identifier les prestataires, OT, hébergements, activités, animations et sites touristiques proposant une offre spécifique pour cette clientèle",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5,
            libelleFr: "Public ciblé : groupes",
            ordre: 187,
          },
          parent: {
            elementReferenceType: "TypeClientele",
            id: 596,
            libelleFr: "Accueil de groupes scolaires",
            ordre: 31,
            description:
              'Permet d’identifier \r\n- les hébergements collectifs qui accueillent les groupes scolaires. L’accueil de ce type de public nécessite pour la structure d’être répertoriée auprès de la DDCS (Direction Départementale de la Cohésion Sociale) pour l’accueil collectif de mineurs. \r\nPour accueillir des maternels, l’hébergement doit avoir reçu en plus l’avis favorable de la Protection Maternelle Infantile.\r\nPour accueillir des enfants d’écoles élémentaires, l’hébergement doit en plus être inscrit au répertoire de l’Education Nationale. \r\n\r\n- les prestataires qui accueillent des groupes scolaires et qui proposent des offres, tarifs et services adaptés. \r\n\r\nSi vous utilisez ce critère, merci de renseigner les autres critères dessous pour permettre une meilleure segmentation du public visé.\r\n\r\nPensez à renseigner la taille des groupes, les tarifs spécifiques consentis.\r\nÉventuellement renseigner l\'aspect "Groupes" si nécessaire.',
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 3899,
          libelleFr: "Cycle 4 : collège (5ème , 4ème , 3ème)",
          ordre: 89,
          description:
            "Permet d'identifier les prestataires, OT, hébergements, activités, animations et sites touristiques proposant une offre spécifique pour cette clientèle",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5,
            libelleFr: "Public ciblé : groupes",
            ordre: 187,
          },
          parent: {
            elementReferenceType: "TypeClientele",
            id: 596,
            libelleFr: "Accueil de groupes scolaires",
            ordre: 31,
            description:
              'Permet d’identifier \r\n- les hébergements collectifs qui accueillent les groupes scolaires. L’accueil de ce type de public nécessite pour la structure d’être répertoriée auprès de la DDCS (Direction Départementale de la Cohésion Sociale) pour l’accueil collectif de mineurs. \r\nPour accueillir des maternels, l’hébergement doit avoir reçu en plus l’avis favorable de la Protection Maternelle Infantile.\r\nPour accueillir des enfants d’écoles élémentaires, l’hébergement doit en plus être inscrit au répertoire de l’Education Nationale. \r\n\r\n- les prestataires qui accueillent des groupes scolaires et qui proposent des offres, tarifs et services adaptés. \r\n\r\nSi vous utilisez ce critère, merci de renseigner les autres critères dessous pour permettre une meilleure segmentation du public visé.\r\n\r\nPensez à renseigner la taille des groupes, les tarifs spécifiques consentis.\r\nÉventuellement renseigner l\'aspect "Groupes" si nécessaire.',
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 3902,
          libelleFr: "Lycée",
          ordre: 90,
          description:
            "Permet d'identifier les prestataires, OT, hébergements, activités, animations et sites touristiques proposant une offre spécifique pour cette clientèle",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5,
            libelleFr: "Public ciblé : groupes",
            ordre: 187,
          },
          parent: {
            elementReferenceType: "TypeClientele",
            id: 596,
            libelleFr: "Accueil de groupes scolaires",
            ordre: 31,
            description:
              'Permet d’identifier \r\n- les hébergements collectifs qui accueillent les groupes scolaires. L’accueil de ce type de public nécessite pour la structure d’être répertoriée auprès de la DDCS (Direction Départementale de la Cohésion Sociale) pour l’accueil collectif de mineurs. \r\nPour accueillir des maternels, l’hébergement doit avoir reçu en plus l’avis favorable de la Protection Maternelle Infantile.\r\nPour accueillir des enfants d’écoles élémentaires, l’hébergement doit en plus être inscrit au répertoire de l’Education Nationale. \r\n\r\n- les prestataires qui accueillent des groupes scolaires et qui proposent des offres, tarifs et services adaptés. \r\n\r\nSi vous utilisez ce critère, merci de renseigner les autres critères dessous pour permettre une meilleure segmentation du public visé.\r\n\r\nPensez à renseigner la taille des groupes, les tarifs spécifiques consentis.\r\nÉventuellement renseigner l\'aspect "Groupes" si nécessaire.',
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 4547,
          libelleFr: "Accueil de colonies de vacances",
          ordre: 33,
          description:
            'Permet d’identifier :\r\n- les hébergements collectifs qui accueillent des colonies de vacances. L’accueil de ce type de public nécessite pour la structure d’être répertoriée auprès de la DDCS pour l’accueil collectif de mineurs.\r\nPour accueillir des enfants de moins de 6 ans, l’hébergement doit avoir reçu en plus l’avis favorable de la Protection Maternelle Infantile.\r\n\r\n- les prestataires qui accueillent des colonies de vacances et qui proposent des offres, tarifs et services adaptés. \r\n\r\nSi vous utilisez ce critère, merci de renseigner les autres critères dessous pour permettre une meilleure segmentation du public visé.\r\n\r\nPensez à renseigner la taille des groupes, les tarifs spécifiques consentis.\r\nÉventuellement renseigner l\'aspect "Groupes" si nécessaire.',
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5,
            libelleFr: "Public ciblé : groupes",
            ordre: 187,
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 4548,
          libelleFr: "Enfants de 3 à 5 ans",
          ordre: 34,
          description:
            "Permet d'identifier les prestataires, OT, hébergements, activités, animations et sites touristiques proposant une offre spécifique pour cette clientèle",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5,
            libelleFr: "Public ciblé : groupes",
            ordre: 187,
          },
          parent: {
            elementReferenceType: "TypeClientele",
            id: 4547,
            libelleFr: "Accueil de colonies de vacances",
            ordre: 33,
            description:
              'Permet d’identifier :\r\n- les hébergements collectifs qui accueillent des colonies de vacances. L’accueil de ce type de public nécessite pour la structure d’être répertoriée auprès de la DDCS pour l’accueil collectif de mineurs.\r\nPour accueillir des enfants de moins de 6 ans, l’hébergement doit avoir reçu en plus l’avis favorable de la Protection Maternelle Infantile.\r\n\r\n- les prestataires qui accueillent des colonies de vacances et qui proposent des offres, tarifs et services adaptés. \r\n\r\nSi vous utilisez ce critère, merci de renseigner les autres critères dessous pour permettre une meilleure segmentation du public visé.\r\n\r\nPensez à renseigner la taille des groupes, les tarifs spécifiques consentis.\r\nÉventuellement renseigner l\'aspect "Groupes" si nécessaire.',
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 4549,
          libelleFr: "Enfants de 6 à 12 ans",
          ordre: 35,
          description:
            "Permet d'identifier les prestataires, OT, hébergements, activités, animations et sites touristiques proposant une offre spécifique pour cette clientèle",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5,
            libelleFr: "Public ciblé : groupes",
            ordre: 187,
          },
          parent: {
            elementReferenceType: "TypeClientele",
            id: 4547,
            libelleFr: "Accueil de colonies de vacances",
            ordre: 33,
            description:
              'Permet d’identifier :\r\n- les hébergements collectifs qui accueillent des colonies de vacances. L’accueil de ce type de public nécessite pour la structure d’être répertoriée auprès de la DDCS pour l’accueil collectif de mineurs.\r\nPour accueillir des enfants de moins de 6 ans, l’hébergement doit avoir reçu en plus l’avis favorable de la Protection Maternelle Infantile.\r\n\r\n- les prestataires qui accueillent des colonies de vacances et qui proposent des offres, tarifs et services adaptés. \r\n\r\nSi vous utilisez ce critère, merci de renseigner les autres critères dessous pour permettre une meilleure segmentation du public visé.\r\n\r\nPensez à renseigner la taille des groupes, les tarifs spécifiques consentis.\r\nÉventuellement renseigner l\'aspect "Groupes" si nécessaire.',
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 4550,
          libelleFr: "Jeunes de 13 à 17 ans",
          ordre: 36,
          description:
            "Permet d'identifier les prestataires, OT, hébergements, activités, animations et sites touristiques proposant une offre spécifique pour cette clientèle",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5,
            libelleFr: "Public ciblé : groupes",
            ordre: 187,
          },
          parent: {
            elementReferenceType: "TypeClientele",
            id: 4547,
            libelleFr: "Accueil de colonies de vacances",
            ordre: 33,
            description:
              'Permet d’identifier :\r\n- les hébergements collectifs qui accueillent des colonies de vacances. L’accueil de ce type de public nécessite pour la structure d’être répertoriée auprès de la DDCS pour l’accueil collectif de mineurs.\r\nPour accueillir des enfants de moins de 6 ans, l’hébergement doit avoir reçu en plus l’avis favorable de la Protection Maternelle Infantile.\r\n\r\n- les prestataires qui accueillent des colonies de vacances et qui proposent des offres, tarifs et services adaptés. \r\n\r\nSi vous utilisez ce critère, merci de renseigner les autres critères dessous pour permettre une meilleure segmentation du public visé.\r\n\r\nPensez à renseigner la taille des groupes, les tarifs spécifiques consentis.\r\nÉventuellement renseigner l\'aspect "Groupes" si nécessaire.',
          },
        },
        {
          elementReferenceType: "TypeClientele",
          id: 4551,
          libelleFr: "Enseignement supérieur",
          ordre: 91,
          description:
            "Permet d'identifier les prestataires, OT, hébergements, activités, animations et sites touristiques proposant une offre spécifique pour cette clientèle",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5,
            libelleFr: "Public ciblé : groupes",
            ordre: 187,
          },
          parent: {
            elementReferenceType: "TypeClientele",
            id: 596,
            libelleFr: "Accueil de groupes scolaires",
            ordre: 31,
            description:
              'Permet d’identifier \r\n- les hébergements collectifs qui accueillent les groupes scolaires. L’accueil de ce type de public nécessite pour la structure d’être répertoriée auprès de la DDCS (Direction Départementale de la Cohésion Sociale) pour l’accueil collectif de mineurs. \r\nPour accueillir des maternels, l’hébergement doit avoir reçu en plus l’avis favorable de la Protection Maternelle Infantile.\r\nPour accueillir des enfants d’écoles élémentaires, l’hébergement doit en plus être inscrit au répertoire de l’Education Nationale. \r\n\r\n- les prestataires qui accueillent des groupes scolaires et qui proposent des offres, tarifs et services adaptés. \r\n\r\nSi vous utilisez ce critère, merci de renseigner les autres critères dessous pour permettre une meilleure segmentation du public visé.\r\n\r\nPensez à renseigner la taille des groupes, les tarifs spécifiques consentis.\r\nÉventuellement renseigner l\'aspect "Groupes" si nécessaire.',
          },
        },
      ],
      nombrePersonnesMinimum: 123,
      tailleGroupeMin: 35,
      tailleGroupeMax: 128,
    },
    ouverture: {
      periodeEnClair: {
        libelleFr: "Toute l'année tous les jours.",
      },
      periodeEnClairGenerationMode: "AUTOMATIQUE",
      indicationsPeriode: [
        {
          elementReferenceType: "IndicationPeriode",
          id: 416,
          libelleFr: "Automne",
          ordre: 4,
          description:
            "Permet de trouver des objets en fonction de la saison automnale - 21 septembre au 20 décembre",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 114,
            libelleFr: "Période",
            ordre: 116,
          },
        },
        {
          elementReferenceType: "IndicationPeriode",
          id: 418,
          libelleFr: "Eté",
          ordre: 3,
          description:
            "Permet de trouver des objets en fonction de la saison estivale - 21 juin au 20 septembre",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 114,
            libelleFr: "Période",
            ordre: 116,
          },
        },
        {
          elementReferenceType: "IndicationPeriode",
          id: 435,
          libelleFr: "Hiver",
          ordre: 5,
          description:
            "Permet de trouver des objets en fonction de la saison hivernale - 21 décembre au 20 mars",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 114,
            libelleFr: "Période",
            ordre: 116,
          },
        },
        {
          elementReferenceType: "IndicationPeriode",
          id: 436,
          libelleFr: "Printemps",
          ordre: 2,
          description:
            "Permet de trouver des objets en fonction de la saison printanière - 21 mars au 20 juin",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 114,
            libelleFr: "Période",
            ordre: 116,
          },
        },
      ],
      periodesOuvertures: [
        {
          identifiant: 18057805,
          dateDebut: "2024-01-01",
          dateFin: "2024-12-31",
          type: "OUVERTURE_TOUS_LES_JOURS",
          tousLesAns: true,
          identifiantTechnique: 37913770,
          horaires: [
            {
              id: 2623689,
              type: {
                elementReferenceType: "HoraireType",
                id: 7487,
                libelleFr: "Ouverture",
                ordre: 16,
                description: "Horaires d'ouverture",
                externalType: "opening",
                startTimeVisibility: true,
                endTimeVisibility: true,
                recurrenceVisibility: false,
              },
              timePeriods: [
                {
                  id: 2822721,
                  closed: false,
                  weekdays: ["SAT", "SUN", "WED", "TUE", "THU", "FRI", "MON"],
                  timeFrames: [
                    {
                      id: 2896544,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
      ouvertTouteLAnnee: "OUVERT_TOUTE_L_ANNEE",
    },
    descriptionTarif: {
      indicationTarif: "PAYANT",
      gratuit: false,
      tarifsEnClair: {
        libelleFr:
          "Nuitée : 1 €\nDemi-pension (/ pers.) : 2 €\nPension complète (/ pers.) : 3 €\nSemaine : 4 €\nSemaine en demi-pension (/ pers.) : 5 €\nSemaine en pension complète (/ pers.) : 6 €\nWeek-end : 7 €\nDeux semaines : 8 €\nTrois semaines : 9 €\nUn Week-end 2J / 1N en DP (/pers.) : 10 €\nUn Week-end 2J/1N en location (base 4 pers.) : 11 €\nUn Week-end 2J / 1N en PC (/pers.) : 12 €\nUne semaine 8J / 7N gîte de groupe : 13 €\nAnimaux : 14 €\nParking voiture : 15 €\nTaxe de séjour : 16 €.\n\n Gratuit pour les moins de 12 ans, les plus de 72 ans, les accompagnateurs en montagne, les accompagnateurs guides, les chauffeurs, les demandeurs d'emploi, les détenteurs de la carte Pass'Région, les enfants accompagnés d'un adulte, les enseignants, les étudiants, les guides de haute montagne, les personnes à mobilité réduite, les personnes handicapées, les personnes handicapées et leurs accompagnants, les spectateurs, les visiteurs.\n Tarif groupe à partir de 35 personnes.\n\nComplément tarifs.",
      },
      tarifsEnClairGenerationMode: "AUTOMATIQUE",
      complement: {
        libelleFr: "Complément tarifs",
      },
      periodes: [
        {
          identifiant: 10854132,
          dateDebut: "2024-01-01",
          dateFin: "2024-01-01",
          tarifs: [
            {
              devise: "EUR",
              minimum: 1.0,
              maximum: 1.0,
              type: {
                elementReferenceType: "TarifType",
                id: 1525,
                libelleFr: "Nuitée",
                ordre: 43,
                description: "Indiquer le prix par personne",
              },
            },
            {
              devise: "EUR",
              minimum: 2.0,
              maximum: 2.0,
              type: {
                elementReferenceType: "TarifType",
                id: 1528,
                libelleFr: "Demi-pension (/ pers.)",
                ordre: 129,
              },
            },
            {
              devise: "EUR",
              minimum: 3.0,
              maximum: 3.0,
              type: {
                elementReferenceType: "TarifType",
                id: 1529,
                libelleFr: "Pension complète (/ pers.)",
                ordre: 149,
              },
            },
            {
              devise: "EUR",
              minimum: 4.0,
              maximum: 4.0,
              type: {
                elementReferenceType: "TarifType",
                id: 1520,
                libelleFr: "Semaine",
                ordre: 163,
              },
            },
            {
              devise: "EUR",
              minimum: 5.0,
              maximum: 5.0,
              type: {
                elementReferenceType: "TarifType",
                id: 1519,
                libelleFr: "Semaine en demi-pension (/ pers.)",
                ordre: 182,
              },
            },
            {
              devise: "EUR",
              minimum: 6.0,
              maximum: 6.0,
              type: {
                elementReferenceType: "TarifType",
                id: 1521,
                libelleFr: "Semaine en pension complète (/ pers.)",
                ordre: 197,
              },
            },
            {
              devise: "EUR",
              minimum: 7.0,
              maximum: 7.0,
              type: {
                elementReferenceType: "TarifType",
                id: 1526,
                libelleFr: "Week-end",
                ordre: 209,
              },
            },
            {
              devise: "EUR",
              minimum: 8.0,
              maximum: 8.0,
              type: {
                elementReferenceType: "TarifType",
                id: 1534,
                libelleFr: "Deux semaines",
                ordre: 219,
              },
            },
            {
              devise: "EUR",
              minimum: 9.0,
              maximum: 9.0,
              type: {
                elementReferenceType: "TarifType",
                id: 1532,
                libelleFr: "Trois semaines",
                ordre: 228,
                description:
                  "Concerne notamment les résidences hôtelières et de tourisme pour les curistes\r\n(tarifs spécifiques pour les curistes qui résident 3 semaines)",
              },
            },
            {
              devise: "EUR",
              minimum: 10.0,
              maximum: 10.0,
              type: {
                elementReferenceType: "TarifType",
                id: 1522,
                libelleFr: "Un Week-end 2J / 1N en DP (/pers.)",
                ordre: 276,
              },
            },
            {
              devise: "EUR",
              minimum: 11.0,
              maximum: 11.0,
              type: {
                elementReferenceType: "TarifType",
                id: 1523,
                libelleFr: "Un Week-end 2J/1N en location (base 4 pers.)",
                ordre: 284,
              },
            },
            {
              devise: "EUR",
              minimum: 12.0,
              maximum: 12.0,
              type: {
                elementReferenceType: "TarifType",
                id: 1524,
                libelleFr: "Un Week-end 2J / 1N en PC (/pers.)",
                ordre: 295,
              },
            },
            {
              devise: "EUR",
              minimum: 13.0,
              maximum: 13.0,
              type: {
                elementReferenceType: "TarifType",
                id: 1527,
                libelleFr: "Une semaine 8J / 7N gîte de groupe",
                ordre: 302,
              },
            },
            {
              devise: "EUR",
              minimum: 14.0,
              maximum: 14.0,
              type: {
                elementReferenceType: "TarifType",
                id: 4081,
                libelleFr: "Animaux",
                ordre: 304,
                description:
                  "Supplément demandé pour l'hébergement des animaux",
              },
            },
            {
              devise: "EUR",
              minimum: 15.0,
              maximum: 15.0,
              type: {
                elementReferenceType: "TarifType",
                id: 4132,
                libelleFr: "Parking voiture",
                ordre: 305,
              },
            },
            {
              devise: "EUR",
              minimum: 16.0,
              maximum: 16.0,
              type: {
                elementReferenceType: "TarifType",
                id: 5876,
                libelleFr: "Taxe de séjour",
                ordre: 317,
              },
            },
          ],
        },
      ],
      modesPaiement: [
        {
          elementReferenceType: "ModePaiement",
          id: 1265,
          libelleFr: "American Express",
          ordre: 2,
        },
        {
          elementReferenceType: "ModePaiement",
          id: 1266,
          libelleFr: "Bons CAF",
          ordre: 4,
          description:
            "Bons délivrés par la Caisse d'Allocations Familiales sous conditions de ressources",
        },
        {
          elementReferenceType: "ModePaiement",
          id: 1268,
          libelleFr: "Carte bancaire/crédit",
          ordre: 5,
        },
        {
          elementReferenceType: "ModePaiement",
          id: 1271,
          libelleFr: "Chèque",
          ordre: 11,
        },
        {
          elementReferenceType: "ModePaiement",
          id: 1273,
          libelleFr: "Chèque de voyage",
          ordre: 15,
          description:
            "Un chèque de voyage (en anglais « traveller's cheque ») est un chèque pré-imprimé, au montant fixé, conçu pour permettre à la personne qui les signe de payer un tiers sans condition aucune, après avoir lui-même payé l'émetteur du chèque pour obtenir ce privilèg",
        },
        {
          elementReferenceType: "ModePaiement",
          id: 1274,
          libelleFr: "Chèque-Vacances Classic",
          ordre: 18,
          description: "Chèque vacances papier",
        },
        {
          elementReferenceType: "ModePaiement",
          id: 1275,
          libelleFr: "Devise étrangère",
          ordre: 25,
          description:
            "Possibilité de paiement en devises étrangères (ex: dollar, franc suisse...)",
        },
        {
          elementReferenceType: "ModePaiement",
          id: 1277,
          libelleFr: "Espèces",
          ordre: 28,
        },
        {
          elementReferenceType: "ModePaiement",
          id: 1281,
          libelleFr: "Virement",
          ordre: 44,
        },
        {
          elementReferenceType: "ModePaiement",
          id: 1285,
          libelleFr: "Titre Restaurant",
          ordre: 41,
        },
      ],
      devise: "EUR",
      taxeDeSejourIncluse: "NON_COMMUNIQUE",
      conditions: {
        conditionsGratuite: [
          {
            elementReferenceType: "ConditionGratuite",
            id: 4249,
            libelleFr: "les enfants accompagnés d'un adulte",
            ordre: 13,
          },
          {
            elementReferenceType: "ConditionGratuite",
            id: 4250,
            libelleFr: "les enseignants",
            ordre: 14,
          },
          {
            elementReferenceType: "ConditionGratuite",
            id: 4771,
            libelleFr: "les étudiants",
            ordre: 15,
          },
          {
            elementReferenceType: "ConditionGratuite",
            id: 4251,
            libelleFr: "les guides de haute montagne",
            ordre: 18,
          },
          {
            elementReferenceType: "ConditionGratuite",
            id: 4255,
            libelleFr: "les personnes handicapées",
            ordre: 21,
          },
          {
            elementReferenceType: "ConditionGratuite",
            id: 4248,
            libelleFr: "les visiteurs",
            ordre: 25,
          },
          {
            elementReferenceType: "ConditionGratuite",
            id: 4252,
            libelleFr: "les accompagnateurs en montagne",
            ordre: 2,
          },
          {
            elementReferenceType: "ConditionGratuite",
            id: 4257,
            libelleFr: "les accompagnateurs guides",
            ordre: 3,
            description:
              "concerne les accompagnateurs ou guides encadrant des groupes",
          },
          {
            elementReferenceType: "ConditionGratuite",
            id: 4253,
            libelleFr: "les chauffeurs",
            ordre: 6,
          },
          {
            elementReferenceType: "ConditionGratuite",
            id: 4772,
            libelleFr: "les demandeurs d'emploi",
            ordre: 9,
          },
          {
            elementReferenceType: "ConditionGratuite",
            id: 4254,
            libelleFr: "les détenteurs de la carte Pass'Région",
            ordre: 11,
            description:
              "Le Pass'Région est une carte proposant des avantages pour la région Auvergne Rhône-Alpes.",
          },
          {
            elementReferenceType: "ConditionGratuite",
            id: 4530,
            libelleFr: "les personnes à mobilité réduite",
            ordre: 20,
          },
          {
            elementReferenceType: "ConditionGratuite",
            id: 4256,
            libelleFr: "les personnes handicapées et leurs accompagnants",
            ordre: 22,
          },
          {
            elementReferenceType: "ConditionGratuite",
            id: 4247,
            libelleFr: "les spectateurs",
            ordre: 24,
          },
        ],
        gratuitPourLesMoinsDe: 12,
        gratuitPourLesPlusDe: 72,
      },
    },
    reservation: {
      organismes: [
        {
          identifiant: 2190087,
          nom: "Auvergne Réservation",
          type: {
            elementReferenceType: "ReservationType",
            id: 473,
            libelleFr: "Centrale",
            ordre: 1,
            description:
              "Réservation auprès d'une centrale  ou de réseaux de réservations",
          },
          observation: {
            libelleFr: "Observation",
          },
          moyensCommunication: [
            {
              identifiant: 35557043,
              type: {
                elementReferenceType: "MoyenCommunicationType",
                id: 201,
                libelleFr: "Téléphone",
                ordre: 1,
              },
              coordonnees: {
                fr: "04 73 29 49 95",
              },
              observation: {
                libelleFr: "Complément Tel",
              },
            },
            {
              identifiant: 35557044,
              type: {
                elementReferenceType: "MoyenCommunicationType",
                id: 204,
                libelleFr: "Mél",
                ordre: 2,
              },
              coordonnees: {
                fr: "serge.bregliano@crdt-auvernge.fr",
              },
              observation: {
                libelleFr: "Complètement Mail",
              },
            },
            {
              identifiant: 35557045,
              type: {
                elementReferenceType: "MoyenCommunicationType",
                id: 205,
                libelleFr: "Site web (URL)",
                ordre: 3,
              },
              coordonnees: {
                fr: "http://perdu.com/",
              },
              observation: {
                libelleFr: "Compliment site web",
              },
            },
          ],
          locked: false,
        },
      ],
      complement: {
        libelleFr: "Complément réservation",
      },
    },
    criteresInternes: [
      {
        id: 17276,
        libelle: "Vérane - Test Formulaire Covid",
        commentaire: "Test commentaire critère interne",
      },
    ],
    contacts: [
      {
        identifiant: 12836508,
        referent: true,
        civilite: {
          elementReferenceType: "ContactCivilite",
          id: 443,
          libelleFr: "Monsieur",
          ordre: 9,
        },
        nom: "BREGLIANO",
        prenom: "Serge",
        titre: {
          libelleFr: "Titre",
        },
        fonction: {
          elementReferenceType: "ContactFonction",
          id: 458,
          libelleFr: "Direction",
          ordre: 8,
        },
        autresFonctions: [
          {
            elementReferenceType: "ContactFonction",
            id: 459,
            libelleFr: "Information",
            ordre: 11,
          },
        ],
        moyensCommunication: [
          {
            identifiant: 35557047,
            type: {
              elementReferenceType: "MoyenCommunicationType",
              id: 204,
              libelleFr: "Mél",
              ordre: 2,
            },
            coordonnees: {
              fr: "serge.bregliano@crdt-auvergne.fr",
            },
            observation: {
              libelleFr: "Complément Mail",
            },
          },
          {
            identifiant: 35557048,
            type: {
              elementReferenceType: "MoyenCommunicationType",
              id: 201,
              libelleFr: "Téléphone",
              ordre: 1,
            },
            coordonnees: {
              fr: "04 73 29 49 95",
            },
            observation: {
              libelleFr: "Complément Téléphone",
            },
          },
        ],
      },
      {
        identifiant: 17624590,
        referent: false,
        civilite: {
          elementReferenceType: "ContactCivilite",
          id: 443,
          libelleFr: "Monsieur",
          ordre: 9,
        },
        nom: "Gérardi",
        prenom: "Ludovic",
        fonction: {
          elementReferenceType: "ContactFonction",
          id: 467,
          libelleFr: "Communication",
          ordre: 4,
        },
        autresFonctions: [
          {
            elementReferenceType: "ContactFonction",
            id: 464,
            libelleFr: "Propriétaire des murs",
            ordre: 18,
          },
        ],
        moyensCommunication: [
          {
            identifiant: 79563401,
            type: {
              elementReferenceType: "MoyenCommunicationType",
              id: 204,
              libelleFr: "Mél",
              ordre: 2,
            },
            coordonnees: {
              fr: "ludovic.gerardi@puy-de-dome.fr",
            },
          },
        ],
      },
      {
        identifiant: 17624578,
        referent: false,
        civilite: {
          elementReferenceType: "ContactCivilite",
          id: 442,
          libelleFr: "Madame",
          ordre: 4,
        },
        nom: "Gatignol",
        prenom: "Anaïs",
        fonction: {
          elementReferenceType: "ContactFonction",
          id: 457,
          libelleFr: "Administration",
          ordre: 1,
        },
        autresFonctions: [
          {
            elementReferenceType: "ContactFonction",
            id: 460,
            libelleFr: "Présidence",
            ordre: 15,
          },
        ],
        moyensCommunication: [
          {
            identifiant: 79563330,
            type: {
              elementReferenceType: "MoyenCommunicationType",
              id: 204,
              libelleFr: "Mél",
              ordre: 2,
            },
            coordonnees: {
              fr: "anais.gatignol@puy-de-dome.fr",
            },
          },
        ],
      },
    ],
    illustrations: [
      {
        identifiant: 7032687,
        link: false,
        type: "IMAGE",
        nom: {
          libelleFr: "Loutre",
        },
        legende: {
          libelleFr: "Loutre",
        },
        copyright: {
          libelleFr: "Daniel Olaleye",
        },
        traductionFichiers: [
          {
            locale: "fr",
            url: "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/54/119/6846262.jpg",
            urlListe:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/54/119/6846262-liste.jpg",
            urlFiche:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/54/119/6846262-fiche.jpg",
            urlDiaporama:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/54/119/6846262-diaporama.jpg",
            extension: "jpg",
            fileName: "daniel-olaleye-8xGNvZVLNCk-unsplash",
            taille: 3138165,
            hauteur: 3060,
            largeur: 5469,
            lastModifiedDate: "2019-10-28T10:54:18.000+00:00",
          },
        ],
        locked: false,
      },
      {
        identifiant: 3534509,
        link: false,
        type: "IMAGE",
        nom: {
          libelleFr: "Nom 2",
        },
        legende: {
          libelleFr: "Légende 2",
        },
        copyright: {
          libelleFr: "Copyright",
        },
        traductionFichiers: [
          {
            locale: "fr",
            url: "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/15/80/3428367.jpg",
            urlListe:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/15/80/3428367-liste.jpg",
            urlFiche:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/15/80/3428367-fiche.jpg",
            urlDiaporama:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/15/80/3428367-diaporama.jpg",
            extension: "jpg",
            fileName: "PDD-0731-72",
            taille: 709846,
            hauteur: 899,
            largeur: 1348,
            lastModifiedDate: "2017-12-11T16:41:44.000+00:00",
          },
          {
            locale: "en",
            url: "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/16/80/3428368.jpg",
            urlListe:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/16/80/3428368-liste.jpg",
            urlFiche:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/16/80/3428368-fiche.jpg",
            urlDiaporama:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/16/80/3428368-diaporama.jpg",
            extension: "jpg",
            fileName: "2275174_2",
            taille: 293735,
            hauteur: 968,
            largeur: 1296,
            lastModifiedDate: "2017-12-11T16:41:45.000+00:00",
          },
          {
            locale: "de",
            url: "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/17/80/3428369.jpg",
            urlListe:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/17/80/3428369-liste.jpg",
            urlFiche:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/17/80/3428369-fiche.jpg",
            urlDiaporama:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/17/80/3428369-diaporama.jpg",
            extension: "jpg",
            fileName: "2201641",
            taille: 315699,
            hauteur: 1296,
            largeur: 968,
            lastModifiedDate: "2017-12-11T16:41:45.000+00:00",
          },
        ],
        locked: false,
      },
      {
        identifiant: 2207601,
        link: false,
        type: "IMAGE",
        nom: {
          libelleFr: "Nom",
        },
        legende: {
          libelleFr: "Légende",
        },
        copyright: {
          libelleFr: "Copyright",
        },
        traductionFichiers: [
          {
            locale: "fr",
            url: "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/239/80/2117871.jpg",
            urlListe:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/239/80/2117871-liste.jpg",
            urlFiche:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/239/80/2117871-fiche.jpg",
            urlDiaporama:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/images/239/80/2117871-diaporama.jpg",
            extension: "jpg",
            fileName: "PDD-9949-72",
            taille: 608236,
            hauteur: 536,
            largeur: 1225,
            lastModifiedDate: "2017-02-16T17:14:54.000+00:00",
          },
        ],
        locked: false,
      },
    ],
    multimedias: [
      {
        identifiant: 3534511,
        link: false,
        type: "DOCUMENT",
        traductionFichiers: [
          {
            locale: "fr",
            url: "https://static.apidae-tourisme.dev/filestore/objets-touristiques/documents/19/80/3428371/jhipster-jdl.jh",
            extension: "jh",
            fileName: "jhipster-jdl",
            taille: 1948,
            lastModifiedDate: "2017-12-11T16:41:46.000+00:00",
          },
          {
            locale: "en",
            url: "https://static.apidae-tourisme.dev/filestore/objets-touristiques/documents/22/80/3428374/goz.jpg",
            urlListe:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/documents/22/80/3428374-liste.jpg",
            urlFiche:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/documents/22/80/3428374-fiche.jpg",
            urlDiaporama:
              "https://static.apidae-tourisme.dev/filestore/objets-touristiques/documents/22/80/3428374-diaporama.jpg",
            extension: "jpg",
            fileName: "goz",
            taille: 8308,
            hauteur: 184,
            largeur: 184,
            lastModifiedDate: "2017-12-11T16:41:46.000+00:00",
          },
        ],
        locked: false,
      },
      {
        identifiant: 9951281,
        link: false,
        type: "PLAN",
        nom: {
          libelleFr: "3D Sculpture parc",
        },
        traductionFichiers: [
          {
            locale: "fr",
            url: "https://static.apidae-tourisme.com/filestore/objets-touristiques/plans/87/39/9709399/3D+Sculpture+parc.gpx", // Erreur CORS : No 'Access-Control-Allow-Origin' header is present sur http://static.apidae-tourisme.home/filestore/objets-touristiques/plans/87/39/9709399/3D+Sculpture+parc.gpx
            // url: "https://kmzmap.com/examples/ukraine_borders.kmz",
            // url: "https://geotrek-admin.ecrins-parcnational.fr/api/fr/treks/995619/les-chargeaux.kml",
            extension: "gpx",
            // extension: "kmz",
            // extension: "kml",
            fileName: "3D Sculpture parc",
            taille: 11902,
            lastModifiedDate: "2021-05-07T14:52:31.000+00:00",
          },
        ],
        locked: false,
      },
    ],
    tourismeAffaires: {
      tourismeAffairesEnabled: true,
      sallesEquipeesPour: [
        {
          elementReferenceType: "SalleEquipeePour",
          id: 1239,
          libelleFr: "Concert/spectacle",
          ordre: 1,
          description:
            "La salle de concert/spectacle doit être composée à minima d’un espace de diffusion (salle avec scène répondant aux normes acoustiques), de loges pour l’accueil des artistes et d’un espace administratif pour le personnel permanent. Le plus souvent, la salle comprend également un bar (parfois dans un espace distinct).",
        },
        {
          elementReferenceType: "SalleEquipeePour",
          id: 1240,
          libelleFr: "Congrès",
          ordre: 2,
          description:
            "Ce sont des « réunions à caractère fermé des tenants d’une discipline qu’elle soit professionnelle, politique ou culturelle ». Ils réunissent un grand nombre de participants (plus de 200 personnes) ayant pour but d’échanger des opinions, des connaissances sur un sujet précis, par exemple le lancement d’un produit. Les congrès prévoient ne logistique importante.",
        },
        {
          elementReferenceType: "SalleEquipeePour",
          id: 1241,
          libelleFr: "Réception",
          ordre: 5,
          description:
            "Ce sont des événements pouvant être organisés par des professionnels, associations ou individuels dont le but est de réunir des invités afin de partager un moment convivial de  type mariage, baptême, déjeuner, dîner, cocktail ou soirée de gala avec ambiance musicale ou non.",
        },
        {
          elementReferenceType: "SalleEquipeePour",
          id: 1242,
          libelleFr: "Foire/Salon/exposition",
          ordre: 6,
          description:
            "Ce sont « un regroupement périodique d’exposants dans le but de présenter aux acheteurs professionnels ou au grand public des échantillons de produits ou de services dans l’intention d’en faire connaître les qualités et d’en provoquer l’acquisition »",
        },
        {
          elementReferenceType: "SalleEquipeePour",
          id: 1243,
          libelleFr: "Séminaire/réunion",
          ordre: 7,
          description:
            "Réunions de professionnels (cadres, ingénieurs…) pour l’étude d’une ou de plusieurs questions précises.  Les réunions se déroulent dans un lieu clos et sont accessibles à tous les intéressés si elles dépassent le cadre des séminaires internes aux entreprises. C’est en général un groupe de travail limité avec un maximum de 200 personnes. Un séminaire a pour principal but de compléter la formation des salariés d’une entreprise, mais il peut néanmoins être organisé pour faciliter l’information, la recherche, la stimulation…",
        },
      ],
      sallesEquipement: [
        {
          elementReferenceType: "SalleEquipement",
          id: 1244,
          libelleFr: "Régie son",
          ordre: 16,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1245,
          libelleFr: "Vidéotransmission",
          ordre: 24,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1246,
          libelleFr: "Vidéoprojecteur",
          ordre: 23,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1247,
          libelleFr: "Paper board",
          ordre: 11,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1248,
          libelleFr: "Régie lumière",
          ordre: 15,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1249,
          libelleFr: "Visioconférence",
          ordre: 25,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1250,
          libelleFr: "Ecran",
          ordre: 7,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1251,
          libelleFr: "Micro",
          ordre: 9,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1252,
          libelleFr: "Piste de danse",
          ordre: 14,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1253,
          libelleFr: "Wifi dans la salle",
          ordre: 26,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1254,
          libelleFr: "Caméra/camescope",
          ordre: 5,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1255,
          libelleFr: "Scène",
          ordre: 17,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1256,
          libelleFr: "Tables",
          ordre: 18,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1257,
          libelleFr: "Chaises",
          ordre: 3,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1258,
          libelleFr: "Pupitre",
          ordre: 13,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1259,
          libelleFr: "Climatisation",
          ordre: 4,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1260,
          libelleFr: "Cabine de traduction",
          ordre: 2,
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1261,
          libelleFr: "Tables rondes",
          ordre: 20,
          parent: {
            elementReferenceType: "SalleEquipement",
            id: 1256,
            libelleFr: "Tables",
            ordre: 18,
          },
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1262,
          libelleFr: "Tables rectangulaires",
          ordre: 21,
          parent: {
            elementReferenceType: "SalleEquipement",
            id: 1256,
            libelleFr: "Tables",
            ordre: 18,
          },
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 1263,
          libelleFr: "Mange-debout",
          ordre: 19,
          parent: {
            elementReferenceType: "SalleEquipement",
            id: 1256,
            libelleFr: "Tables",
            ordre: 18,
          },
        },
        {
          elementReferenceType: "SalleEquipement",
          id: 3986,
          libelleFr: "Amphithéâtre",
          ordre: 1,
        },
      ],
      sallesRestauration: [
        {
          elementReferenceType: "SalleRestauration",
          id: 1228,
          libelleFr: "Bar",
          ordre: 1,
        },
        {
          elementReferenceType: "SalleRestauration",
          id: 1229,
          libelleFr: "Cuisine équipée",
          ordre: 3,
        },
        {
          elementReferenceType: "SalleRestauration",
          id: 1230,
          libelleFr: "Espace de restauration",
          ordre: 4,
        },
        {
          elementReferenceType: "SalleRestauration",
          id: 1233,
          libelleFr: "Restaurant sur place",
          ordre: 6,
        },
        {
          elementReferenceType: "SalleRestauration",
          id: 1234,
          libelleFr: "Restaurant à proximité",
          ordre: 7,
        },
        {
          elementReferenceType: "SalleRestauration",
          id: 1235,
          libelleFr: "Traiteur libre",
          ordre: 8,
        },
        {
          elementReferenceType: "SalleRestauration",
          id: 1236,
          libelleFr: "Traiteur imposé",
          ordre: 9,
        },
        {
          elementReferenceType: "SalleRestauration",
          id: 1237,
          libelleFr: "Vaisselle mise à disposition",
          ordre: 10,
        },
        {
          elementReferenceType: "SalleRestauration",
          id: 1238,
          libelleFr: "Chambre froide",
          ordre: 2,
        },
      ],
      sallesHebergement: [
        {
          elementReferenceType: "SalleHebergement",
          id: 1231,
          libelleFr: "Hébergement sur place",
          ordre: 1,
        },
        {
          elementReferenceType: "SalleHebergement",
          id: 1232,
          libelleFr: "Hébergement à proximité",
          ordre: 2,
        },
      ],
      sallesReunion: [
        {
          identifiant: 117363,
          nom: "Nom de la salle de réunion",
          description: {
            libelleFr: "Description de la salle de réunino",
          },
          capaciteMax: 130,
          superficie: 250,
          hauteur: 5.0,
          lumiereNaturelle: true,
          tarifSalle: {
            minimum: 456.0,
            maximum: 789.0,
          },
          tarifJournee: {
            minimum: 147.0,
            maximum: 258.0,
          },
          tarifResident: {
            minimum: 369.0,
            maximum: 951.0,
          },
          dispositions: [
            {
              capacite: 123,
              disposition: {
                elementReferenceType: "SalleDisposition",
                id: 1309,
                libelleFr: "En classe",
                ordre: 1,
              },
            },
            {
              capacite: 124,
              disposition: {
                elementReferenceType: "SalleDisposition",
                id: 1307,
                libelleFr: "En théâtre",
                ordre: 2,
              },
            },
            {
              capacite: 125,
              disposition: {
                elementReferenceType: "SalleDisposition",
                id: 1305,
                libelleFr: "En U",
                ordre: 3,
              },
            },
            {
              capacite: 126,
              disposition: {
                elementReferenceType: "SalleDisposition",
                id: 1313,
                libelleFr: "En banquet",
                ordre: 4,
              },
            },
            {
              capacite: 127,
              disposition: {
                elementReferenceType: "SalleDisposition",
                id: 1314,
                libelleFr: "En cocktail",
                ordre: 5,
              },
            },
            {
              capacite: 128,
              disposition: {
                elementReferenceType: "SalleDisposition",
                id: 1315,
                libelleFr: "En carre",
                ordre: 6,
              },
            },
          ],
        },
      ],
      devise: "EUR",
      nombreSallesReunionEquipees: 127,
      capaciteMaxAccueil: 128,
      nombreSallesModulables: 129,
    },
    territoires: [
      {
        type: "TERRITOIRE",
        id: 5731591,
        nom: {
          libelleFr: "test territoire GLN",
        },
        identifier: "SITRA2_GEO_5731591",
        state: "HIDDEN",
      },
    ],
    datesOuverture: [
      "2026-01-15",
      "2026-01-16",
      "2026-01-17",
      "2026-01-18",
      "2026-01-19",
      "2026-01-20",
      "2026-01-21",
      "2026-01-22",
      "2026-01-23",
      "2026-01-24",
      "2026-01-25",
      "2026-01-26",
      "2026-01-27",
      "2026-01-28",
      "2026-01-29",
      "2026-01-30",
      "2026-01-31",
      "2026-02-01",
      "2026-02-02",
      "2026-02-03",
      "2026-02-04",
      "2026-02-05",
      "2026-02-06",
      "2026-02-07",
      "2026-02-08",
      "2026-02-09",
      "2026-02-10",
      "2026-02-11",
      "2026-02-12",
      "2026-02-13",
      "2026-02-14",
      "2026-02-15",
      "2026-02-16",
      "2026-02-17",
      "2026-02-18",
      "2026-02-19",
      "2026-02-20",
      "2026-02-21",
      "2026-02-22",
      "2026-02-23",
      "2026-02-24",
      "2026-02-25",
      "2026-02-26",
      "2026-02-27",
      "2026-02-28",
      "2026-03-01",
      "2026-03-02",
      "2026-03-03",
      "2026-03-04",
      "2026-03-05",
      "2026-03-06",
      "2026-03-07",
      "2026-03-08",
      "2026-03-09",
      "2026-03-10",
      "2026-03-11",
      "2026-03-12",
      "2026-03-13",
      "2026-03-14",
      "2026-03-15",
      "2026-03-16",
      "2026-03-17",
      "2026-03-18",
      "2026-03-19",
      "2026-03-20",
      "2026-03-21",
      "2026-03-22",
      "2026-03-23",
      "2026-03-24",
      "2026-03-25",
      "2026-03-26",
      "2026-03-27",
      "2026-03-28",
      "2026-03-29",
      "2026-03-30",
      "2026-03-31",
      "2026-04-01",
      "2026-04-02",
      "2026-04-03",
      "2026-04-04",
      "2026-04-05",
      "2026-04-06",
      "2026-04-07",
      "2026-04-08",
      "2026-04-09",
      "2026-04-10",
      "2026-04-11",
      "2026-04-12",
      "2026-04-13",
      "2026-04-14",
      "2026-04-15",
      "2026-04-16",
      "2026-04-17",
      "2026-04-18",
      "2026-04-19",
      "2026-04-20",
      "2026-04-21",
      "2026-04-22",
      "2026-04-23",
      "2026-04-24",
      "2026-04-25",
      "2026-04-26",
      "2026-04-27",
      "2026-04-28",
      "2026-04-29",
      "2026-04-30",
      "2026-05-01",
      "2026-05-02",
      "2026-05-03",
      "2026-05-04",
      "2026-05-05",
      "2026-05-06",
      "2026-05-07",
      "2026-05-08",
      "2026-05-09",
      "2026-05-10",
      "2026-05-11",
      "2026-05-12",
      "2026-05-13",
      "2026-05-14",
      "2026-05-15",
      "2026-05-16",
      "2026-05-17",
      "2026-05-18",
      "2026-05-19",
      "2026-05-20",
      "2026-05-21",
      "2026-05-22",
      "2026-05-23",
      "2026-05-24",
      "2026-05-25",
      "2026-05-26",
      "2026-05-27",
      "2026-05-28",
      "2026-05-29",
      "2026-05-30",
      "2026-05-31",
      "2026-06-01",
      "2026-06-02",
      "2026-06-03",
      "2026-06-04",
      "2026-06-05",
      "2026-06-06",
      "2026-06-07",
      "2026-06-08",
      "2026-06-09",
      "2026-06-10",
      "2026-06-11",
      "2026-06-12",
      "2026-06-13",
      "2026-06-14",
      "2026-06-15",
      "2026-06-16",
      "2026-06-17",
      "2026-06-18",
      "2026-06-19",
      "2026-06-20",
      "2026-06-21",
      "2026-06-22",
      "2026-06-23",
      "2026-06-24",
      "2026-06-25",
      "2026-06-26",
      "2026-06-27",
      "2026-06-28",
      "2026-06-29",
      "2026-06-30",
      "2026-07-01",
      "2026-07-02",
      "2026-07-03",
      "2026-07-04",
      "2026-07-05",
      "2026-07-06",
      "2026-07-07",
      "2026-07-08",
      "2026-07-09",
      "2026-07-10",
      "2026-07-11",
      "2026-07-12",
      "2026-07-13",
      "2026-07-14",
      "2026-07-15",
      "2026-07-16",
      "2026-07-17",
      "2026-07-18",
      "2026-07-19",
      "2026-07-20",
      "2026-07-21",
      "2026-07-22",
      "2026-07-23",
      "2026-07-24",
      "2026-07-25",
      "2026-07-26",
      "2026-07-27",
      "2026-07-28",
      "2026-07-29",
      "2026-07-30",
      "2026-07-31",
      "2026-08-01",
      "2026-08-02",
      "2026-08-03",
      "2026-08-04",
      "2026-08-05",
      "2026-08-06",
      "2026-08-07",
      "2026-08-08",
      "2026-08-09",
      "2026-08-10",
      "2026-08-11",
      "2026-08-12",
      "2026-08-13",
      "2026-08-14",
      "2026-08-15",
      "2026-08-16",
      "2026-08-17",
      "2026-08-18",
      "2026-08-19",
      "2026-08-20",
      "2026-08-21",
      "2026-08-22",
      "2026-08-23",
      "2026-08-24",
      "2026-08-25",
      "2026-08-26",
      "2026-08-27",
      "2026-08-28",
      "2026-08-29",
      "2026-08-30",
      "2026-08-31",
      "2026-09-01",
      "2026-09-02",
      "2026-09-03",
      "2026-09-04",
      "2026-09-05",
      "2026-09-06",
      "2026-09-07",
      "2026-09-08",
      "2026-09-09",
      "2026-09-10",
      "2026-09-11",
      "2026-09-12",
      "2026-09-13",
      "2026-09-14",
      "2026-09-15",
      "2026-09-16",
      "2026-09-17",
      "2026-09-18",
      "2026-09-19",
      "2026-09-20",
      "2026-09-21",
      "2026-09-22",
      "2026-09-23",
      "2026-09-24",
      "2026-09-25",
      "2026-09-26",
      "2026-09-27",
      "2026-09-28",
      "2026-09-29",
      "2026-09-30",
      "2026-10-01",
      "2026-10-02",
      "2026-10-03",
      "2026-10-04",
      "2026-10-05",
      "2026-10-06",
      "2026-10-07",
      "2026-10-08",
      "2026-10-09",
      "2026-10-10",
      "2026-10-11",
      "2026-10-12",
      "2026-10-13",
      "2026-10-14",
      "2026-10-15",
      "2026-10-16",
      "2026-10-17",
      "2026-10-18",
      "2026-10-19",
      "2026-10-20",
      "2026-10-21",
      "2026-10-22",
      "2026-10-23",
      "2026-10-24",
      "2026-10-25",
      "2026-10-26",
      "2026-10-27",
      "2026-10-28",
      "2026-10-29",
      "2026-10-30",
      "2026-10-31",
      "2026-11-01",
      "2026-11-02",
      "2026-11-03",
      "2026-11-04",
      "2026-11-05",
      "2026-11-06",
      "2026-11-07",
      "2026-11-08",
      "2026-11-09",
      "2026-11-10",
      "2026-11-11",
      "2026-11-12",
      "2026-11-13",
      "2026-11-14",
      "2026-11-15",
      "2026-11-16",
      "2026-11-17",
      "2026-11-18",
      "2026-11-19",
      "2026-11-20",
      "2026-11-21",
      "2026-11-22",
      "2026-11-23",
      "2026-11-24",
      "2026-11-25",
      "2026-11-26",
      "2026-11-27",
      "2026-11-28",
      "2026-11-29",
      "2026-11-30",
      "2026-12-01",
      "2026-12-02",
      "2026-12-03",
      "2026-12-04",
      "2026-12-05",
      "2026-12-06",
      "2026-12-07",
      "2026-12-08",
      "2026-12-09",
      "2026-12-10",
      "2026-12-11",
      "2026-12-12",
      "2026-12-13",
      "2026-12-14",
      "2026-12-15",
      "2026-12-16",
      "2026-12-17",
      "2026-12-18",
      "2026-12-19",
      "2026-12-20",
      "2026-12-21",
      "2026-12-22",
      "2026-12-23",
      "2026-12-24",
      "2026-12-25",
      "2026-12-26",
      "2026-12-27",
      "2026-12-28",
      "2026-12-29",
      "2026-12-30",
      "2026-12-31",
      "2027-01-01",
      "2027-01-02",
      "2027-01-03",
      "2027-01-04",
      "2027-01-05",
      "2027-01-06",
      "2027-01-07",
      "2027-01-08",
      "2027-01-09",
      "2027-01-10",
      "2027-01-11",
      "2027-01-12",
      "2027-01-13",
      "2027-01-14",
      "2027-01-15",
      "2027-01-16",
      "2027-01-17",
      "2027-01-18",
      "2027-01-19",
      "2027-01-20",
      "2027-01-21",
      "2027-01-22",
      "2027-01-23",
      "2027-01-24",
      "2027-01-25",
      "2027-01-26",
      "2027-01-27",
      "2027-01-28",
      "2027-01-29",
      "2027-01-30",
      "2027-01-31",
      "2027-02-01",
      "2027-02-02",
      "2027-02-03",
      "2027-02-04",
      "2027-02-05",
      "2027-02-06",
      "2027-02-07",
      "2027-02-08",
      "2027-02-09",
      "2027-02-10",
      "2027-02-11",
      "2027-02-12",
      "2027-02-13",
      "2027-02-14",
      "2027-02-15",
      "2027-02-16",
      "2027-02-17",
      "2027-02-18",
      "2027-02-19",
      "2027-02-20",
      "2027-02-21",
      "2027-02-22",
      "2027-02-23",
      "2027-02-24",
      "2027-02-25",
      "2027-02-26",
      "2027-02-27",
      "2027-02-28",
      "2027-03-01",
      "2027-03-02",
      "2027-03-03",
      "2027-03-04",
      "2027-03-05",
      "2027-03-06",
      "2027-03-07",
      "2027-03-08",
      "2027-03-09",
      "2027-03-10",
      "2027-03-11",
      "2027-03-12",
      "2027-03-13",
      "2027-03-14",
      "2027-03-15",
      "2027-03-16",
      "2027-03-17",
      "2027-03-18",
      "2027-03-19",
      "2027-03-20",
      "2027-03-21",
      "2027-03-22",
      "2027-03-23",
      "2027-03-24",
      "2027-03-25",
      "2027-03-26",
      "2027-03-27",
      "2027-03-28",
      "2027-03-29",
      "2027-03-30",
      "2027-03-31",
      "2027-04-01",
      "2027-04-02",
      "2027-04-03",
      "2027-04-04",
      "2027-04-05",
      "2027-04-06",
      "2027-04-07",
      "2027-04-08",
      "2027-04-09",
      "2027-04-10",
      "2027-04-11",
      "2027-04-12",
      "2027-04-13",
      "2027-04-14",
      "2027-04-15",
      "2027-04-16",
      "2027-04-17",
      "2027-04-18",
      "2027-04-19",
      "2027-04-20",
      "2027-04-21",
      "2027-04-22",
      "2027-04-23",
      "2027-04-24",
      "2027-04-25",
      "2027-04-26",
      "2027-04-27",
      "2027-04-28",
      "2027-04-29",
      "2027-04-30",
      "2027-05-01",
      "2027-05-02",
      "2027-05-03",
      "2027-05-04",
      "2027-05-05",
      "2027-05-06",
      "2027-05-07",
      "2027-05-08",
      "2027-05-09",
      "2027-05-10",
      "2027-05-11",
      "2027-05-12",
      "2027-05-13",
      "2027-05-14",
      "2027-05-15",
      "2027-05-16",
      "2027-05-17",
      "2027-05-18",
      "2027-05-19",
      "2027-05-20",
      "2027-05-21",
      "2027-05-22",
      "2027-05-23",
      "2027-05-24",
      "2027-05-25",
      "2027-05-26",
      "2027-05-27",
      "2027-05-28",
      "2027-05-29",
      "2027-05-30",
      "2027-05-31",
      "2027-06-01",
      "2027-06-02",
      "2027-06-03",
      "2027-06-04",
      "2027-06-05",
      "2027-06-06",
      "2027-06-07",
      "2027-06-08",
      "2027-06-09",
      "2027-06-10",
      "2027-06-11",
      "2027-06-12",
      "2027-06-13",
      "2027-06-14",
      "2027-06-15",
      "2027-06-16",
      "2027-06-17",
      "2027-06-18",
      "2027-06-19",
      "2027-06-20",
      "2027-06-21",
      "2027-06-22",
      "2027-06-23",
      "2027-06-24",
      "2027-06-25",
      "2027-06-26",
      "2027-06-27",
      "2027-06-28",
      "2027-06-29",
      "2027-06-30",
      "2027-07-01",
      "2027-07-02",
      "2027-07-03",
      "2027-07-04",
      "2027-07-05",
      "2027-07-06",
      "2027-07-07",
      "2027-07-08",
      "2027-07-09",
      "2027-07-10",
      "2027-07-11",
      "2027-07-12",
      "2027-07-13",
      "2027-07-14",
      "2027-07-15",
      "2027-07-16",
      "2027-07-17",
      "2027-07-18",
      "2027-07-19",
      "2027-07-20",
      "2027-07-21",
      "2027-07-22",
      "2027-07-23",
      "2027-07-24",
      "2027-07-25",
      "2027-07-26",
      "2027-07-27",
      "2027-07-28",
      "2027-07-29",
      "2027-07-30",
      "2027-07-31",
      "2027-08-01",
      "2027-08-02",
      "2027-08-03",
      "2027-08-04",
      "2027-08-05",
      "2027-08-06",
      "2027-08-07",
      "2027-08-08",
      "2027-08-09",
      "2027-08-10",
      "2027-08-11",
      "2027-08-12",
      "2027-08-13",
      "2027-08-14",
      "2027-08-15",
      "2027-08-16",
      "2027-08-17",
      "2027-08-18",
      "2027-08-19",
      "2027-08-20",
      "2027-08-21",
      "2027-08-22",
      "2027-08-23",
      "2027-08-24",
      "2027-08-25",
      "2027-08-26",
      "2027-08-27",
      "2027-08-28",
      "2027-08-29",
      "2027-08-30",
      "2027-08-31",
      "2027-09-01",
      "2027-09-02",
      "2027-09-03",
      "2027-09-04",
      "2027-09-05",
      "2027-09-06",
      "2027-09-07",
      "2027-09-08",
      "2027-09-09",
      "2027-09-10",
      "2027-09-11",
      "2027-09-12",
      "2027-09-13",
      "2027-09-14",
      "2027-09-15",
      "2027-09-16",
      "2027-09-17",
      "2027-09-18",
      "2027-09-19",
      "2027-09-20",
      "2027-09-21",
      "2027-09-22",
      "2027-09-23",
      "2027-09-24",
      "2027-09-25",
      "2027-09-26",
      "2027-09-27",
      "2027-09-28",
      "2027-09-29",
      "2027-09-30",
      "2027-10-01",
      "2027-10-02",
      "2027-10-03",
      "2027-10-04",
      "2027-10-05",
      "2027-10-06",
      "2027-10-07",
      "2027-10-08",
      "2027-10-09",
      "2027-10-10",
      "2027-10-11",
      "2027-10-12",
      "2027-10-13",
      "2027-10-14",
      "2027-10-15",
      "2027-10-16",
      "2027-10-17",
      "2027-10-18",
      "2027-10-19",
      "2027-10-20",
      "2027-10-21",
      "2027-10-22",
      "2027-10-23",
      "2027-10-24",
      "2027-10-25",
      "2027-10-26",
      "2027-10-27",
      "2027-10-28",
      "2027-10-29",
      "2027-10-30",
      "2027-10-31",
      "2027-11-01",
      "2027-11-02",
      "2027-11-03",
      "2027-11-04",
      "2027-11-05",
      "2027-11-06",
      "2027-11-07",
      "2027-11-08",
      "2027-11-09",
      "2027-11-10",
      "2027-11-11",
      "2027-11-12",
      "2027-11-13",
      "2027-11-14",
      "2027-11-15",
      "2027-11-16",
      "2027-11-17",
      "2027-11-18",
      "2027-11-19",
      "2027-11-20",
      "2027-11-21",
      "2027-11-22",
      "2027-11-23",
      "2027-11-24",
      "2027-11-25",
      "2027-11-26",
      "2027-11-27",
      "2027-11-28",
      "2027-11-29",
      "2027-11-30",
      "2027-12-01",
      "2027-12-02",
      "2027-12-03",
      "2027-12-04",
      "2027-12-05",
      "2027-12-06",
      "2027-12-07",
      "2027-12-08",
      "2027-12-09",
      "2027-12-10",
      "2027-12-11",
      "2027-12-12",
      "2027-12-13",
      "2027-12-14",
      "2027-12-15",
      "2027-12-16",
      "2027-12-17",
      "2027-12-18",
      "2027-12-19",
      "2027-12-20",
      "2027-12-21",
      "2027-12-22",
      "2027-12-23",
      "2027-12-24",
      "2027-12-25",
      "2027-12-26",
      "2027-12-27",
      "2027-12-28",
      "2027-12-29",
      "2027-12-30",
      "2027-12-31",
      "2028-01-01",
      "2028-01-02",
      "2028-01-03",
      "2028-01-04",
      "2028-01-05",
      "2028-01-06",
      "2028-01-07",
      "2028-01-08",
      "2028-01-09",
      "2028-01-10",
      "2028-01-11",
      "2028-01-12",
      "2028-01-13",
      "2028-01-14",
      "2028-01-15",
    ],
    informationsHebergementCollectif: {
      hebergementCollectifType: {
        elementReferenceType: "HebergementCollectifType",
        id: 2644,
        libelleFr: "Village de vacances",
        ordre: 18,
        description:
          "Ensemble d'hébergements, classé confort ou grand confort par la Préfecture, \r\n- faisant l'objet d'une exploitation globale à caractère commercial ou non, \r\n- destiné à assurer des séjours de vacances et de loisirs, \r\n- selon un prix forfaitaire comportant la fourniture de repas ou de moyens individuels pour les préparer,\r\n- avec l'usage d'équipements collectifs, permettant des activités de loisirs sportifs et culturels.\r\n\r\nIl existe aussi un agrément Village de vacances délivré par le Secrétariat d'Etat au Tourisme.",
      },
      classementPrefectoral: {
        elementReferenceType: "HebergementCollectifClassementPrefectoral",
        id: 2660,
        libelleFr: "3 étoiles",
        ordre: 3,
        critereDeprecie: {
          code: "31345-distinctions",
          message:
            "#31345 - réorganisation des distinctions : le critère existe toujours mais a été migré sous forme de distinction",
          dateAlerte: "2025-11-10",
          dateDesactivation: "2026-11-24",
          critereSubstitutionId: 7682,
          champSubstitution: "distinctions[].qualification",
          url: "https://dev.apidae-tourisme.com/reorganisation-des-distinctions/",
        },
      },
      chaineEtLabel: {
        elementReferenceType: "HebergementCollectifChaineEtLabel",
        id: 2695,
        libelleFr: "Belambra",
        ordre: 15,
        description: "www.belambra.fr",
        familleCritere: {
          elementReferenceType: "FamilleCritere",
          id: 6602,
          libelleFr: "Chaînes",
          ordre: 26,
          description:
            'permet de regrouper les critères dans "Chaines et Labels" de HCO',
        },
        critereDeprecie: {
          code: "31345-distinctions",
          message:
            "#31345 - réorganisation des distinctions : le critère existe toujours mais a été migré sous forme de distinction",
          dateAlerte: "2025-11-10",
          dateDesactivation: "2026-11-24",
          critereSubstitutionId: 7732,
          champSubstitution: "distinctions[].nom",
          url: "https://dev.apidae-tourisme.com/reorganisation-des-distinctions/",
        },
      },
      labels: [
        {
          elementReferenceType: "HebergementCollectifLabel",
          id: 3611,
          libelleFr: "Bébé câlin",
          ordre: 17,
          description:
            "Vous trouverez dans ces hébergements : Un lit bébé (en bois ou lit pliant) avec matelas et housse de protection, une chaise haute, une petite baignoire ou un anneau de bain, un matelas à langer ou une table à langer, un mixeur, un chauffe biberon ou un micro-ondes, des jeux d'enfants : livres, cubes... un pot ...",
          typeLabel: {
            elementReferenceType: "HebergementCollectifTypeLabel",
            id: 2719,
            libelleFr: "Gîtes de France",
            ordre: 3,
            critereDeprecie: {
              code: "31345-distinctions",
              message:
                "#31345 - réorganisation des distinctions : le critère existe toujours mais a été migré sous forme de distinction",
              dateAlerte: "2025-11-10",
              dateDesactivation: "2026-11-24",
              critereSubstitutionId: 7572,
              champSubstitution: "distinctions[].nom",
              url: "https://dev.apidae-tourisme.com/reorganisation-des-distinctions/",
            },
          },
          critereDeprecie: {
            code: "31345-distinctions",
            message:
              "#31345 - réorganisation des distinctions : le critère existe toujours mais a été migré sous forme de distinction",
            dateAlerte: "2025-11-10",
            dateDesactivation: "2026-11-24",
            critereSubstitutionId: 7620,
            champSubstitution: "distinctions[].qualification",
            url: "https://dev.apidae-tourisme.com/reorganisation-des-distinctions/",
          },
        },
      ],
      typesHebergement: [
        {
          elementReferenceType: "HebergementCollectifTypeHebergement",
          id: 1317,
          libelleFr: "Appartement",
          ordre: 4,
        },
        {
          elementReferenceType: "HebergementCollectifTypeHebergement",
          id: 1324,
          libelleFr: "Chambres",
          ordre: 11,
        },
        {
          elementReferenceType: "HebergementCollectifTypeHebergement",
          id: 1326,
          libelleFr: "Emplacements",
          ordre: 15,
        },
        {
          elementReferenceType: "HebergementCollectifTypeHebergement",
          id: 1328,
          libelleFr: "Salles",
          ordre: 31,
        },
        {
          elementReferenceType: "HebergementCollectifTypeHebergement",
          id: 1329,
          libelleFr: "Personnes",
          ordre: 30,
        },
        {
          elementReferenceType: "HebergementCollectifTypeHebergement",
          id: 1333,
          libelleFr: "Dortoir",
          ordre: 12,
        },
        {
          elementReferenceType: "HebergementCollectifTypeHebergement",
          id: 1349,
          libelleFr: "Suite",
          ordre: 32,
        },
        {
          elementReferenceType: "HebergementCollectifTypeHebergement",
          id: 1351,
          libelleFr: "Lit Simple",
          ordre: 27,
        },
        {
          elementReferenceType: "HebergementCollectifTypeHebergement",
          id: 1360,
          libelleFr: "Lit double",
          ordre: 26,
        },
        {
          elementReferenceType: "HebergementCollectifTypeHebergement",
          id: 1366,
          libelleFr: "Chambre pour personnes à mobilité réduite",
          ordre: 10,
        },
      ],
      typesHabitation: [
        {
          elementReferenceType: "TypeHabitation",
          id: 1608,
          libelleFr: "Bungalows indépendants",
          ordre: 5,
          description:
            "Habitation basse, généralement en bois, entourée de vérandas.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5403,
            libelleFr: "Type de logement",
            ordre: 165,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1610,
          libelleFr: "Châteaux et demeures de prestige",
          ordre: 11,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5401,
            libelleFr: "Type de bâtiment",
            ordre: 163,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1612,
          libelleFr: "Habitations mitoyennes",
          ordre: 19,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5403,
            libelleFr: "Type de logement",
            ordre: 165,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1613,
          libelleFr: "Appartement",
          ordre: 3,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5403,
            libelleFr: "Type de logement",
            ordre: 165,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1614,
          libelleFr: "Chalet",
          ordre: 6,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5401,
            libelleFr: "Type de bâtiment",
            ordre: 163,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1616,
          libelleFr: "Maison",
          ordre: 25,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5401,
            libelleFr: "Type de bâtiment",
            ordre: 163,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1618,
          libelleFr: "Chambres",
          ordre: 9,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5403,
            libelleFr: "Type de logement",
            ordre: 165,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1619,
          libelleFr: "Construction ancienne",
          ordre: 13,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5402,
            libelleFr: "Type de construction",
            ordre: 164,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1625,
          libelleFr: "Construction récente",
          ordre: 16,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5402,
            libelleFr: "Type de construction",
            ordre: 164,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1627,
          libelleFr: "Couvent",
          ordre: 17,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5401,
            libelleFr: "Type de bâtiment",
            ordre: 163,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1632,
          libelleFr: "Immeuble/Résidence",
          ordre: 20,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5401,
            libelleFr: "Type de bâtiment",
            ordre: 163,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1633,
          libelleFr: "Logement dans chalet",
          ordre: 21,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5403,
            libelleFr: "Type de logement",
            ordre: 165,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1635,
          libelleFr: "Logement dans maison",
          ordre: 22,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5403,
            libelleFr: "Type de logement",
            ordre: 165,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1639,
          libelleFr: "Meublé indépendant",
          ordre: 31,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5403,
            libelleFr: "Type de logement",
            ordre: 165,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1651,
          libelleFr: "Studio cabine",
          ordre: 33,
          description:
            "Un studio cabine comporte une pièce qui fait à la fois office de séjour, cuisine, avec une salle de bains séparée, et des wc séparés eux aussi ou installés dans la salle de bains + un recoin ou une partie indépendante permettant d'accueillir un lit superposé.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5403,
            libelleFr: "Type de logement",
            ordre: 165,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1653,
          libelleFr: "Duplex",
          ordre: 10,
          description:
            "Concerne les studios, les appartements et les maisons sur 2 niveaux réunis par un escalier intérieur.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5403,
            libelleFr: "Type de logement",
            ordre: 165,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1681,
          libelleFr: "Studio",
          ordre: 32,
          description:
            "Un studio comporte une pièce qui fait à la fois office de séjour, chambre, cuisine, avec une salle de bains séparée, et des wc séparés eux aussi ou installés dans la salle de bains.",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5403,
            libelleFr: "Type de logement",
            ordre: 165,
          },
        },
        {
          elementReferenceType: "TypeHabitation",
          id: 1683,
          libelleFr: "Cabine",
          ordre: 8,
          description:
            "Chambre qui ne respecte pas la surface minimale pour le classement préfectoral (un espace qui accueille un lit, souvent superposé)",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 5403,
            libelleFr: "Type de logement",
            ordre: 165,
          },
        },
      ],
      agrements: [
        {
          type: {
            elementReferenceType: "HebergementCollectifAgrementType",
            id: 2676,
            libelleFr: "Ministère du Tourisme",
            ordre: 5,
          },
          numero: "Schtroumpfs",
        },
      ],
      capacite: {
        capaciteTotale: 58,
        capaciteTotaleReelle: 15,
        capaciteTotaleClassee: 57,
        capaciteTotaleJeunesseSport: 12,
        capaciteTotaleEducationNationale: 18,
        capaciteCommissionSecurite: 20,
        nombreChambres: 24,
        nombreAppartements: 5,
        nombreVillas: 3,
        nombreDortoirs: 7,
        nombreDortoirsMoyens: 5,
        nombreDortoirsGrands: 4,
        nombreHebergementsMobiliteReduite: 6,
        nombreHebergementsUnePersonne: 5,
        nombreHebergementsDeuxPersonnes: 4,
        nombreHebergementsTroisPersonnes: 3,
        nombreHebergementsQuatrePersonnes: 2,
        nombreHebergementsCinqPersonnes: 1,
        nombreHebergementsSixPersonnes: 7,
        nombreHebergementsPlusSixPersonnes: 9,
        nombreHebergementsClasses: 12,
        nombreClassesEducationNationale: 19,
        descriptifChambres: {
          libelleFr: "Descriptif des chambres",
        },
      },
    },
    formatVersion: "v002",
    expiration: {},
    informationsPrestataireActivites: {
      prestataireActivites: false,
    },
    enquete: {
      enquetes: [
        {
          identifiant: 2972820,
          annee: 2023,
          retour: true,
          titre: {
            elementReferenceType: "EnqueteTitre",
            id: 3934,
            libelleFr: "Enquête annuelle",
            ordre: 1,
          },
        },
      ],
    },
    distinctions: [
      {
        id: 244889,
        nom: {
          elementReferenceType: "DistinctionNom",
          id: 7732,
          libelleFr: "Belambra",
          ordre: 360,
          description: "www.belambra.fr",
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 6602,
            libelleFr: "Chaînes",
            ordre: 26,
            description:
              'permet de regrouper les critères dans "Chaines et Labels" de HCO',
          },
          categorie: {
            elementReferenceType: "DistinctionCategorie",
            id: 7559,
            libelleFr: "Chaînes",
            ordre: 5,
          },
        },
        locked: false,
      },
      {
        id: 244888,
        nom: {
          elementReferenceType: "DistinctionNom",
          id: 7566,
          libelleFr: "Atout France",
          ordre: 349,
          categorie: {
            elementReferenceType: "DistinctionCategorie",
            id: 7561,
            libelleFr: "Classements",
            ordre: 6,
          },
        },
        qualification: {
          elementReferenceType: "DistinctionQualification",
          id: 7682,
          libelleFr: "3 étoiles",
          ordre: 65,
        },
        locked: false,
      },
      {
        id: 244887,
        nom: {
          elementReferenceType: "DistinctionNom",
          id: 8397,
          libelleFr: "Famille plus",
          ordre: 504,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 113,
            libelleFr: "National",
            ordre: 98,
          },
          categorie: {
            elementReferenceType: "DistinctionCategorie",
            id: 7564,
            libelleFr: "Labels",
            ordre: 9,
          },
        },
        locked: false,
      },
      {
        id: 244886,
        nom: {
          elementReferenceType: "DistinctionNom",
          id: 7572,
          libelleFr: "Gîtes de France",
          ordre: 556,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 29,
            libelleFr: "Label",
            ordre: 77,
          },
          categorie: {
            elementReferenceType: "DistinctionCategorie",
            id: 7564,
            libelleFr: "Labels",
            ordre: 9,
          },
        },
        qualification: {
          elementReferenceType: "DistinctionQualification",
          id: 7620,
          libelleFr: "Bébé câlin",
          ordre: 109,
        },
        locked: false,
      },
      {
        id: 244882,
        nom: {
          elementReferenceType: "DistinctionNom",
          id: 7715,
          libelleFr: "Marque Tourisme et Handicap - déficience auditive",
          ordre: 800,
          description: "Critère spécifique de la marque, non-déclaratif.",
          categorie: {
            elementReferenceType: "DistinctionCategorie",
            id: 7564,
            libelleFr: "Labels",
            ordre: 9,
          },
        },
        locked: false,
      },
      {
        id: 244883,
        nom: {
          elementReferenceType: "DistinctionNom",
          id: 7716,
          libelleFr: "Marque Tourisme et Handicap - déficience mentale",
          ordre: 801,
          description: "Critère spécifique de la marque, non-déclaratif.",
          categorie: {
            elementReferenceType: "DistinctionCategorie",
            id: 7564,
            libelleFr: "Labels",
            ordre: 9,
          },
        },
        locked: false,
      },
      {
        id: 244884,
        nom: {
          elementReferenceType: "DistinctionNom",
          id: 7717,
          libelleFr: "Marque Tourisme et Handicap - déficience motrice",
          ordre: 802,
          description: "Critère spécifique de la marque, non-déclaratif.",
          categorie: {
            elementReferenceType: "DistinctionCategorie",
            id: 7564,
            libelleFr: "Labels",
            ordre: 9,
          },
        },
        locked: false,
      },
      {
        id: 244885,
        nom: {
          elementReferenceType: "DistinctionNom",
          id: 7718,
          libelleFr: "Marque Tourisme et Handicap - déficience visuelle",
          ordre: 803,
          description: "Critère spécifique de marque, non-déclaratif.",
          categorie: {
            elementReferenceType: "DistinctionCategorie",
            id: 7564,
            libelleFr: "Labels",
            ordre: 9,
          },
        },
        locked: false,
      },
      {
        id: 244890,
        nom: {
          elementReferenceType: "DistinctionNom",
          id: 8528,
          libelleFr: "Valeurs Parc Naturel Régional",
          ordre: 1006,
          familleCritere: {
            elementReferenceType: "FamilleCritere",
            id: 113,
            libelleFr: "National",
            ordre: 98,
          },
          categorie: {
            elementReferenceType: "DistinctionCategorie",
            id: 7565,
            libelleFr: "Marques",
            ordre: 10,
          },
        },
        locked: false,
      },
    ],
    donneesPrivees: [
      {
        nomTechnique: "1157_Vg_testDescriptifPrive-1",
        libelleFr: "VG_Test Descriptif privé-1",
        ordre: 1,
        descriptif: {
          libelleFr: "blabla",
        },
      },
    ],
    aspects: [
      {
        aspect: "HIVER",
        champsAspect: [
          "presentation.descriptifCourt",
          "presentation.descriptifDetaille",
        ],
        presentation: {
          descriptifCourt: {
            libelleFr: "DC HIVER FR",
          },
          descriptifDetaille: {
            libelleFr: "DD HIVER FR",
          },
        },
      },
      {
        aspect: "ETE",
        champsAspect: ["informations.moyensCommunication"],
        informations: {
          moyensCommunication: [
            {
              identifiant: 35557050,
              type: {
                elementReferenceType: "MoyenCommunicationType",
                id: 201,
                libelleFr: "Téléphone",
                ordre: 1,
              },
              coordonnees: {
                fr: "04 73 29 49 95",
              },
              observation: {
                libelleFr: "Complément Tel",
              },
            },
          ],
        },
      },
    ],
    metadonnees: [
      {
        noeudId: "test-pg",
        contenus: [
          {
            cible: "membre_1157",
            metadonnee: {
              "info Membre":
                "Ceci est une information à destination du membre 1157 (Apidae)",
            },
          },
          {
            cible: "general",
            metadonnee: {
              bms: "bms",
              product_id: 1234,
              supplier_id: 5678,
            },
          },
        ],
      },
    ],
  },
  // Mock pour tester la section Capacités — variant HOTELLERIE
  {
    type: "HOTELLERIE",
    id: 900001,
    nom: { libelleFr: "Hôtel des Cimes (mock capacités)" },
    identifier: "sitraHOT900001",
    presentation: {
      descriptifCourt: {
        libelleFr:
          "Hôtel de charme pour tester l'affichage des capacités (hotellerie).",
      },
    },
    capacites: {
      classees: { personnes: 80, unitesHebergement: 42 },
      handicap: { pmrUnitesHebergement: 3 },
      hotellerie: {
        nombreChambresSimples: 8,
        nombreChambresDoubles: 28,
        nombreSuites: 6,
      },
    },
    localisation: {
      adresse: {
        adresse1: "12 place de la Gare",
        codePostal: "63000",
        commune: {
          id: 1,
          code: "63113",
          nom: "Clermont-Ferrand",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
            ordre: 78,
          },
          codePostal: "63000",
        },
      },
      geolocalisation: {
        valide: true,
        geoJson: { type: "Point", coordinates: [3.077, 45.777] },
      },
    },
  },
  // Mock pour tester la section Capacités — variant HOTELLERIE_PLEIN_AIR
  {
    type: "HOTELLERIE_PLEIN_AIR",
    id: 900002,
    nom: { libelleFr: "Camping du Lac (mock capacités)" },
    identifier: "sitraHPA900002",
    presentation: {
      descriptifCourt: {
        libelleFr: "Camping pour tester l'affichage des capacités (plein air).",
      },
    },
    capacites: {
      classees: { personnes: 200, unitesHebergement: 85 },
      hotelleriePleinAir: {
        superficie: 45000,
      },
    },
    localisation: {
      adresse: {
        adresse1: "Route du Lac",
        codePostal: "43200",
        commune: {
          id: 2,
          code: "43000",
          nom: "Le Puy-en-Velay",
          pays: {
            elementReferenceType: "Pays",
            id: 532,
            libelleFr: "France",
            ordre: 78,
          },
          codePostal: "43200",
        },
      },
      geolocalisation: {
        valide: true,
        geoJson: { type: "Point", coordinates: [3.95, 45.04] },
      },
    },
  },
];

/**
 * CSS de démo : même chaîne que `visualCustomization.customCSS`, injectée dans chaque shadow
 * pertinent. Les règles sans correspondance dans un shadow donné sont ignorées.
 * À désactiver (retirer `customCSS` du mock) une fois la vérif visuelle faite.
 */
export const MOCK_DEBUG_VISUAL_CUSTOM_CSS = `
  /* Racine widget (list, map, …) */
  .widget-container {
    box-shadow: inset 0 0 0 2px rgba(194, 24, 91, 0.4);
  }

  apidae-widget-layout {
    outline: 2px solid #e91e63;
    outline-offset: 1px;
  }

  apidae-widget-header {
    outline: 2px dashed #9c27b0;
  }

  apidae-filter-panel {
    outline: 2px solid #3f51b5;
  }

  apidae-detail-view {
    outline: 2px solid #f44336;
  }

  apidae-list-item-card {
    outline: 2px solid #4caf50;
  }

  apidae-date-picker {
    outline: 1px dashed #2196f3;
  }

  apidae-combobox {
    outline: 1px dashed #00bcd4;
  }

  apidae-button {
    outline: 1px solid #ff9800;
  }

  apidae-icon {
    outline: 1px dotted #795548;
  }

  apidae-open-system-widget,
  apidae-elloha-widget {
    outline: 2px solid #607d8b;
  }

  apidae-detail-view-information-block,
  apidae-detail-view-information-block-listing,
  apidae-detail-view-information-block-listing-w-columns {
    outline: 1px solid rgba(255, 152, 0, 0.7);
  }

  /* Shadow WidgetHeader */
  .widget-header {
    border-bottom: 3px solid rgba(103, 58, 183, 0.55);
  }

  /* Shadow FilterPanel */
  .filter-header {
    background: rgba(63, 81, 181, 0.08);
  }

  /* Shadow DatePicker */
  .date-picker {
    background: rgba(33, 150, 243, 0.06);
  }

  /* Shadow Combobox */
  .combobox-trigger {
    box-shadow: inset 0 -2px 0 0 #00bcd4;
  }

  /* Shadow ListItemCard */
  .list-card-title {
    background: rgba(76, 175, 80, 0.12);
  }

  /* Shadow DetailView */
  .detail-overlay {
    box-shadow: inset 0 0 0 3px rgba(244, 67, 54, 0.3);
  }

  .detail-container {
    border-left: 4px solid #ffc107;
  }

  /* Blocs fiche */
  .information-block {
    border-left: 4px solid #ff9800;
  }

  .information-block-listing {
    border-left: 4px solid #8bc34a;
  }

  .information-block-listing-header,
  .information-block-header {
    text-decoration: underline;
    text-decoration-color: rgba(255, 193, 7, 0.65);
    text-underline-offset: 3px;
  }

  .results-badge {
    background: rgba(76, 175, 80, 0.12) !important;
  }
`.trim();

/**
 * Configuration de widget mock pour les tests
 */
export const MOCK_WIDGET_CONFIG: WidgetConfiguration = {
  name: "Widget de démonstration",
  templateType: WidgetTemplateType.LIST,
  selections: [
    { id: "1", label: "Sélection 1", count: 10 },
    { id: "2", label: "Sélection 2", count: 5 },
  ],
  targetUrl: "https://example.com",
  projetId: "12345",
  visualCustomization: {
    colors: {
      primary: "#0094DB", //"#0078d4",
      secondary: "#F2F5F9", //"#106ebe",
    },
    typography: {
      titleFont: WidgetFont.INTER,
      titleColor: "#2F2F2F", //"#333333"
      // titleSize: 20, //24 // en px // champ non modifiable dans le BO actuellement
      textFont: WidgetFont.INTER, //WidgetFont.OPEN_SANS
      textColor: "#2F2F2F", //"#666666"
      // textSize: 16, // en px // champ non modifiable dans le BO actuellement
    },
    // customCSS: MOCK_DEBUG_VISUAL_CUSTOM_CSS,
  },
  // Thème sombre
  // visualCustomization: {
  //   colors: {
  //     primary: "#0094DB", //"#0078d4",
  //     secondary: "#0f0101", //"#106ebe",
  //   },
  //   typography: {
  //     titleFont: WidgetFont.INTER,
  //     titleColor: "#bc1616", //"#333333"
  //     // titleSize: 20, //24 // en px // champ non modifiable dans le BO actuellement
  //     textFont: WidgetFont.INTER, //WidgetFont.OPEN_SANS
  //     textColor: "#f0e9e9", //"#666666"
  //     // textSize: 16, // en px // champ non modifiable dans le BO actuellement
  //   },
  // },
  contentCustomization: {
    language: WidgetLanguage.FR,
    excludedOfferIds: [],
    displayedFields: [
      { id: DisplayedFieldId.INFOS_ITINERAIRES },
      { id: DisplayedFieldId.ANIMAUX_ACCEPTES },
      { id: DisplayedFieldId.LOCATION_SALLE },
      { id: DisplayedFieldId.PUBLIC_NIVEAU },
      { id: DisplayedFieldId.INFORMATIONS_RESERVATION },
      { id: DisplayedFieldId.IMAGES },
      { id: DisplayedFieldId.DESCRIPTIF_COURT },
      { id: DisplayedFieldId.DESCRIPTIF_DETAILLE },
      {
        id: DisplayedFieldId.DISPONIBILITES_ELLOHA,
        data: { idBookingEngine: "7617ac8b-2e82-49d9-92a5-8a28771c90d4" }, // correspond à https://base.apidae-tourisme.com/diffuser/dev-tools/metadonnees/objet-touristique/5824357 <-> https://www.bruniquel.fr/tourisme/campings/#widget-details-offre-5824357
      },
      {
        id: DisplayedFieldId.DISPONIBILITES_OPENSYSTEM,
        data: { idPanier: "ueu7ubk", idIntegration: 1068 }, // correspond à https://base.apidae-tourisme.com/diffuser/dev-tools/metadonnees/objet-touristique/5801668 <-> https://trailencoterotie.fr/hebergements/#widget-details-offre-5801668
      },
      {
        id: DisplayedFieldId.DESCRIPTIFS_PRIVES,
        data: {
          nomsTechniques: [
            "team_apidae_adresse",
            "1157_Vg_testDescriptifPrive-1",
            "1157_TestDescriptifPrive",
          ],
        }, // correspond à https://base.apidae-tourisme.com/diffuser/dev-tools/metadonnees/objet-touristique/5801668 <-> https://trailencoterotie.fr/hebergements/#widget-details-offre-5801668
      },
      { id: DisplayedFieldId.PRESTATAIRE_ACTIVITE },
      { id: DisplayedFieldId.OBJETS_LIES },
      { id: DisplayedFieldId.DESCRIPTIFS_THEMATISES },
      { id: DisplayedFieldId.CAPACITES },
      { id: DisplayedFieldId.ACCESSIBILITE },
      { id: DisplayedFieldId.LABEL_DISTINCTION },
      { id: DisplayedFieldId.OUVERTURE },
      { id: DisplayedFieldId.EQUIPEMENTS },
      { id: DisplayedFieldId.MOYEN_PAIEMENT },
      { id: DisplayedFieldId.TARIFS },
      { id: DisplayedFieldId.MOYENS_COMMUNICATION },
      { id: DisplayedFieldId.MULTIMEDIAS },
    ],
    filterFields: [
      { id: FilterId.TYPES },
      { id: FilterId.COMMUNES },
      { id: FilterId.GRATUITE },
      { id: FilterId.ANIMAUX },
      { id: FilterId.DUREE },
      { id: FilterId.OUVERTURE },
    ],
    displayedFieldsPreview: [
      { id: DisplayedFieldPreviewId.COMMUNE }, //{ id: DisplayedFieldPreviewId.CATEGORIE },
      { id: DisplayedFieldPreviewId.TELEPHONE }, //{ id: DisplayedFieldPreviewId.RESERVATION },
    ],
  },
  sort: {
    option: WidgetSortOption.NOM,
    order: "asc",
  },
  templateSpecificConfig: {
    carousel: {
      nbItemsToShow: 5,
    },
  },
};

/**
 * Filtres mock pour les tests
 * Basé sur les IDs des objets touristiques mock
 * Format aligné avec example_response_filters.json
 */
export const MOCK_WIDGET_FILTERS: Map<FacetId, FacetValue[]> = new Map([
  [
    FacetId.COMMUNE,
    [
      {
        val: "Commune_28739",
        label: "Lyon 2ème (69002)",
        count: 51,
      },
      {
        val: "Commune_28742",
        label: "Lyon 5ème (69005)",
        count: 36,
      },
      {
        val: "Commune_28738",
        label: "Lyon 1er (69001)",
        count: 16,
      },
      {
        val: "Commune_28705",
        label: "Villeurbanne (69100)",
        count: 13,
      },
      {
        val: "Commune_28741",
        label: "Lyon 4ème (69004)",
        count: 12,
      },
      {
        val: "Commune_28565",
        label: "Lyon (69123)",
        count: 10,
      },
      {
        val: "Commune_28745",
        label: "Lyon 8ème (69008)",
        count: 10,
      },
      {
        val: "Commune_28696",
        label: "Vaulx-en-Velin (69120)",
        count: 8,
      },
      {
        val: "Commune_28740",
        label: "Lyon 3ème (69003)",
        count: 8,
      },
      {
        val: "Commune_28583",
        label: "Mornant (69440)",
        count: 6,
      },
    ],
  ],
  [
    FacetId.DUREE_SEANCE,
    [
      {
        val: "MOINS_UNE_HEURE",
        label: "Less than 1 hour",
        count: 1,
      },
      {
        val: "UNE_A_DEUX_HEURES",
        label: "1 to 2 hours",
        count: 1,
      },
    ],
  ],
  [
    FacetId.GRATUIT,
    [
      {
        val: "false",
        label: "No",
        count: 211,
      },
      {
        val: "true",
        label: "Yes",
        count: 63,
      },
    ],
  ],
  [
    FacetId.ANIMAUX,
    [
      {
        val: "NON_DISPONIBLE",
        label: "Not communicated",
        count: 242,
      },
      {
        val: "ACCEPTES",
        label: "Yes",
        count: 19,
      },
      {
        val: "NON_ACCEPTES",
        label: "No",
        count: 13,
      },
    ],
  ],
  [
    FacetId.TYPE_CLIENTELE,
    [
      {
        val: "TypeClientele_593",
        label: "Groups",
        count: 37,
      },
      {
        val: "TypeClientele_513",
        label: "Children",
        count: 33,
      },
      {
        val: "TypeClientele_580",
        label: "Groups only",
        count: 23,
      },
      {
        val: "TypeClientele_596",
        label: "Home school groups",
        count: 12,
      },
      {
        val: "TypeClientele_597",
        label: "Welcome for business/incentive groups",
        count: 11,
      },
      {
        val: "TypeClientele_594",
        label: "Specially for children",
        count: 9,
      },
      {
        val: "TypeClientele_3897",
        label: "Cycle 2: elementary School",
        count: 8,
      },
      {
        val: "TypeClientele_3899",
        label: "Cycle 4: middle School",
        count: 5,
      },
      {
        val: "TypeClientele_5078",
        label: "Cycle 3: elementary school (CM1, CM2)",
        count: 5,
      },
      {
        val: "TypeClientele_5079",
        label: "Cycle 3: college (6th)",
        count: 5,
      },
    ],
  ],
  [
    FacetId.SOUS_TYPE,
    [
      {
        val: "FeteEtManifestationType_1958",
        label: "Cultural",
        count: 117,
      },
      {
        val: "FeteEtManifestationType_1962",
        label: "Commercial event",
        count: 54,
      },
      {
        val: "FeteEtManifestationType_1974",
        label: "Entertainment/recreation",
        count: 34,
      },
      {
        val: "FeteEtManifestationType_1971",
        label: "Sports and leisure",
        count: 2,
      },
      {
        val: "FeteEtManifestationType_1966",
        label: "Nature and relaxation",
        count: 1,
      },
    ],
  ],
]);
